import type { Dict } from '../types';
import { en } from './en';

export const vi: Dict = {
  ...en,

  'common.cancel': 'Hủy',
  'common.save': 'Lưu',
  'common.close': 'Đóng',
  'common.clear': 'Xóa',
  'common.delete': 'Xóa',
  'common.rename': 'Đổi tên',
  'common.edit': 'Sửa',
  'common.preview': 'Xem trước',
  'common.share': 'Chia sẻ',
  'common.search': 'Tìm kiếm',
  'common.searchEllipsis': 'Tìm kiếm…',
  'common.loading': 'Đang tải…',
  'common.all': 'Tất cả',
  'common.none': 'Không có',
  'common.default': 'Mặc định',
  'common.installed': 'đã cài',
  'common.notInstalled': 'chưa cài',
  'common.active': 'đang bật',
  'common.inactive': 'đang tắt',
  'common.offline': 'ngoại tuyến',
  'common.selected': 'đã chọn',
  'common.create': 'Tạo',
  'common.openPreview': 'Mở xem trước',
  'common.exitFullscreen': 'Thoát toàn màn hình',
  'common.fullscreen': 'Toàn màn hình',
  'common.openInNewTab': 'Mở trong tab mới',
  'common.exportPdf': 'Xuất PDF',
  'common.exportZip': 'Tải xuống .zip',
  'common.exportHtml': 'Xuất HTML độc lập',
  'common.exportImage': 'Xuất ảnh',
  'common.justNow': 'vừa xong',
  'common.minutesAgo': '{n} phút trước',
  'common.hoursAgo': '{n} giờ trước',
  'common.daysAgo': '{n} ngày trước',
  'common.weeksAgo': '{n} tuần trước',
  'common.now': 'bây giờ',
  'common.untitled': 'Chưa đặt tên',

  'settings.title': 'Mô hình & nhà cung cấp',
  'settings.subtitle': 'Chọn model Codex mà hệ thống sẽ dùng.',
  'settings.sectionsAria': 'Các mục cài đặt',
  'settings.general': 'Chung',
  'settings.generalHint': 'Ngôn ngữ, giao diện, thông báo và vị trí project.',
  'settings.language': 'Ngôn ngữ',
  'settings.languageHint': 'Chọn ngôn ngữ hiển thị của giao diện.',
  'settings.amrBalance': 'Hạn mức',
  'settings.modeAria': 'Chế độ chạy',
  'settings.protocolAria': 'Giao thức API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Chạy bằng code-agent CLI trên máy này',
  'settings.modeDaemonOffline': 'Daemon chưa chạy',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} đã cài',
  'settings.modeApi': 'Nhà cung cấp API',
  'settings.modeApiMeta': 'API provider',
  'settings.byokNoFileToolsNotice': 'BYOK không đọc, ghi hoặc sửa file project. Dùng CLI local khi cần sửa code.',
  'settings.byokDraftNotice': 'Điền các trường bắt buộc để lưu provider này. Cấu hình hiện tại vẫn được giữ.',
  'settings.codeAgent': 'Codex',
  'settings.codeAgentHint': 'Chọn model OpenAI đang có trong tài khoản Codex này.',
  'settings.rescan': 'Quét lại',
  'settings.rescanTitle': 'Quét lại PATH',
  'settings.rescanRunning': 'Đang quét...',
  'settings.rescanSuccess': 'Quét xong. Có {count}.',
  'settings.rescanFailed': 'Quét lỗi. Kiểm tra daemon rồi thử lại.',
  'settings.test': 'Test',
  'settings.testTitle': 'Gửi prompt nhỏ để kiểm tra kết nối',
  'settings.testRunning': 'Đang test kết nối…',
  'settings.byokReadyToTest': 'Sẵn sàng test',
  'settings.testCancel': 'Hủy test',
  'settings.testRetry': 'Test lại',
  'settings.required': 'bắt buộc',
  'settings.apiSection': 'API',
  'settings.quickFillProvider': 'Điền nhanh provider',
  'settings.providerPreset': 'Preset provider',
  'settings.protocolGroupProtocols': 'Giao thức',
  'settings.protocolGroupGateways': 'Gateway',
  'settings.customProvider': 'Provider tùy chỉnh',
  'settings.apiKey': 'API key',
  'settings.apiKeyGetLink': 'Lấy key',
  'settings.showKey': 'Hiện key',
  'settings.hideKey': 'Ẩn key',
  'settings.show': 'Hiện',
  'settings.hide': 'Ẩn',
  'settings.model': 'Mô hình',
  'settings.fetchModels': 'Lấy danh sách model',
  'settings.fetchModelsTitle': 'Lấy model có sẵn từ provider này',
  'settings.fetchModelsRunning': 'Đang lấy model…',
  'settings.fetchModelsMissingFields': 'Điền {fields} để lấy model.',
  'settings.fetchModelsInvalidBaseUrl': 'Nhập Base URL hợp lệ để lấy model.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI dùng deployment name nên không lấy model tự động ở đây.',
  'settings.fetchModelsUnsupportedOllama': 'Ollama chưa hỗ trợ lấy danh sách model tự động. Chọn hoặc nhập model.',
  'settings.fetchModelsSuccess': 'Đã lấy {count} model.',
  'settings.fetchModelsEmpty': 'Provider không trả về model text phù hợp.',
  'settings.fetchModelsUnsupported': 'Giao thức này không hỗ trợ lấy model tự động.',
  'settings.fetchModelsFailed': 'Không lấy được model: {detail}',
  'settings.suggestedModelsHint': 'Đây là model gợi ý cho giao thức này. Provider của bạn có thể hỗ trợ model khác.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Dùng URL http:// hoặc https:// public.',
  'settings.baseUrlCustomize': 'Tùy chỉnh URL',
  'settings.baseUrlDefaultHint': 'Chỉ đổi nếu bạn dùng proxy hoặc gateway tương thích.',
  'settings.apiVersion': 'API version',
  'settings.apiHint': 'Lưu cục bộ trên máy này.',
  'settings.localCli': 'Codex',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'chưa chọn agent',
  'settings.agentModelHead': 'Model cho:',
  'settings.modelPicker': 'Mô hình',
  'settings.modelSourceLive': 'Đồng bộ từ CLI',
  'settings.modelUsesCliDefault': 'Mặc định của CLI',
  'settings.modelSourceFallback': 'Danh sách có sẵn',
  'settings.reasoningPicker': 'Mức reasoning',
  'settings.serviceTierPicker': 'Service tier',
  'settings.modelPickerHint': 'Default dùng cấu hình riêng của CLI. Custom… cho phép nhập model id.',
  'settings.modelPickerLiveHint': 'Danh sách model lấy từ CLI này. Default dùng cấu hình riêng của CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Danh sách model lấy từ CLI này.',
  'settings.modelPickerFallbackHint': 'Đang hiện danh sách mặc định. Bấm Quét lại để lấy model live từ CLI.',
  'settings.modelCustom': 'Tùy chỉnh (nhập bên dưới)…',
  'settings.modelCustomLabel': 'Model id tùy chỉnh',
  'settings.modelCustomPlaceholder': 'ví dụ anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Provider media',
  'settings.mediaProvidersHint': 'Kết nối provider cho ảnh, video, âm thanh và tìm kiếm.',
  'settings.mediaProvidersNavSub': 'Ảnh / video / âm thanh',
  'settings.onboardingExecutionTitle': 'Chọn nguồn model',
  'settings.onboardingExecutionBody': 'Kết nối CLI local hoặc dùng API key riêng.',
  'settings.onboardingGateTooltipNoRuntime': 'Chọn runtime để tiếp tục.',
  'settings.onboardingGateTooltipAmr': 'Chọn CLI local hoặc provider BYOK để tiếp tục.',
  'settings.onboardingGateTooltipLocal': 'Chọn một CLI local khả dụng để tiếp tục.',
  'settings.onboardingGateTooltipByok': 'Thêm và test model key để tiếp tục.',
  'settings.onboardingRecommended': 'Đề xuất',
  'settings.onboardingLocalTitle': 'Agent local',
  'settings.onboardingLocalBody': 'Chạy bằng CLI đã cài trên máy.',
  'settings.onboardingByokTitle': 'Dùng key riêng',
  'settings.onboardingByokBody': 'Kết nối provider bằng API key của bạn.',
  'settings.onboardingContinue': 'Tiếp tục',
  'chat.amrError.rechargeCta': 'Nạp thêm',

  'entry.openSettingsTitle': 'Cài đặt',
  'entry.openSettingsAria': 'Mở cài đặt',
  'entry.accountSettings': 'Cài đặt',
  'entry.credits': 'Hạn mức',
  'entry.loadingWorkspace': 'Đang tải workspace…',
  'entry.navExpand': 'Mở rộng thanh bên',
  'entry.navCollapse': 'Thu gọn thanh bên',
  'entry.navNewProject': 'Dự án mới',
  'entry.navHome': 'Trang chủ',
  'entry.navProjects': 'Dự án',
  'entry.navTasks': 'Tự động hóa',
  'entry.navPlugins': 'Tiện ích',
  'entry.navDesignSystems': 'Hệ thiết kế',
  'entry.navBrands': 'Hệ thiết kế',
  'entry.navIntegrations': 'Tích hợp',
  'entry.navMembers': 'Thành viên',
  'entry.navWorkspaceSettings': 'Cài đặt workspace',
  'entry.navDrafts': 'Dự án cá nhân',
  'entry.navAllProjects': 'Dự án nhóm',
  'entry.navBoard': 'Bảng',
  'entry.deepseekCampaignAria': 'Chiến dịch DeepSeek V4 miễn phí, xem giá',
  'entry.deepseekCampaignLabel': 'DeepSeek V4 miễn phí',
  'entry.navTeamSection': 'Nhóm',
  'entry.draftsDescription': 'Dự án do bạn tạo, chỉ bạn nhìn thấy',
  'entry.allProjectsDescription': 'Dự án thuộc về mọi người trong nhóm',

  'homeHero.title': 'Hôm nay bạn muốn thiết kế gì với agent?',
  'homeHero.startWithTemplate': 'Bắt đầu từ mẫu…',
  'homeHero.startBlankProject': 'tạo project trống',
  'homeHero.templatePicker.label': 'Loại nội dung',
  'homeHero.templatePicker.searchPlaceholder': 'Tìm mẫu',
  'homeHero.templatePicker.projectTypes': 'Loại dự án',
  'homeHero.placeholder': 'Mô tả thứ bạn muốn tạo…',
  'homeHero.placeholderActive': 'Sửa ví dụ hoặc viết yêu cầu của bạn…',
  'homeHero.carousel.hint': 'Đính kèm nội dung slide, chọn design token hoặc mô tả deck bạn muốn tạo',
  'homeHero.skills': 'Kỹ năng',
  'homeHero.addMenu': 'Thêm ngữ cảnh',
  'homeHero.addPlugin': 'Thêm tiện ích',
  'homeHero.addConnectors': 'Thêm kết nối',
  'homeHero.addMcp': 'Thêm MCP server',
  'homeHero.noPlugins': 'Chưa cài tiện ích',
  'homeHero.noMcp': 'Chưa có MCP server',
  'homeHero.noConnectors': 'Chưa có kết nối',
  'homeHero.applying': 'Đang áp dụng…',
  'homeHero.removePlugin': 'Gỡ tiện ích',
  'homeHero.clearActivePlugin': 'Bỏ tiện ích đang dùng',
  'homeHero.clearActiveSkill': 'Bỏ kỹ năng đang dùng',
  'homeHero.contextItemsResolved': 'Đã xử lý {n} mục ngữ cảnh',
  'homeHero.removeFile': 'Gỡ file',
  'homeHero.contextSearchResults': 'Kết quả tìm ngữ cảnh',
  'homeHero.loadingContext': 'Đang tải ngữ cảnh…',
  'homeHero.noResults': 'Không có kết quả cho "{query}".',
  'homeHero.searchPrompt': 'Tìm file slide và design token.',
  'homeHero.parameters': '{n} tham số',
  'homeHero.details': 'Chi tiết',
  'homeHero.toRun': 'để chạy',
  'homeHero.forNewLine': 'để xuống dòng',
  'homeHero.run': 'Chạy',
  'homeHero.typeSomethingToRun': 'Nhập nội dung để chạy',
  'homeHero.promptExamples': 'Ví dụ',
  'homeHero.footer.designSystem': 'Phong cách',
  'homeHero.footer.autoDesignSystem': 'Tự động',
  'homeHero.footer.ratio': 'Tỷ lệ',
  'homeHero.footer.duration': 'Thời lượng',
  'homeHero.footer.resolution': 'Độ phân giải',
  'homeHero.footer.speakerNotes': 'Ghi chú',
  'homeHero.footer.noSpeakerNotes': 'Không có ghi chú',
  'homeHero.footer.availableCount': 'Có {n}',
  'homeHero.footer.noMatches': 'Không khớp',
  'homeHero.moreShortcuts': 'Thêm',
  'homeHero.confirmReplaceTitle': 'Thay prompt hiện tại?',
  'homeHero.confirmReplaceBody': 'Dùng {title} sẽ thay nội dung đang có trong ô nhập.',
  'homeHero.confirmReplace': 'Thay',
  'homeHero.chip.prototype': 'UI Mockup',
  'homeHero.chip.webClone': 'Clone website',
  'homeHero.chip.liveArtifact': 'Tài liệu tương tác',
  'homeHero.chip.deck': 'Slides',
  'homeHero.chip.image': 'Ảnh',
  'homeHero.chip.video': 'Video',
  'homeHero.chip.audio': 'Âm thanh',
  'homeHero.chip.createPlugin': 'Tạo tiện ích',
  'homeHero.chip.figma': 'Từ Figma',
  'homeHero.chip.folder': 'Từ thư mục',
  'homeHero.chip.template': 'Từ mẫu',
  'homeHero.chip.mobile': 'Ứng dụng di động',
  'homeHero.chip.document': 'Tài liệu',

  'newproj.tabPrototype': 'Bản mẫu',
  'newproj.tabLiveArtifact': 'Tài liệu tương tác',
  'newproj.tabDeck': 'Slides',
  'newproj.tabTemplate': 'Mẫu',
  'newproj.tabMedia': 'Media',
  'newproj.tabOther': 'Khác',
  'newproj.titlePrototype': 'Tạo bản mẫu',
  'newproj.titleLiveArtifact': 'Tạo tài liệu tương tác',
  'newproj.titleDeck': 'Tạo slides',
  'newproj.titleTemplate': 'Tạo từ mẫu',
  'newproj.titleImage': 'Tạo ảnh',
  'newproj.titleVideo': 'Tạo video',
  'newproj.titleAudio': 'Tạo âm thanh',
  'newproj.titleMedia': 'Tạo media',
  'newproj.titleOther': 'Tạo project',
  'newproj.namePlaceholder': 'Tên project',
  'newproj.fidelityLabel': 'Độ chi tiết',
  'newproj.fidelityWireframe': 'Khung dây',
  'newproj.fidelityHigh': 'Hoàn thiện cao',
  'newproj.toggleSpeakerNotes': 'Thêm ghi chú thuyết trình',
  'newproj.toggleAnimations': 'Thêm animation',
  'newproj.targetPlatformsLabel': 'Nền tảng mục tiêu',
  'newproj.surfaceOptionsLabel': 'Tùy chọn bề mặt',
  'newproj.templateLabel': 'Mẫu',
  'newproj.noTemplatesTitle': 'Chưa có mẫu',
  'newproj.noTemplatesBody': 'Không tìm thấy mẫu phù hợp.',
  'newproj.savedTemplate': 'Mẫu đã lưu',
  'newproj.fileSingular': '1 file',
  'newproj.filePlural': 'Nhiều file',
  'newproj.create': 'Tạo project',
  'newproj.locationLabel': 'Vị trí',
  'newproj.locationDefault': 'Dự án EduDeck',
  'newproj.createLiveArtifact': 'Tạo tài liệu tương tác',
  'newproj.createFromTemplate': 'Tạo từ mẫu',
  'newproj.createDisabledTitle': 'Nhập tên hoặc nội dung để tạo dự án.',
  'newproj.openFolder': 'Mở thư mục',
  'newproj.openingFolder': 'Đang mở thư mục…',
  'newproj.privacyFooter': 'Project được lưu trên máy này.',
  'newproj.designSystem': 'Hệ thiết kế',
  'newproj.dsNoneFreeform': 'Không dùng hệ thiết kế',
  'newproj.dsSearch': 'Tìm hệ thiết kế',
  'newproj.dsEmpty': 'Không tìm thấy hệ thiết kế cho "{query}".',
  'newproj.dsFootClear': 'Bỏ chọn',
  'newproj.modelLabel': 'Mô hình',
  'newproj.modelSearch': 'Tìm mô hình',
  'newproj.modelEmpty': 'Không tìm thấy mô hình.',
  'newproj.modelRecommended': 'Đề xuất',
  'newproj.aspectLabel': 'Tỷ lệ',
  'newproj.videoLengthLabel': 'Độ dài video',
  'newproj.audioKindLabel': 'Loại âm thanh',
  'newproj.audioKindMusic': 'Nhạc',
  'newproj.audioKindSpeech': 'Giọng nói',
  'newproj.audioKindSfx': 'Hiệu ứng âm thanh',
  'newproj.audioDurationLabel': 'Thời lượng âm thanh',
  'newproj.voiceLabel': 'Giọng',
  'newproj.voicePlaceholder': 'Chọn hoặc nhập giọng',
  'newproj.connectorsLabel': 'Kết nối',
  'newproj.connectorsHint': 'Thêm dữ liệu từ dịch vụ đã kết nối.',
  'newproj.connectorsEmptyTitle': 'Chưa có kết nối',
  'newproj.connectorsEmptyBody': 'Kết nối dịch vụ để dùng dữ liệu trong dự án.',
  'newproj.connectorsEmptyCta': 'Quản lý kết nối',
  'newproj.connectorsLoading': 'Đang tải kết nối…',
  'newproj.connectorsManage': 'Quản lý',
  'newproj.promptTemplateLabel': 'Mẫu nội dung',
  'newproj.promptTemplateSearch': 'Tìm mẫu nội dung',
  'newproj.promptTemplateEmpty': 'Không tìm thấy mẫu nội dung.',
  'newproj.startFromLabel': 'Bắt đầu từ',
  'newproj.startBlank': 'Project trống',
  'newproj.startBlankHint': 'Tự mô tả thứ bạn muốn tạo.',

  'dsCreate.referenceLabel': 'Sao chép từ design system có sẵn',
  'dsCreate.referenceLoading': 'Đang tải DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Không tải được design system đó.',
  'dsCreate.heroEyebrow': 'Design system',
  'dsCreate.heroTitle': 'Tạo design system trong vài phút',
  'dsCreate.heroLede': 'Biến website hoặc DESIGN.md, kèm ngữ cảnh bạn đã có, thành một design system đúng thương hiệu và dùng được ngay.',
  'dsCreate.heroStepsLabel': 'bước',
  'dsCreate.heroStep1Title': 'Website hoặc DESIGN.md',
  'dsCreate.heroStep1Desc': 'Dán link, chọn brand hoặc copy token',
  'dsCreate.heroStep2Title': 'Thêm tư liệu',
  'dsCreate.heroStep2Desc': 'Ảnh, font, repo hoặc file .fig nếu có',
  'dsCreate.heroStep3Title': 'Tạo hệ thống',
  'dsCreate.heroStep3Desc': 'Trích xuất nhanh trước, AI refine sau',
  'dsCreate.heroPreviewTitle': 'Design system của bạn',
  'dsCreate.heroPreviewPalette': 'Bảng màu',
  'dsCreate.heroPreviewTypeScale': 'Cỡ chữ',
  'dsCreate.heroPreviewComponents': 'Component',
  'dsCreate.heroPreviewPrimary': 'Chính',
  'dsCreate.heroPreviewGhost': 'Phụ',
  'dsCreate.heroShowGuideAria': 'Hiện hướng dẫn design system',
  'dsCreate.heroHideGuideAria': 'Ẩn hướng dẫn design system',
  'dsCreate.heroShowGuideTitle': 'Hiện hướng dẫn',
  'dsCreate.heroHideGuideTitle': 'Ẩn hướng dẫn',
  'dsCreate.heroGuide': 'Hướng dẫn',
  'dsCreate.missingSourceError': 'Thêm website, DESIGN.md, mô tả, file, nguồn Figma hoặc ghi chú để tạo design system.',
  'dsCreate.continueToGeneration': 'Tiếp tục tạo',
  'dsCreate.embeddedTitle': 'Tạo từ tư liệu của bạn',
  'dsCreate.embeddedBody': 'Bắt đầu bằng website hoặc brand reference, rồi thêm các file nguồn nếu có.',
  'dsCreate.sourceSectionTitle': 'Trích xuất từ GitHub, website hoặc tư liệu nguồn',
  'dsCreate.sourceSectionBody': 'Bắt đầu bằng GitHub repo, website, DESIGN.md hoặc file thể hiện phong cách. EduDeck tạo hệ thống dùng được trước, rồi AI refine trong project.',
  'dsCreate.githubWebsiteLabel': 'GitHub hoặc website',
  'dsCreate.add': 'Thêm',
  'dsCreate.startFromBrand': 'Bắt đầu từ brand',
  'dsCreate.brandPickerSubtitle': 'Tìm brand, chọn một mục rồi app sẽ thêm website của brand đó làm style reference.',
  'dsCreate.brandPickerQuickPicks': 'Brand phổ biến - bấm để thêm',
  'dsCreate.addedSourceLinks': 'Source link đã thêm',
  'dsCreate.openSourceLabel': 'Mở {label}',
  'dsCreate.removeSourceLabel': 'Gỡ {label}',
  'dsCreate.addFiles': 'Thêm file',
  'dsCreate.describeBrand': 'Mô tả brand',
  'dsCreate.optional': 'tùy chọn',
  'dsCreate.describeBrandHelp': 'Giọng brand, giới thiệu và ngữ cảnh sản phẩm. Dùng trong lượt nhanh và AI refine.',
  'dsCreate.companyPlaceholder': 'ví dụ Mission Impastabowl: nhà hàng pasta fast-casual với kiosk, mobile app và website',
  'dsCreate.pasteDesignMd': 'Dán DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Dán DESIGN.md để tạo trực tiếp từ token, rationale và hướng dẫn component.',
  'dsCreate.reference': 'Tham chiếu',
  'dsCreate.designMdViewMode': 'Chế độ xem DESIGN.md',
  'dsCreate.advancedToggle': 'Nâng cao - repo, code local, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Liên kết code local',
  'dsCreate.localCodeHelper': 'Dùng thư mục hoặc file được chọn từ máy này.',
  'dsCreate.localCodePrompt': 'Kéo thư mục vào đây hoặc duyệt file',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Giải mã trên máy này thành token, component và asset thật - không cần tài khoản Figma.',
  'dsCreate.uploadFigPrompt': 'Thả file .fig vào đây hoặc duyệt file',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/... hoặc /file/...',
  'dsCreate.addedFigmaUrls': 'Figma URL đã thêm',
  'dsCreate.savedFigmaHelp': 'Đã lưu làm nguồn thiết kế Figma. Agent dùng nó làm tham chiếu chính; xuất .fig bên trên để decode offline đầy đủ.',

  'settings.designSystems': 'Hệ thiết kế',
  'settings.designSystemsHint': 'Quản lý hệ thiết kế hiện trong thư viện trang chủ',
  'settings.designSystemsInstalled': 'Đã cài',
  'settings.designSystemsAdd': 'Thêm hệ thiết kế',
  'settings.designSystemsHiddenCount': '{count} đang ẩn khỏi thư viện trang chủ',
  'settings.designSystemsShowAll': 'Hiện tất cả',
  'settings.designSystemsShowHidden': 'Hiện mục ẩn',
  'settings.designSystemsSource': 'Nguồn',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Tham chiếu registry shadcn',
  'settings.designSystemsImportShadcn': 'Nhập từ shadcn',
  'settings.designSystemsStructure': 'Cấu trúc',
  'settings.designSystemsModeHybrid': 'Hybrid',
  'settings.designSystemsModeNormalized': 'Chuẩn hóa',
  'settings.designSystemsModeVerbatim': 'Giữ nguyên',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Màu sắc',
  'settings.designSystemsCraftAccessibility': 'Khả năng truy cập',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'Đường dẫn dự án',
  'settings.designSystemsImportGithub': 'Nhập từ GitHub',
  'settings.designSystemsImportProject': 'Nhập từ dự án',
  'settings.designSystemsImportedStatus': 'Đã nhập {title}',
  'settings.designSystemsViewImported': 'Xem hệ thiết kế đã nhập',
  'settings.designSystemsCategory': 'Danh mục',
  'settings.designSystemsAllCategories': 'Tất cả danh mục',
  'settings.designSystemsShowInHomeGallery': 'Hiện trong thư viện trang chủ',
  'settings.pageBackToHome': 'Về trang chủ',
  'settings.pageNavGroupPersonal': 'Cá nhân',
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Thành viên, billing và team space',
  'settings.workspaceLede': 'Cài đặt cấp team cho workspace này. Các khu vực này do team service quản lý.',
  'settings.workspaceBack': 'Về workspace',
  'settings.workspaceMembers': 'Thành viên & lời mời',
  'settings.workspaceMembersHint': 'Quản lý người có quyền truy cập workspace và gửi lời mời.',
  'settings.workspaceBilling': 'Gói & seat',
  'settings.workspaceBillingHint': 'Gói, seat và thanh toán cho workspace này.',
  'settings.workspaceAutoRecharge': 'Tự động nạp',
  'settings.workspaceAutoRechargeHint': 'Tự động nạp credit khi số dư thấp.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Project dùng chung và quyền hiển thị cho team.',
  'settings.projectLocations': 'Vị trí project',
  'settings.projectLocationsHint': 'Thư mục lưu workspace',
  'settings.projectLocationsDescription': 'Chọn nơi EduDeck lưu project mới trên máy này.',
  'settings.projectLocationsSaveError': 'Không lưu được vị trí project.',
  'settings.projectLocationsSaved': 'Đã lưu vị trí project.',
  'settings.projectLocationsScanError': 'Không quét được thư mục.',
  'settings.projectLocationsScanComplete': 'Quét xong: đã nhập {imported}, đã có {existing}.',
  'settings.projectLocationsNoFolderSelected': 'Chưa chọn thư mục.',
  'settings.projectLocationsDuplicate': 'Thư mục này đã có trong danh sách.',
  'settings.projectLocationsWorkBaseMeta': 'Thư mục làm việc',
  'settings.projectLocationsAddFolder': 'Thêm thư mục',
  'settings.projectLocationsDefaultBadge': 'Mặc định',
  'settings.projectLocationsMakeDefault': 'Đặt mặc định',
  'settings.projectLocationsDefaultSaved': 'Đã đặt làm mặc định.',

  'designSystemPicker.select': 'Chọn design system',
  'designSystemPicker.loading': 'Đang tải design system…',
  'designSystemPicker.searchPlaceholder': 'Tìm design system (tên / danh mục / tóm tắt)',
  'designSystemPicker.searchCompactPlaceholder': 'Tìm design system',
  'designSystemPicker.noneTitle': 'Không dùng design system',
  'designSystemPicker.noneSummary': 'Không dùng design system - model tự suy luận phong cách từ prompt.',
  'designSystemPicker.empty': 'Không có design system khớp',
  'designSystemPicker.openPreview': 'Mở preview',
  'designSystemPicker.loadingPreview': 'Đang tải preview…',
  'designSystemPicker.noPreview': 'Chưa có trang preview. Mở Design System để xem đầy đủ.',
  'designSystemPicker.previewHint': 'Hover một design system để xem preview',
  'designSystemPicker.fullscreenAria': 'Preview toàn màn hình {title}',
  'designSystemPicker.closeFullscreen': 'Đóng preview toàn màn hình',
  'designSystemPicker.closeEsc': 'Đóng (Esc)',
  'designSystemPicker.previewFrameTitle': 'Preview {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Preview toàn màn hình {title}',

  'brandDetail.identity': 'Nhận diện',
  'brandDetail.designLanguage': 'Ngôn ngữ thiết kế',
  'brandDetail.colors': 'Màu sắc',
  'brandDetail.fonts': 'Font',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Thẩm mỹ',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Dùng trong chat mới',
  'brandDetail.delete': 'Xóa design system',
  'brandDetail.back': 'Design System',
  'brandDetail.refining': 'Đang refine design system này…',
  'brandDetail.notFound': 'Không tìm thấy design system.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Bảng màu',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Hình ảnh & layout',
  'brandDetail.images': 'Ảnh',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Asset design system',
  'brandDetail.openProject': 'Mở project',
  'brandDetail.themeLight': 'Sáng',
  'brandDetail.themeDark': 'Tối',
  'brandDetail.subjects': 'Chủ thể',
  'brandDetail.treatment': 'Cách xử lý',
  'brandDetail.useLabel': 'Nên dùng',
  'brandDetail.avoidLabel': 'Tránh',
  'brandDetail.layoutPosture': 'Tư thế layout',
  'brandDetail.deleteConfirm': 'Xóa "{name}"? Design system này sẽ bị gỡ.',
  'brandDetail.viewMore': 'Hiện tất cả {count}',
  'brandDetail.viewLess': 'Thu gọn',

  'integrations.kicker': 'Tích hợp',
  'integrations.lede': 'Kết nối MCP server, skill và connector để agent dùng được nhiều ngữ cảnh hơn.',
  'integrations.agentReady': 'Sẵn sàng cho agent',
  'integrations.areasAria': 'Khu vực tích hợp',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Công cụ ngoài',
  'integrations.tabHint.connectors': 'Dịch vụ đã kết nối',
  'integrations.tabHint.useEverywhere': 'Dùng ở mọi nơi',
  'integrations.skillsTitle': 'Skills',
  'integrations.skillsBody': 'Workflow và quy tắc tái sử dụng cho agent.',

  'tasks.kicker': 'Workspace tự động hóa',
  'tasks.comingSoon': 'Sắp có',
  'tasks.lede': 'Automations biến prompt thành công việc bền vững: Orbit chạy chúng, routine giữ định nghĩa, lịch quyết định thời điểm chạy, và live artifact cho thấy thay đổi.',
  'tasks.newAutomation': 'Automation mới',
  'tasks.previewNote': 'Đây là bề mặt preview. Orbit settings đã dùng được; routine, schedule và live artifact sẽ hoàn thiện khi backend merge.',
  'tasks.primitivesAria': 'Thành phần automation',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Runtime bền vững cho công việc agent dài hoặc lặp lại.',
  'tasks.primitive.orbit.enabled': 'Đã bật tóm tắt hằng ngày',
  'tasks.primitive.orbit.manualOnly': 'Chạy thủ công',
  'tasks.primitive.routines.title': 'Routine',
  'tasks.primitive.routines.body': 'Định nghĩa task bền vững, vẫn tồn tại sau một chat.',
  'tasks.primitive.routines.meta': 'Product shell sẵn sàng',
  'tasks.primitive.schedules.title': 'Lịch chạy',
  'tasks.primitive.schedules.body': 'Trigger theo thời gian hoặc sự kiện để quyết định khi nào routine chạy.',
  'tasks.primitive.schedules.meta': 'Branch đang chờ',
  'tasks.primitive.liveArtifacts.title': 'Live artifact',
  'tasks.primitive.liveArtifacts.body': 'Report và ghi chú tự cập nhật khi agent làm việc.',
  'tasks.primitive.liveArtifacts.meta': 'Preview model',
  'tasks.listAria': 'Danh sách automation',
  'tasks.routinesAndRuns': '{n} routine và lượt chạy',
  'tasks.filtersAria': 'Bộ lọc automation',
  'tasks.filter.scheduled': 'Đã lên lịch',
  'tasks.filter.running': 'Đang chạy',
  'tasks.filter.done': 'Hoàn tất',
  'tasks.configurationAria': 'Cấu hình automation',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Pattern',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Output',
  'tasks.liveArtifact': 'Live artifact',
  'tasks.viewProgress': 'Xem tiến độ',
  'tasks.pause': 'Tạm dừng',
  'tasks.runNow': 'Chạy ngay',
  'tasks.openArtifact': 'Mở artifact',
  'tasks.status.dailyAt': 'Hằng ngày · {time}',
  'tasks.status.pausedManual': 'Đã tạm dừng · chỉ chạy thủ công',
  'tasks.sample.orbit.title': 'Tóm tắt connector hằng ngày của Orbit',
  'tasks.sample.orbit.metaEnabled': 'Connector digest đã được lên lịch',
  'tasks.sample.orbit.metaDisabled': 'Mở Orbit settings để bật',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · live artifact',
  'tasks.sample.orbit.previewDisabled': 'Chưa có lịch chạy',
  'tasks.sample.orbit.triggerEnabled': 'Lịch · hằng ngày lúc {time}',
  'tasks.sample.orbit.triggerDisabled': 'Thủ công · chạy khi cần',
  'tasks.sample.orbit.pattern': 'Routine · connector digest',
  'tasks.sample.orbit.runtime': 'Orbit · daemon đã lên lịch',
  'tasks.sample.orbit.output': 'Live artifact · report có thể refresh',
  'tasks.sample.orbit.artifactMetaEnabled': 'Refresh sau mỗi lượt chạy',
  'tasks.sample.orbit.artifactMetaDisabled': 'Đang chờ lịch',
  'tasks.sample.orbit.body1': '# Tóm tắt hoạt động Orbit Daily',
  'tasks.sample.orbit.body2': 'Connector đã kiểm tra · thành công, bỏ qua và lỗi',
  'tasks.sample.orbit.body3': 'Điểm nổi bật trở thành live artifact có thể refresh.',
  'tasks.sample.mcp.title': 'Nghiên cứu lựa chọn thay thế MCP',
  'tasks.sample.mcp.status': 'Đang chạy trong orbit · 2h 14m',
  'tasks.sample.mcp.meta': 'Đã xử lý 14 / 30 nguồn',
  'tasks.sample.mcp.preview': 'research_notes.md · live',
  'tasks.sample.mcp.trigger': 'Thủ công · một lần',
  'tasks.sample.mcp.pattern': 'Prompt nghiên cứu sâu',
  'tasks.sample.mcp.runtime': 'Remote · bền vững',
  'tasks.sample.mcp.output': 'Live report · tự cập nhật',
  'tasks.sample.mcp.artifactMeta': 'Cập nhật 12 giây trước',
  'tasks.sample.mcp.body1': '# Lựa chọn thay thế MCP - kết quả tạm thời',
  'tasks.sample.mcp.body2': 'Đã xem 14 nguồn · shortlist 3 ứng viên',
  'tasks.sample.mcp.body3': '## Shortlist',
  'tasks.sample.mcp.body4': '- Schema tool-call qua JSON-RPC...',
  'tasks.sample.mcp.body5': '- Giao thức agent dựa trên gRPC...',
  'tasks.sample.weekly.title': 'Digest team hằng tuần',
  'tasks.sample.weekly.status': 'Tiếp theo: Thứ Hai 9:00',
  'tasks.sample.weekly.meta': 'Cập nhật tài liệu weekly của team',
  'tasks.sample.weekly.preview': 'team_weekly.md · artifact tiếp theo',
  'tasks.sample.weekly.trigger': 'Lịch · hằng tuần',
  'tasks.sample.weekly.pattern': 'Routine · team digest',
  'tasks.sample.weekly.runtime': 'Remote · lặp lại',
  'tasks.sample.weekly.output': 'Live artifact · markdown',
  'tasks.sample.weekly.artifactMeta': 'Cập nhật lần cuối 4 ngày trước',
  'tasks.sample.weekly.body1': '# Team weekly',
  'tasks.sample.weekly.body2': '## Đang làm',
  'tasks.sample.weekly.body3': '- Lượt tích hợp design system',
  'tasks.sample.weekly.body4': '- Quét chất lượng connector',
  'tasks.sample.weekly.body5': '## Rủi ro',
  'tasks.sample.pr.title': 'Nhắc review PR',
  'tasks.sample.pr.status': 'Khi có PR mới · đã chạy 23 phút trước',
  'tasks.sample.pr.meta': 'Gửi Slack DM',
  'tasks.sample.pr.preview': 'Lần gửi gần nhất thành công',
  'tasks.sample.pr.trigger': 'Sự kiện · PR mới',
  'tasks.sample.pr.pattern': 'Routine · thông báo',
  'tasks.sample.pr.runtime': 'Local · chạy nhanh',
  'tasks.sample.pr.output': 'Tin nhắn · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Chạy lần cuối 23 phút trước',
  'tasks.sample.pr.body1': 'Đã mở PR #184 để review',
  'tasks.sample.pr.body2': 'Reviewer khớp: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Delivery: đã gửi Slack DM',
  'tasks.sample.meeting.title': 'Chuẩn bị trước họp',
  'tasks.sample.meeting.status': 'Ngày mai · 10:00',
  'tasks.sample.meeting.meta': 'Một lần · gửi tóm tắt',
  'tasks.sample.meeting.preview': 'meeting_brief.md · đang chờ',
  'tasks.sample.meeting.trigger': 'Lịch · một lần',
  'tasks.sample.meeting.pattern': 'Prompt briefing',
  'tasks.sample.meeting.runtime': 'Remote · giới hạn',
  'tasks.sample.meeting.output': 'Artifact + tin nhắn',
  'tasks.sample.meeting.artifactMeta': 'Đang chờ tạo',
  'tasks.sample.meeting.body1': '# Brief cuộc họp',
  'tasks.sample.meeting.body2': 'Nguồn agenda: calendar event + tài liệu liên kết',
  'tasks.sample.meeting.body3': 'Output sẽ gồm quyết định, blocker và câu hỏi.',
  'tasks.sample.candidate.title': 'Theo dõi ứng viên',
  'tasks.sample.candidate.status': 'Lỗi · cần xử lý',
  'tasks.sample.candidate.meta': 'Auth hết hạn',
  'tasks.sample.candidate.preview': 'Kết nối lại Greenhouse để tiếp tục',
  'tasks.sample.candidate.trigger': 'Lịch · hằng ngày',
  'tasks.sample.candidate.pattern': 'Routine · đồng bộ applicant',
  'tasks.sample.candidate.runtime': 'Remote · lặp lại',
  'tasks.sample.candidate.output': 'Live artifact · bảng',
  'tasks.sample.candidate.artifactMeta': 'Tạm dừng đến khi khôi phục auth',
  'tasks.sample.candidate.body1': '# Pipeline ứng viên',
  'tasks.sample.candidate.body2': 'Lần đồng bộ thành công gần nhất: 2 ngày trước',
  'tasks.sample.candidate.body3': 'Cần thao tác: kết nối lại tài khoản nguồn.',

  'pluginsView.lede': 'Duyệt workflow đã cài, tìm mục từ registry, quản lý source và chuẩn bị plugin cho team.',
  'pluginsView.importPlugin': 'Import plugin',
  'pluginsView.agentContext': 'Ngữ cảnh agent',
  'pluginsView.summaryAria': 'Tóm tắt plugin',
  'pluginsView.areasAria': 'Khu vực plugin',
  'pluginsView.loading': 'Đang tải plugin…',
  'pluginsView.tab.installed': 'Đã cài',
  'pluginsView.tab.available': 'Có sẵn',
  'pluginsView.tab.sources': 'Nguồn',
  'pluginsView.tab.team': 'Team',
  'pluginsView.tabHint.installed': 'Plugin của bạn',
  'pluginsView.tabHint.available': 'Từ nguồn',
  'pluginsView.tabHint.sources': 'Catalog',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Plugin đã cài',
  'pluginsView.installedSubtitle': 'Plugin bạn import hoặc cài từ marketplace source.',
  'pluginsView.installedEmpty': 'Chưa có plugin người dùng. Dùng Tạo / Import hoặc cài một mục Có sẵn.',
  'pluginsView.availableTitle': 'Có sẵn từ nguồn',
  'pluginsView.availableSubtitle': 'Các mục catalog phát hiện từ marketplace đã cấu hình.',
  'pluginsView.availableFiltersAria': 'Bộ lọc plugin có sẵn',
  'pluginsView.searchAvailableAria': 'Tìm plugin có sẵn',
  'pluginsView.searchAvailablePlaceholder': 'Tìm plugin có sẵn',
  'pluginsView.clearAvailableSearch': 'Xóa tìm kiếm plugin',
  'pluginsView.source': 'Nguồn',
  'pluginsView.availableEmptyInstalled': 'Chưa có mục có sẵn. Mục đã cài được bỏ khỏi Có sẵn; gỡ cài đặt để hiện lại.',
  'pluginsView.availableEmptyFiltered': 'Không có mục nào khớp bộ lọc.',
  'pluginsView.availableEmptyNoSources': 'Chưa có mục có sẵn. Thêm source trong tab Nguồn.',
  'pluginsView.installing': 'Đang cài…',
  'pluginsView.installWaiting': 'Đang chờ…',
  'pluginsView.installQueuedHint': 'Một plugin khác đang cài. Các lượt cài chạy lần lượt.',
  'pluginsView.install': 'Cài',
  'pluginsView.sourcesTitle': 'Nguồn registry',
  'pluginsView.sourcesSubtitle': 'Marketplace catalog dùng để nạp các plugin Có sẵn.',
  'pluginsView.sourceUrl': 'URL nguồn',
  'pluginsView.defaultTrust': 'Mức tin cậy mặc định',
  'pluginsView.trust.restricted': 'Hạn chế',
  'pluginsView.trust.trusted': 'Tin cậy',
  'pluginsView.trust.official': 'Chính thức',
  'pluginsView.adding': 'Đang thêm…',
  'pluginsView.addSource': 'Thêm nguồn',
  'pluginsView.sourcesEmpty': 'Chưa cấu hình nguồn registry.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'catalog v{version}',
  'pluginsView.trustFor': 'Trust cho {name}',
  'pluginsView.refreshing': 'Đang làm mới…',
  'pluginsView.removing': 'Đang gỡ…',
  'pluginsView.warningSingular': '{count} cảnh báo',
  'pluginsView.warningPlural': '{count} cảnh báo',
  'pluginsView.installLog': 'Log cài đặt',
  'pluginsView.marketplaceTitle': 'Extensions',
  'pluginsView.marketplaceBody': 'Cài bộ công cụ, skill và connector để thêm năng lực làm việc cho EduDeck.',
  'pluginsView.scope.official': 'Chính thức',
  'pluginsView.scope.team': 'Team',
  'pluginsView.scope.personal': 'Cá nhân',
  'pluginsView.kind.plugins': 'Bộ công cụ',
  'pluginsView.kind.skills': 'Skill',
  'pluginsView.searchPlugins': 'Tìm bộ công cụ',
  'pluginsView.searchSkills': 'Tìm skill',
  'pluginsView.create': 'Thêm',
  'pluginsView.createTitle': 'Thêm {kind}',
  'pluginsView.createWithAgent': 'Mô tả để agent tự tạo',
  'pluginsView.createClose': 'Đóng panel thêm',
  'pluginsView.createTypeAria': 'Loại cần tạo',
  'pluginsView.userPlugins': 'Plugin người dùng',
  'pluginsView.closeImportDialog': 'Đóng hộp thoại import',
  'pluginsView.importSourceAria': 'Nguồn import',
  'pluginsView.importChoiceGithub': 'Từ GitHub',
  'pluginsView.importChoiceGithubBody': 'Cài đường dẫn github:owner/repo.',
  'pluginsView.importChoiceZip': 'Upload zip',
  'pluginsView.importChoiceZipBody': 'Upload archive plugin.',
  'pluginsView.importChoiceFolder': 'Upload thư mục',
  'pluginsView.importChoiceFolderBody': 'Upload thư mục plugin.',
  'pluginsView.importSourceLabel': 'Nguồn GitHub, archive hoặc marketplace',
  'pluginsView.import': 'Import',
  'pluginsView.importSourceHelpBefore': 'Hỗ trợ',
  'pluginsView.importSourceHelpAfter': 'archive hoặc tên plugin marketplace.',
  'pluginsView.importZipBody': 'Chọn archive .zip có open-design.json, SKILL.md hoặc .claude-plugin/plugin.json.',
  'pluginsView.noZipSelected': 'Chưa chọn file zip',
  'pluginsView.importFolderBody': 'Chọn thư mục plugin. Đường dẫn tương đối được giữ nguyên và cài vào registry plugin người dùng.',
  'pluginsView.noFolderSelected': 'Chưa chọn thư mục',
  'pluginsView.importFooter': 'Plugin import là plugin người dùng và được lưu riêng với plugin official đi kèm.',
  'pluginsView.createWithAgentAction': 'Bắt đầu từ prompt',
  'pluginsView.importFromUrl': 'Import từ link',
  'pluginsView.uploadFolder': 'Upload thư mục local',
  'pluginsView.importing': 'Đang import…',
  'pluginsView.importAndUpload': 'Import và upload',
  'pluginsView.uploading': 'Đang upload…',
  'pluginsView.uploadKind': 'Upload {kind}',
  'pluginsView.filesSelected': 'Đã chọn {count} file',
  'pluginsView.chooseFolder': 'Chọn thư mục',
  'pluginsView.emptyNoMatchTitle': 'Không có kết quả khớp',
  'pluginsView.emptyNoMatchHint': 'Thử từ khóa khác.',
  'pluginsView.tryIt': 'Dùng thử',
  'pluginsView.uninstall': 'Gỡ cài đặt',
  'pluginsView.uninstalling': 'Đang gỡ…',
  'pluginsView.uninstallConfirm': 'Gỡ {title}?',
  'pluginsView.uninstallSuccess': 'Đã gỡ {title}',
  'pluginsView.uninstallFailed': 'Không gỡ được {title}',
  'pluginsView.shareToTeam': 'Chia sẻ với team',
  'pluginsView.moreActions': 'Thêm thao tác cho {title}',
  'pluginCard.details': 'Chi tiết',
  'pluginCard.use': 'Dùng',
  'plugins.availableDetails.provenance': 'Nguồn gốc',
  'plugins.availableDetails.install': 'Cài',
  'plugins.availableDetails.version': 'Phiên bản',
  'plugins.availableDetails.pluginVersion': 'Phiên bản plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copy lệnh cài',
  'plugins.availableDetails.copied': 'Đã copy',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Quyền',
  'plugins.availableDetails.capabilitySummary': 'Tóm tắt năng lực',
  'plugins.availableDetails.about': 'Giới thiệu',
  'plugins.availableDetails.noDescription': 'Chưa có mô tả.',
  'plugins.availableDetails.installedBundledHint': 'Mục official này đi kèm EduDeck và đã sẵn sàng dùng.',
  'plugins.availableDetails.catalog': 'Catalog',
  'plugins.availableDetails.source': 'Nguồn',
  'plugins.availableDetails.catalogUrl': 'Catalog URL',
  'plugins.availableDetails.license': 'License',
  'plugins.availableDetails.publisher': 'Publisher',
  'plugins.availableDetails.homepage': 'Homepage',
  'plugins.availableDetails.tags': 'Tag',
  'plugins.availableDetails.close': 'Đóng chi tiết plugin có sẵn',

  'dsFlow.sourceContext': 'Ngữ cảnh nguồn',
  'dsAsset.noInlinePreview': 'Không có preview inline cho loại file này.',
  'dsAsset.addFilesAria': 'Thêm file - kéo thả, dán hoặc bấm để duyệt',
  'dsAsset.dropTitleBeforeBrowse': 'Kéo thả, dán hoặc',
  'dsAsset.browse': 'duyệt file',
  'dsAsset.dropHint': 'Ảnh, font, logo, PDF, slide, HTML - tối đa 12 MB mỗi file',
  'dsAsset.reuseSavedAsset': 'hoặc dùng lại asset bạn đã lưu',
  'dsAsset.selectFromLibrary': 'Chọn từ thư viện',
  'dsAsset.stagedAssetsAria': 'Asset đã chọn',
  'dsAsset.removeFileAria': 'Gỡ {name}',

  'chat.runError.title.authRequired': 'Cần cấp quyền',
  'chat.runError.title.balance': 'Không đủ hạn mức',
  'chat.runError.title.connectionDropped': 'Mất kết nối',
  'chat.runError.title.signInRequired': 'Cần đăng nhập',
  'chat.runError.title.rateLimited': 'Đã tới giới hạn sử dụng',
  'chat.runError.title.generic': 'Tác vụ thất bại',
  'chat.runError.title.artifactMissing': 'Không tạo được kết quả',
  'chat.runError.signInMessage.amr': 'Agent này đã tắt ở chế độ local. Chọn local CLI hoặc provider BYOK.',
  'chat.runError.signInMessage.other': '{agent} chưa đăng nhập. Kiểm tra trạng thái đăng nhập trên máy.',
  'chat.runError.agentFallback': 'agent',
  'chat.runError.sourceLabel': 'Chi tiết lỗi',
  'chat.runError.sourceExpandAria': 'Mở chi tiết nguồn lỗi',
  'chat.runError.sourceCollapseAria': 'Thu gọn nguồn lỗi',
  'chat.runError.title.cliMissing': 'Chưa cài agent',
  'chat.runError.title.promptTooLarge': 'Input quá dài',
  'chat.runError.title.modelUnavailable': 'Model không khả dụng',
  'chat.runError.title.upstreamUnavailable': 'Dịch vụ tạm thời không khả dụng',
  'chat.runError.title.toolLoop': 'Bị kẹt trong vòng lặp',
  'chat.runError.title.outputInvalid': 'Output model không hợp lệ',
  'chat.runError.title.runtimeConfig': 'Lỗi cấu hình',
  'chat.runError.cliMissingMessage': 'Không tìm thấy công cụ dòng lệnh {agent}. Cài đặt và bảo đảm nó có trong PATH, rồi thử lại.',
  'chat.runError.promptTooLargeMessage': 'Lượt này vượt quá giới hạn context của model. Rút gọn prompt, bỏ bớt attachment hoặc mở cuộc trò chuyện mới rồi thử lại.',
  'chat.runError.modelUnavailableMessage': 'Model đã chọn không khả dụng hoặc không tồn tại. Đổi model trong Settings rồi thử lại.',
  'chat.runError.rateLimitedMessage': 'Bạn đã tới giới hạn sử dụng của dịch vụ model. Chờ một lát rồi thử lại, hoặc đổi model/dịch vụ khác.',
  'chat.runError.upstreamUnavailableMessage': 'Dịch vụ model đang tạm thời không khả dụng, thường do upstream hoặc mạng/proxy. Thử lại sau một lát.',
  'chat.runError.toolLoopMessage': '{agent} lặp lại cùng một thao tác mà không tiến triển nên đã bị dừng. Kiểm tra file hoặc lệnh đích rồi thử lại.',
  'chat.runError.outputInvalidMessage': 'Model trả về output không hợp lệ nên lượt này bị ngắt. Thường chỉ cần thử lại.',
  'chat.runError.runtimeConfigMessage': 'Cấu hình runtime của agent đã chọn không hợp lệ nên không thể bắt đầu. Cập nhật bản mới nhất hoặc liên hệ hỗ trợ.',
  'chat.runError.title.quotaExhausted': 'Hết quota',
  'chat.runError.title.timedOut': 'Hết thời gian chờ',
  'chat.runError.title.emptyOutput': 'Không có output',
  'chat.runError.title.sessionExpired': 'Phiên đã hết hạn',
  'chat.runError.title.gitBashMissing': 'Thiếu Git Bash',
  'chat.runError.title.cpuUnsupported': 'CPU không được hỗ trợ',
  'chat.runError.quotaExhaustedMessage': 'Quota hoặc giới hạn billing của dịch vụ model đã hết nên thử lại cũng không giúp. Nạp thêm ở provider hoặc đổi model/dịch vụ khác.',
  'chat.runError.workspaceCreditsMessage': 'Workspace đã hết hạn mức. Nạp thêm, nhờ owner tăng hạn mức hoặc đổi model/dịch vụ khác.',
  'chat.runError.timedOutMessage': 'Lượt chạy quá lâu và đã bị dừng. Thử lại hoặc thu hẹp tác vụ.',
  'chat.runError.inactivityTimeoutMessage': 'Agent im lặng quá lâu nên bị dừng do timeout. Thường chỉ cần thử lại.',
  'chat.runError.emptyOutputMessage': 'Agent kết thúc nhưng không tạo output. Lỗi này thường tạm thời, hãy thử chạy lại.',
  'chat.runError.sessionExpiredMessage': 'Phiên resume đã hết hạn. Phiên đã được reset, hãy thử lại để chạy mới.',
  'chat.runError.gitBashMissingMessage': 'Agent này cần Git Bash trên Windows nhưng không tìm thấy. Cài Git for Windows rồi thử lại.',
  'chat.runError.cpuUnsupportedMessage': 'Runtime của agent này cần tập lệnh CPU AVX2 mà máy này không có, nên không thể khởi động. Cập nhật EduDeck lên bản mới nhất có runtime tương thích.',

  'chat.comments.attached': 'Đã đính kèm',
  'chat.comments.emptyAttached': 'Chưa có comment nào được đính kèm.',
  'chat.comments.saved': 'Đã lưu',
  'chat.comments.emptySaved': 'Chưa có comment đã lưu.',
  'chat.comments.add': 'Thêm comment',
  'chat.comments.addAll': 'Thêm tất cả',
  'chat.comments.remove': 'Gỡ',
  'chat.comments.placeholder': 'Viết ghi chú...',
  'chat.comments.addSend': 'Thêm và gửi',
  'chat.comments.updateSend': 'Cập nhật và gửi',
  'chat.comments.removeAttachment': 'Gỡ attachment',
  'chat.comments.removeAttachmentAria': 'Gỡ attachment comment {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Gửi vào chat',
  'chat.comments.sending': 'Đang gửi...',
  'chat.comments.edit': 'Sửa',
  'chat.comments.select': 'Chọn',
  'chat.comments.selectAll': 'Chọn tất cả',
  'chat.comments.deselect': 'Bỏ chọn',
  'chat.comments.nSelected': 'Đã chọn {n}',
  'chat.comments.pin': 'Ghim',
  'chat.comments.addNote': 'Thêm ghi chú',
  'chat.comments.savedToast': 'Đã lưu comment',
  'chat.comments.pinSavedToast': 'Đã lưu pin',
  'chat.comments.pinAtCoords': 'Ghim tại {x}, {y}',
  'chat.comments.capturedItems': '{n} mục đã chụp',
  'chat.comments.clear': 'Xóa',
  'chat.comments.targetImage': 'Ảnh',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Vùng',

  'conv.switch': 'Đổi cuộc trò chuyện',
  'conv.label': 'Cuộc trò chuyện',
  'conv.heading': 'Cuộc trò chuyện',
  'conv.new': '+ Mới',
  'conv.empty': 'Chưa có cuộc trò chuyện.',
  'conv.untitled': 'Cuộc trò chuyện chưa đặt tên',
  'conv.renameTooltip': 'Nhấp đúp để đổi tên',
  'conv.delete': 'Xóa cuộc trò chuyện',
  'conv.deleteConfirm': 'Xóa "{title}"? Thao tác này xóa các tin nhắn của cuộc trò chuyện.',
  'agentPicker.label': 'Agent',
  'agentPicker.modeChoose': 'Chọn chế độ chạy',
  'agentPicker.localCli': 'Local CLI',
  'agentPicker.daemonOff': 'daemon tắt',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Chọn code-agent CLI đã phát hiện',
  'agentPicker.noAgents': 'không có agent trong PATH',
  'agentPicker.notInstalled': 'chưa cài',
  'agentPicker.rescan': 'Quét lại PATH local để tìm agent',
  'tool.openInTab': 'Mở {name} trong tab',
  'tool.open': 'mở',
  'tool.todos': 'Việc cần làm',
  'tool.todosExpand': 'Hiện task',
  'tool.todosCollapse': 'Ẩn task',
  'tool.todosDone': 'Xong',
  'tool.todosDismiss': 'Ẩn danh sách task',
  'tool.write': 'Ghi',
  'tool.edit': 'Sửa',
  'tool.read': 'Đọc',
  'tool.delete': 'Xóa',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Tìm',
  'tool.lines': '{n} dòng',
  'tool.changeSingular': 'thay đổi',
  'tool.changePlural': 'thay đổi',
  'tool.in': 'trong {path}',
  'tool.hide': 'ẩn',
  'tool.output': 'output',
  'tool.running': 'đang chạy...',
  'tool.error': 'lỗi',
  'tool.done': 'xong',

  'routines.title': 'Automation',
  'routines.subtitle': 'Automation theo lịch chạy tự động.',
  'routines.newAutomation': 'Automation mới',
  'routines.loading': 'Đang tải...',
  'routines.empty': 'Chưa có automation.',
  'routines.emptyHint': 'Bấm Automation mới để lên lịch một lượt agent chạy tự động.',
  'routines.runHistoryLoading': 'Đang tải lượt chạy...',
  'routines.runHistoryEmpty': 'Chưa có lượt chạy.',
  'routines.fieldName': 'Tên',
  'routines.fieldNamePlaceholder': 'Brief buổi sáng',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Lấy hoạt động GitHub + Linear hôm qua và tóm tắt thay đổi.',
  'routines.fieldSchedule': 'Lịch',
  'routines.fieldMinute': 'Phút của mỗi giờ',
  'routines.fieldTime': 'Giờ',
  'routines.fieldTimezone': 'Múi giờ',
  'routines.fieldsetProject': 'Project',
  'routines.kind.hourly': 'Hằng giờ',
  'routines.kind.daily': 'Hằng ngày',
  'routines.kind.weekdays': 'Ngày làm việc',
  'routines.kind.weekly': 'Hằng tuần',
  'routines.weekday.short.0': 'CN',
  'routines.weekday.short.1': 'T2',
  'routines.weekday.short.2': 'T3',
  'routines.weekday.short.3': 'T4',
  'routines.weekday.short.4': 'T5',
  'routines.weekday.short.5': 'T6',
  'routines.weekday.short.6': 'T7',
  'routines.weekday.long.0': 'Chủ nhật',
  'routines.weekday.long.1': 'Thứ Hai',
  'routines.weekday.long.2': 'Thứ Ba',
  'routines.weekday.long.3': 'Thứ Tư',
  'routines.weekday.long.4': 'Thứ Năm',
  'routines.weekday.long.5': 'Thứ Sáu',
  'routines.weekday.long.6': 'Thứ Bảy',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Chạy mỗi giờ tại phút :{minute}',
  'routines.describe.daily': 'Chạy hằng ngày lúc {time} {tz}',
  'routines.describe.weekdays': 'Chạy Thứ Hai-Thứ Sáu lúc {time} {tz}',
  'routines.describe.weekly': 'Chạy mỗi {day} lúc {time} {tz}',
  'routines.modeCreate': 'Tạo project mới mỗi lượt chạy',
  'routines.modeCreateHint': 'Mỗi lượt chạy có workspace riêng.',
  'routines.modeReuse': 'Dùng lại project có sẵn',
  'routines.modeReuseHint': 'Mỗi lượt chạy là một cuộc trò chuyện mới trong project.',
  'routines.pickProject': '-- Chọn project --',
  'routines.targetReuse': '-> {project}',
  'routines.targetCreate': '-> project mới mỗi lượt chạy',
  'routines.tagPaused': 'đã tạm dừng',
  'routines.metaNext': 'tiếp theo: {when}',
  'routines.metaLast': 'gần nhất:',
  'routines.triggerManual': 'thủ công',
  'routines.triggerScheduled': 'theo lịch',
  'routines.openProject': 'Mở project',
  'routines.openProjectTitle': 'Mở project mà lượt chạy này ghi vào',
  'routines.runNow': 'Chạy ngay',
  'routines.edit': 'Sửa',
  'routines.pause': 'Tạm dừng',
  'routines.resume': 'Tiếp tục',
  'routines.history': 'Lịch sử',
  'routines.hideHistory': 'Ẩn lịch sử',
  'routines.delete': 'Xóa',
  'routines.deleteTitle': 'Xóa automation này',
  'routines.cancel': 'Hủy',
  'routines.save': 'Lưu',
  'routines.saving': 'Đang lưu...',
  'routines.create': 'Tạo',
  'routines.creating': 'Đang tạo...',
  'routines.status.queued': 'đang chờ',
  'routines.status.running': 'đang chạy',
  'routines.status.succeeded': 'thành công',
  'routines.status.failed': 'thất bại',
  'routines.status.canceled': 'đã hủy',
  'routines.confirmDelete': 'Xóa automation này? Các lượt chạy cũ và project của chúng vẫn được giữ.',
  'routines.errorPickProject': 'Chọn project để dùng lại, hoặc đổi sang "Tạo project mới mỗi lượt chạy"',
  'routines.errorAgentEmptyOutput': 'Agent hoàn tất nhưng không tạo output. Model hoặc provider có thể đã trả về rỗng, hãy kiểm tra log agent.',

  'fileViewer.empty': 'Chọn một file để xem.',
  'fileViewer.loading': 'Đang tải...',
  'fileViewer.exportPptx': 'Xuất PPTX',
  'fileViewer.openInNewTab': 'Mở trong tab mới',
  'fileViewer.copyPath': 'Sao chép đường dẫn',
  'fileViewer.copied': 'Đã copy!',
  'fileViewer.share': 'Chia sẻ',
  'fileViewer.binaryMeta': 'Binary · {size}',
  'fileViewer.binaryNote': 'File binary ({size} byte). Tải xuống hoặc mở từ ổ đĩa để kiểm tra.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Tài liệu',
  'fileViewer.presentationMeta': 'Bài trình chiếu',
  'fileViewer.spreadsheetMeta': 'Bảng tính',
  'fileViewer.previewUnavailable': 'Không có bản xem trước. Tải xuống hoặc mở file để kiểm tra.',
  'fileViewer.download': 'Tải xuống',
  'fileViewer.open': 'Mở',
  'fileViewer.imageMeta': 'Ảnh · {size}',
  'fileViewer.reactMeta': 'Component React · {size}',
  'fileViewer.sketchMeta': 'Sketch · {size}',
  'fileViewer.markdownStreamingMeta': 'Đang phát bản xem trước...',
  'fileViewer.markdownErrorMeta': 'Bản xem trước có thể chưa đầy đủ do lỗi tạo nội dung.',
  'fileViewer.markdownStreamingStatus': 'Đang stream... hiển thị markdown tạm thời.',
  'fileViewer.markdownErrorStatus': 'Lỗi generation. Hiển thị nội dung cuối cùng còn có.',
  'fileViewer.markdownSaving': 'Đang lưu...',
  'fileViewer.markdownSaveFailed': 'Lưu thất bại',
  'fileViewer.markdownSaved': 'Đã lưu',
  'fileViewer.markdownAutoSaved': 'Tự động lưu · {time}',
  'fileViewer.markdownAutoSaveHint': 'Tự động lưu bật',
  'fileViewer.markdownViewMode': 'Chế độ xem Markdown',
  'fileViewer.split': 'Chia đôi',
  'fileViewer.markdownEditor': 'Trình sửa Markdown',
  'fileViewer.markdownEditorPlaceholder': 'Nhập ghi chú, yêu cầu hoặc hướng dẫn cho tài liệu này...',
  'fileViewer.markdownPreview': 'Xem trước Markdown',
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Âm thanh · {size}',
  'fileViewer.reload': 'Tải lại',
  'fileViewer.reloadDisk': 'Tải lại từ ổ đĩa',
  'fileViewer.copy': 'Sao chép',
  'fileViewer.copyTitle': 'Sao chép nội dung file',
  'fileViewer.saveDisabled': 'Lưu (viewer chỉ đọc)',
  'fileViewer.save': 'Lưu',
  'fileViewer.preview': 'Xem trước',
  'fileViewer.source': 'Code',
  'fileViewer.tweaks': 'Tinh chỉnh',
  'fileViewer.tweaksUnavailable': 'Artifact này không có panel tinh chỉnh',
  'fileViewer.jsxModuleTitle': 'Không có preview độc lập',
  'fileViewer.jsxModuleBody': 'File này là module component được trang khác nạp vào.',
  'fileViewer.jsxModuleCta': 'Mở trang render nó:',
  'fileViewer.comment': 'Comment',
  'fileViewer.edit': 'Sửa',
  'fileViewer.draw': 'Vẽ',
  'fileViewer.mark': 'Đánh dấu',
  'fileViewer.markTool': 'Công cụ đánh dấu',
  'fileViewer.boxSelect': 'Chọn vùng',
  'fileViewer.textTool': 'Text',
  'fileViewer.textAnnotationRemove': 'Gỡ text',
  'fileViewer.screenshot': 'Screenshot',
  'fileViewer.versions.entry': 'Phiên bản',
  'fileViewer.versions.entryFull': 'Lịch sử phiên bản',
  'fileViewer.versions.title': 'Phiên bản',
  'fileViewer.versions.countOne': '1 phiên bản',
  'fileViewer.versions.countMany': '{count} phiên bản',
  'fileViewer.versions.current': 'Hiện tại',
  'fileViewer.versions.sourceAi': 'AI sửa',
  'fileViewer.versions.sourceManual': 'Sửa thủ công',
  'fileViewer.versions.sourceRestore': 'Đã khôi phục',
  'fileViewer.versions.restoredFrom': 'Khôi phục từ v{version}',
  'fileViewer.versions.versionLabel': 'Phiên bản {version}',
  'fileViewer.versions.listAria': 'Các phiên bản file',
  'fileViewer.versions.loading': 'Đang tải phiên bản...',
  'fileViewer.versions.empty': 'Chưa có phiên bản.',
  'fileViewer.versions.loadFailed': 'Không tải được phiên bản.',
  'fileViewer.versions.previewFailed': 'Không tải được bản xem trước của phiên bản này.',
  'fileViewer.versions.previewLoading': 'Đang tải bản xem trước phiên bản...',
  'fileViewer.versions.noPrompt': 'Không có nội dung yêu cầu được ghi lại',
  'fileViewer.versions.noPromptBody': 'Phiên bản này không ghi lại nội dung yêu cầu.',
  'fileViewer.versions.promptTitle': 'Nội dung yêu cầu',
  'fileViewer.versions.copyPrompt': 'Sao chép nội dung yêu cầu',
  'fileViewer.versions.fullscreen': 'Xem trước toàn màn hình',
  'fileViewer.versions.open': 'Mở bản xem trước',
  'fileViewer.versions.currentHelp': 'Đây đã là phiên bản hiện tại.',
  'fileViewer.versions.restoreHelp': 'Chuyển sẽ khôi phục HTML này thành phiên bản hiện tại mới.',
  'fileViewer.versions.restore': 'Chuyển sang phiên bản này',
  'fileViewer.versions.restoreConfirmTitle': 'Chuyển sang phiên bản này?',
  'fileViewer.versions.restoreConfirmCta': 'Chuyển',
  'fileViewer.versions.restoring': 'Đang chuyển...',
  'fileViewer.versions.restoreFailed': 'Không chuyển được sang phiên bản này.',
  'fileViewer.versions.restoreSuccess': 'Đã chuyển sang phiên bản này.',
  'fileViewer.editScreenshotToChat': 'Gửi screenshot vào chat',
  'fileViewer.zoomOut': 'Thu nhỏ',
  'fileViewer.zoomIn': 'Phóng to',
  'fileViewer.resetZoom': 'Reset zoom',
  'fileViewer.viewportAria': 'Kích thước xem trước',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Xem trước desktop toàn chiều rộng',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Xem trước tablet 820 x 1180',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Xem trước mobile 390 x 844',
  'fileViewer.reloadAria': 'Tải lại',
  'fileViewer.previousSlide': 'Slide trước',
  'fileViewer.nextSlide': 'Slide sau',
  'fileViewer.slideNavAria': 'Điều hướng slide',
  'fileViewer.speakerNotes': 'Ghi chú thuyết trình',
  'fileViewer.speakerNotesSlide': 'Slide {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Slide này chưa có ghi chú thuyết trình.',
  'fileViewer.speakerNotesEdit': 'Sửa',
  'fileViewer.speakerNotesSave': 'Lưu ghi chú',
  'fileViewer.speakerNotesSaving': 'Đang lưu...',
  'fileViewer.speakerNotesSaved': 'Đã lưu',
  'fileViewer.speakerNotesSaveFailed': 'Không lưu được ghi chú thuyết trình.',
  'fileViewer.speakerNotesPlaceholder': 'Thêm ghi chú thuyết trình cho slide này...',
  'fileViewer.previewAssetBlockedTitle': 'Asset xem trước bị chặn',
  'fileViewer.previewAssetBlockedDetail': 'Không tải được {filePath}. Hãy thay symlink ngoài bằng file nằm trong project này.',
  'fileViewer.presenterReset': 'Reset',
  'fileViewer.present': 'Trình chiếu',
  'fileViewer.presentInTab': 'Trong tab này',
  'fileViewer.presentFullscreen': 'Toàn màn hình',
  'fileViewer.presentNewTab': 'Tab mới',
  'fileViewer.presentFromBeginning': 'Bắt đầu từ đầu',
  'fileViewer.presentFromCurrentSlide': 'Bắt đầu từ slide hiện tại',
  'fileViewer.presenterMode': 'Chế độ presenter',
  'fileViewer.exitPresentation': 'Thoát trình chiếu',
  'fileViewer.shareLabel': 'Chia sẻ',
  'fileViewer.shareMenuShareLink': 'CHIA SẺ',
  'fileViewer.shareMenuPublishOnline': 'CÔNG KHAI ONLINE',
  'fileViewer.shareMenuDownload': 'TẢI XUỐNG',
  'fileViewer.shareMenuPresentation': 'Bài trình chiếu',
  'fileViewer.shareMenuSourceFiles': 'File nguồn',
  'fileViewer.shareMenuSave': 'LƯU',
  'fileViewer.unifiedShareAria': 'Thao tác chia sẻ và xuất file',
  'fileViewer.unifiedShareTab': 'Chia sẻ',
  'fileViewer.unifiedExportTab': 'Xuất file',
  'fileViewer.unifiedSendTab': 'Gửi tới...',
  'fileViewer.openFileForHistory': 'Mở một file để xem lịch sử phiên bản',
  'fileViewer.workspaceShareTitle': 'Chia sẻ dự án trong workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Chỉ bạn có thể truy cập dự án này. Chọn thành viên workspace để chia sẻ với team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Thành viên của workspace này có thể truy cập dự án.',
  'fileViewer.workspaceAccessPrivate': 'Chỉ mình tôi',
  'fileViewer.workspaceAccessMembers': 'Member workspace',
  'fileViewer.publishSingleFileTitle': 'Công khai file này cho mọi người',
  'fileViewer.publishSingleFileDescription': 'Cho phép file hiện tại hiển thị bên ngoài. Ai có link công khai đều xem được online.',
  'fileViewer.openFileRequired': 'Mở một file để dùng tính năng này.',
  'fileViewer.publishFile': 'Công khai file',
  'fileViewer.publishingFile': 'Đang công khai...',
  'fileViewer.unpublishFile': 'Gỡ công khai file',
  'fileViewer.shareEmptyStateTitle': 'Chưa có gì để chia sẻ',
  'fileViewer.shareEmptyStateDescription': 'Tạo hoặc tham gia team để chia sẻ file này với đồng đội',
  'fileViewer.shareEmptyStateCreateTeam': 'Tạo team',
  'fileViewer.shareTeamMissingTitle': 'Chưa có team để chia sẻ',
  'fileViewer.publishFileRequiresTeam': 'Link công khai cần team workspace. Đổi sang team workspace hoặc dùng Deploy để công khai file này.',
  'fileViewer.publishFileRequiresWorkspace': 'Link công khai cần workspace. Dùng Deploy để công khai file này.',
  'fileViewer.publishFileFailed': 'Không công khai được file này. Vui lòng thử lại.',
  'fileViewer.workspaceShareSuccess': 'Đã chia sẻ với member workspace',
  'fileViewer.workspaceShareFailed': 'Không chia sẻ được với workspace',
  'fileViewer.workspaceUnshareSuccess': 'Đã chuyển lại về private',
  'fileViewer.workspaceUnshareFailed': 'Không chuyển lại về private được',
  'fileViewer.readonlySharedNoExport': 'Dự án được chia sẻ ở chế độ chỉ đọc: bạn có thể bình luận nhưng không thể sửa hoặc xuất file.',
  'fileViewer.copyShareLink': 'Copy link chia sẻ',
  'fileViewer.openSharePage': 'Mở trang chia sẻ',
  'fileViewer.shareLinkRequiresDeploy': 'Publish online trước để có link',
  'fileViewer.shareLinkPublishGuide': 'Publish online phía trên để bật chia sẻ ↑',
  'fileViewer.shareAfterGenerationComplete': 'Chia sẻ sau khi generation hoàn tất',
  'fileViewer.copyProviderLink': 'Copy link {provider}',
  'fileViewer.copyCloudflareLink': 'Copy link Cloudflare',
  'fileViewer.screenshotCopying': 'Đang copy screenshot...',
  'fileViewer.screenshotCopied': 'Đã copy screenshot vào clipboard',
  'fileViewer.screenshotClipboardDenied': 'Trình duyệt đã chặn quyền clipboard',
  'fileViewer.screenshotPreviewLoading': 'Preview vẫn đang tải. Thử lại sau một lát.',
  'fileViewer.screenshotCaptureFailed': 'Không chụp được preview. Vui lòng thử lại.',
  'fileViewer.exportPdf': 'Xuất PDF',
  'fileViewer.exportPdfAllSlides': 'Xuất PDF (tất cả slide)',
  'fileViewer.exportPptxBusy': 'Chờ lượt hiện tại hoàn tất.',
  'fileViewer.exportPptxHint': 'Gửi yêu cầu cho agent để chuyển thiết kế này thành PPTX.',
  'fileViewer.exportPptxNa': 'Xuất PPTX không khả dụng ở đây.',
  'fileViewer.exportZip': 'Tải xuống .zip',
  'fileViewer.exportHtml': 'Xuất HTML độc lập',
  'fileViewer.exportMd': 'Xuất Markdown',
  'fileViewer.exportImage': 'Xuất ảnh',
  'fileViewer.exportPptxImages': 'Xuất PPTX (ảnh)',
  'fileViewer.exportPptxEditable': 'Xuất PPTX (có thể sửa)',
  'fileViewer.exportPptxEditableHint': 'Shape và text native có thể sửa (không pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': 'Chọn cách xuất rồi tải xuống.',
  'fileViewer.exportPptxScreenshot': 'PPTX screenshot',
  'fileViewer.exportPptxScreenshotHint': 'Mỗi slide là một ảnh, pixel-perfect nhưng không sửa được.',
  'fileViewer.exportPptxConfirm': 'Xuất file',
  'fileViewer.exportPptxRecommended': 'Khuyến nghị',
  'fileViewer.exportingProgress': 'Đang xuất...',
  'fileViewer.exportSlideProgress': 'Đang xuất slide {current}/{total}...',
  'fileViewer.exportingElapsed': 'Đang xuất... {seconds}s',
  'fileViewer.exportSlideEta': 'Đang xuất slide {current}/{total} · còn khoảng {seconds}s',
  'fileViewer.exportFailed': 'Xuất file thất bại. Vui lòng thử lại.',
  'fileViewer.exportDone': 'Xuất file hoàn tất',
  'fileViewer.exportImageFailed': 'Chụp ảnh thất bại. Vui lòng thử lại hoặc dùng công cụ screenshot của trình duyệt.',
  'fileViewer.exportImageModalSubtitle': 'Chọn định dạng rồi tải bản xem trước hiện tại thành ảnh.',
  'fileViewer.exportImageFormatLabel': 'Định dạng',
  'fileViewer.exportImageSaving': 'Đang lưu ảnh...',
  'fileViewer.exportImageSaved': 'Đã lưu ảnh',
  'fileViewer.exportImageDownloadStarted': 'Đã bắt đầu tải xuống',
  'fileViewer.exportImageDownloadDetails': '{filename} nằm trong thư mục downloads của trình duyệt nếu không hiện hộp thoại Save As.',
  'fileViewer.exportJsx': 'Xuất JSX',
  'fileViewer.exportReactHtml': 'Xuất bản xem trước thành HTML',
  'fileViewer.exportStarted': 'Đã bắt đầu xuất',
  'fileViewer.saveAsTemplate': 'Lưu làm mẫu...',
  'fileViewer.savingTemplate': 'Đang lưu mẫu...',
  'fileViewer.savedTemplate': 'Đã lưu thành "{name}"',
  'fileViewer.savedTemplateFail': 'Không lưu được mẫu, hãy thử lại.',
  'fileViewer.templateNamePrompt': 'Tên mẫu',
  'fileViewer.templateNameDefault': 'Mẫu chưa đặt tên',
  'fileViewer.templateDescPrompt': 'Mô tả ngắn (tùy chọn, mẫu này hữu ích ở điểm nào?)',
  'fileViewer.deployToVercel': 'Deploy lên Vercel',
  'fileViewer.redeployToVercel': 'Deploy lại',
  'fileViewer.deployingToVercel': 'Đang deploy lên Vercel...',
  'fileViewer.deployProviderLabel': 'Provider',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Đích',
  'fileViewer.deployTargetPreview': 'Preview',
  'fileViewer.deployTargetProduction': 'Production',
  'fileViewer.deployToProvider': 'Deploy lên {provider}',
  'fileViewer.redeployToProvider': 'Deploy lại lên {provider}',
  'fileViewer.deployingToProvider': 'Đang deploy lên {provider}...',
  'fileViewer.preparingPublicLink': 'Đang chuẩn bị link công khai...',
  'fileViewer.copyDeployLink': 'Copy link',
  'fileViewer.deployModalTitle': 'Deploy',
  'fileViewer.deployModalSubtitle': 'Dùng tài khoản provider đã chọn để triển khai bản xem trước HTML này.',
  'fileViewer.vercelToken': 'Vercel token',
  'fileViewer.vercelTokenGetLink': 'Lấy Vercel token',
  'fileViewer.vercelTokenPlaceholder': 'Dán Vercel token',
  'fileViewer.vercelTokenReuseHint': 'Token đã lưu sẽ được dùng. Nhập token mới để thay thế.',
  'fileViewer.vercelTokenRequired': 'Nhập và lưu Vercel token trước.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API token',
  'fileViewer.cloudflareApiTokenGetLink': 'Lấy API token',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Dán Cloudflare API token',
  'fileViewer.cloudflareApiTokenReuseHint': 'Cloudflare API token đã lưu sẽ được dùng. Nhập token mới để thay thế.',
  'fileViewer.cloudflareApiTokenRequired': 'Nhập và lưu Cloudflare API token trước.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Chọn Pages Edit khi tạo API token; custom domain cần Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'Team ID',
  'fileViewer.vercelTeamSlug': 'Team slug',
  'fileViewer.cloudflareAccountId': 'Account ID',
  'fileViewer.cloudflareAccountIdHint': 'Tìm account ID trong Cloudflare dashboard.',
  'fileViewer.cloudflareAccountIdRequired': 'Nhập và lưu Cloudflare Account ID trước.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Lưu cài đặt Cloudflare để tải domain',
  'fileViewer.cloudflareZoneRequired': 'Chọn domain Cloudflare trước.',
  'fileViewer.cloudflareZonesLoading': 'Đang tải domain Cloudflare...',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domain',
  'fileViewer.cloudflareZonesLoadFailed': 'Không tải được domain Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Không tìm thấy full domain Cloudflare đang active cho account này.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Prefix subdomain',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Chỉ dùng một nhãn DNS: chữ thường, số và dấu gạch nối.',
  'fileViewer.cloudflareHostnamePreview': 'Preview custom domain: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Tùy chọn: gắn custom domain. Để trống vẫn tạo link pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Tùy chọn',
  'fileViewer.vercelPreviewOnly': 'Deploy hiện chỉ là Preview.',
  'fileViewer.cloudflarePagesPreviewHint': 'Deploy Cloudflare Pages dùng Direct Upload.',
  'fileViewer.savingConfig': 'Đang lưu...',
  'fileViewer.deployConfigSaveFailed': 'Không lưu được cài đặt Vercel.',
  'fileViewer.deployFailed': 'Deploy thất bại. Kiểm tra cài đặt Vercel rồi thử lại.',
  'fileViewer.deployProviderConfigSaveFailed': 'Không lưu được cài đặt {provider}.',
  'fileViewer.deployProviderFailed': 'Deploy {provider} thất bại. Kiểm tra cài đặt rồi thử lại.',
  'fileViewer.deployResultLabel': 'URL đã deploy',
  'fileViewer.deployLinkReady': 'Sẵn sàng',
  'fileViewer.deploySuccessToast': 'Tải deployment lên thành công',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Link công khai đang chờ',
  'fileViewer.deployLinkDelayed': 'Site đã deploy. Link công khai vẫn đang được chuẩn bị.',
  'fileViewer.deployLinkFailed': 'Custom domain thất bại',
  'fileViewer.deployLinkProtectedLabel': 'Deployment protection đang bật',
  'fileViewer.deployLinkProtected': 'Site đã deploy, nhưng link preview này đang yêu cầu xác thực. Tắt Deployment Protection hoặc dùng custom domain.',
  'fileViewer.retryLink': 'Thử lại ngay',
  'fileViewer.presentInTabDeckHint': 'Ghi chú thuyết trình trong cửa sổ popup',
  'fileViewer.presentEscHint': 'Nhấn Esc để thoát',
  'fileViewer.presenterPause': 'Tạm dừng',
  'fileViewer.presenterResume': 'Tiếp tục',
  'fileViewer.presenterPrevious': 'Trước',
  'fileViewer.presenterNext': 'Sau',

  'liveArtifact.refresh.button': 'Refresh',
  'liveArtifact.refresh.buttonTitle': 'Refresh live artifact này',
  'liveArtifact.refresh.loadingTitle': 'Đang tải live artifact...',
  'liveArtifact.refresh.noSourceTitle': 'Chưa có nguồn refresh.',
  'liveArtifact.refresh.running': 'Đang refresh...',
  'liveArtifact.refresh.runningMessage': 'Đang refresh dữ liệu và preview. Có thể mất một lát.',
  'liveArtifact.refresh.runningAction': 'Preview cũ vẫn hiển thị cho đến khi refresh thành công.',
  'liveArtifact.refresh.successOne': 'Refresh hoàn tất. Dữ liệu đã cập nhật.',
  'liveArtifact.refresh.successMany': 'Refresh hoàn tất. Dữ liệu đã cập nhật.',
  'liveArtifact.refresh.successAction': 'Preview đã được tải lại với dữ liệu commit mới nhất.',
  'liveArtifact.refresh.previousFailure': 'Lần refresh trước thất bại: {message}',
  'liveArtifact.refresh.failureAction': 'Xem Refresh history, sửa nguồn hoặc quyền truy cập rồi thử lại.',
  'liveArtifact.refresh.networkFailure': 'Request refresh thất bại. Kiểm tra kết nối rồi thử lại.',
  'liveArtifact.refresh.genericFailure': 'Refresh thất bại.',
  'liveArtifact.refresh.statusNever': 'Không thể refresh',
  'liveArtifact.refresh.statusReady': 'Sẵn sàng refresh',
  'liveArtifact.refresh.statusSucceeded': 'Đã cập nhật',
  'liveArtifact.refresh.statusFailed': 'Refresh thất bại',
  'liveArtifact.refresh.statusRunning': 'Đang refresh',
  'liveArtifact.refresh.statusRunningDescription': 'Một lượt refresh đang chạy.',
  'liveArtifact.refresh.statusSucceededDescription': 'Lần refresh gần nhất hoàn tất thành công.',
  'liveArtifact.refresh.statusFailedDescription': 'Lần refresh gần nhất không hoàn tất thành công.',
  'liveArtifact.refresh.statusReadyDescription': 'Đã cấu hình nguồn có thể refresh và hiện không có lượt chạy.',
  'liveArtifact.refresh.statusNeverDescription': 'Live artifact này chưa có nguồn refresh.',
  'liveArtifact.refresh.eventStarted': 'Đã bắt đầu',
  'liveArtifact.refresh.eventSucceeded': 'Thành công',
  'liveArtifact.refresh.eventFailed': 'Thất bại',
  'liveArtifact.refresh.eventStartedDetail': 'Refresh đã bắt đầu...',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} nguồn đã cập nhật',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} nguồn đã cập nhật',
  'liveArtifact.refresh.timelineEmpty': 'Chưa có hoạt động refresh trong phiên này. Bấm Refresh để ghi timeline hoặc chờ lượt tự động.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Refresh gần nhất',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Chưa bao giờ',
  'liveArtifact.refresh.justNow': 'vừa xong',
  'liveArtifact.refresh.factCreated': 'Đã tạo',
  'liveArtifact.refresh.factLastUpdated': 'Cập nhật gần nhất',
  'liveArtifact.refresh.factUnknown': 'Không rõ',
  'liveArtifact.refresh.persistedTitle': 'Lịch sử refresh đã lưu',
  'liveArtifact.refresh.persistedHint': 'Entry nạp từ refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Chưa có lịch sử refresh đã lưu.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'thành công',
  'liveArtifact.refresh.persistedStatusRunning': 'đang chạy',
  'liveArtifact.refresh.persistedStatusFailed': 'thất bại',
  'liveArtifact.refresh.persistedStatusCancelled': 'đã hủy',
  'liveArtifact.refresh.persistedStatusSkipped': 'đã bỏ qua',
  'liveArtifact.refresh.sessionTitle': 'Hoạt động phiên',
  'liveArtifact.refresh.sessionHint': 'Event ghi nhận khi tab này đang mở',
  'liveArtifact.refresh.docSourceTitle': 'Nguồn tài liệu',
  'liveArtifact.refresh.docSourceHint': 'Nguồn đã cấu hình',
  'liveArtifact.refresh.docSourceType': 'Loại',
  'liveArtifact.refresh.docSourceTool': 'Tool',
  'liveArtifact.refresh.docSourceConnector': 'Connector',
  'liveArtifact.refresh.debugSummary': 'Metadata debug nâng cao',
  'liveArtifact.refresh.debugNote': 'Có thể gồm connector ID, tên file, metadata nguồn và path artifact nội bộ.',
  'liveArtifact.viewer.tabPreview': 'Preview',
  'liveArtifact.viewer.tabCode': 'Code',
  'liveArtifact.viewer.tabData': 'Dữ liệu',
  'liveArtifact.viewer.tabRefreshHistory': 'Lịch sử refresh',
  'liveArtifact.viewer.dataEmpty': 'Không có cache data.json.',
  'liveArtifact.viewer.code.templateHeading': 'Template HTML',
  'liveArtifact.viewer.code.renderedHeading': 'HTML đã render',
  'liveArtifact.viewer.code.templateHelp': 'Template có thể sửa dùng với data.json để tạo preview.',
  'liveArtifact.viewer.code.renderedHelp': 'index.html được tạo và hiện đang nạp trong Preview.',
  'liveArtifact.viewer.code.variantAria': 'Biến thể code',
  'liveArtifact.viewer.code.variantTemplate': 'Template',
  'liveArtifact.viewer.code.variantRendered': 'Đã render',
  'liveArtifact.viewer.code.loading': 'Đang tải code...',
  'liveArtifact.viewer.code.unavailable': 'Code chưa khả dụng.',
  'liveArtifact.viewer.code.empty': 'File code này đang rỗng.',

  'manualEdit.layers': 'Layer',
  'manualEdit.editableCount': '{count} có thể sửa',
  'manualEdit.hiddenBadge': 'Ẩn',
  'manualEdit.title': 'Trình sửa thủ công',
  'manualEdit.fallbackTitle': 'Sửa',
  'manualEdit.movePanel': 'Di chuyển panel sửa',
  'manualEdit.editParams': 'Sửa tham số',
  'manualEdit.closePanel': 'Đóng panel sửa',
  'manualEdit.selectLayer': 'Chọn layer',
  'manualEdit.empty': 'Bấm một phần tử trong preview hoặc chọn layer.',
  'manualEdit.noEditableLayers': 'Không tìm thấy layer có thể sửa.',
  'manualEdit.noClass': 'không có class',
  'manualEdit.tabsAria': 'Tab sửa thủ công',
  'manualEdit.tabContent': 'Nội dung',
  'manualEdit.tabStyle': 'Style',
  'manualEdit.tabAttributes': 'Thuộc tính',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'Source',
  'manualEdit.attributesJson': 'JSON thuộc tính',
  'manualEdit.selectedHtml': 'HTML phần tử đang chọn',
  'manualEdit.fullSource': 'Source artifact đầy đủ',
  'manualEdit.applyContent': 'Áp dụng nội dung',
  'manualEdit.applyStyle': 'Áp dụng style',
  'manualEdit.applyAttributes': 'Áp dụng thuộc tính',
  'manualEdit.applyHtml': 'Áp dụng HTML',
  'manualEdit.applySource': 'Áp dụng source',
  'manualEdit.invalidAttributes': 'JSON thuộc tính không hợp lệ.',
  'manualEdit.changes': 'Thay đổi',
  'manualEdit.undo': 'Hoàn tác',
  'manualEdit.redo': 'Làm lại',
  'manualEdit.noChanges': 'Chưa có sửa thủ công.',
  'manualEdit.imageUrl': 'URL ảnh',
  'manualEdit.altText': 'Alt text',
  'manualEdit.label': 'Nhãn',
  'manualEdit.text': 'Text',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Màu chữ',
  'manualEdit.background': 'Nền',
  'manualEdit.fontSize': 'Cỡ chữ',
  'manualEdit.weight': 'Độ đậm',
  'manualEdit.align': 'Căn',
  'manualEdit.textAlignLeft': 'Căn trái',
  'manualEdit.textAlignCenter': 'Căn giữa',
  'manualEdit.textAlignRight': 'Căn phải',
  'manualEdit.padding': 'Padding',
  'manualEdit.margin': 'Margin',
  'manualEdit.radius': 'Bo góc',
  'manualEdit.referenceValues': 'Giá trị tham chiếu',
  'manualEdit.referenceValuesEmpty': 'Không có giá trị tham chiếu khớp',
  'manualEdit.referenceValuesLoading': 'Đang tải...',
  'manualEdit.lineHeight': 'Line height',
  'manualEdit.letterSpacing': 'Letter spacing',
  'manualEdit.borderStyle': 'Kiểu viền',
  'manualEdit.borderStyleSolid': 'Liền',
  'manualEdit.borderStyleDashed': 'Nét đứt',
  'manualEdit.borderStyleDotted': 'Chấm',
  'manualEdit.borderStyleDouble': 'Đôi',
  'manualEdit.borderStyleNone': 'Không',
  'manualEdit.border': 'Viền',
  'manualEdit.width': 'Rộng',
  'manualEdit.minHeight': 'Cao tối thiểu',
  'manualEdit.deleteElement': 'Xóa phần tử',
  'manualEdit.deleteElementConfirm': 'Xóa phần tử đang chọn? Có thể hoàn tác bằng Undo.',
  'manualEdit.alignCenter': 'Giữa',
  'manualEdit.opacity': 'Độ mờ',
  'manualEdit.uploadImage': 'Upload ảnh',
  'manualEdit.uploadingImage': 'Đang upload ảnh...',
  'manualEdit.uploadImageFailed': 'Không upload được ảnh.',
  'manualEdit.focusSlides': 'Tập trung slide',
  'manualEdit.showPanels': 'Hiện panel',
  'manualEdit.parameters': 'Tham số',
  'manualEdit.fontFamily': 'Font',
  'manualEdit.borderColor': 'Màu viền',
  'manualEdit.borderWidth': 'Độ dày viền',
  'manualEdit.height': 'Cao',
  'manualEdit.sideTop': 'Trên',
  'manualEdit.sideBottom': 'Dưới',
  'manualEdit.sideLeft': 'Trái',
  'manualEdit.sideRight': 'Phải',
  'manualEdit.layoutDirection': 'Hướng',
  'manualEdit.distribution': 'Phân bố',
  'manualEdit.gap': 'Khoảng cách',
  'manualEdit.layoutUnavailable': 'Control layout chỉ có cho container flex hoặc grid.',
  'manualEdit.directionRow': 'Ngang',
  'manualEdit.directionRowReverse': 'Ngang đảo',
  'manualEdit.directionColumn': 'Dọc',
  'manualEdit.directionColumnReverse': 'Dọc đảo',
  'manualEdit.justifyStart': 'Đầu',
  'manualEdit.justifyCenter': 'Giữa',
  'manualEdit.justifyEnd': 'Cuối',
  'manualEdit.justifyBetween': 'Giãn giữa',
  'manualEdit.justifyAround': 'Giãn quanh',
  'manualEdit.justifyEvenly': 'Giãn đều',
  'manualEdit.alignStart': 'Đầu',
  'manualEdit.alignEnd': 'Cuối',
  'manualEdit.alignStretch': 'Kéo giãn',
  'manualEdit.alignBaseline': 'Baseline',
  'manualEdit.sectionImage': 'ẢNH',
  'manualEdit.sectionContent': 'NỘI DUNG',
  'manualEdit.sectionPage': 'TRANG',
  'manualEdit.pageBackground': 'Nền',
  'manualEdit.pageBaseSize': 'Kích thước gốc',
  'manualEdit.pageStylesHtmlOnly': 'Style trang chỉ có cho tài liệu HTML đầy đủ.',

  'automations.eyebrow': 'Phiên agent theo lịch',
  'automations.title': 'Automation',
  'automations.lede': 'Lên lịch cuộc trò chuyện lặp lại cho project, digest Orbit và live artifact.',
  'automations.summaryAria': 'Tóm tắt automation',
  'automations.metricActive': 'Đang hoạt động',
  'automations.metricPaused': 'Tạm dừng',
  'automations.metricTemplates': 'Template',
  'automations.newAutomation': 'Automation mới',
  'automations.yourAutomations': 'Automation của bạn',
  'automations.loading': 'Đang tải',
  'automations.emptyTitle': 'Chưa có automation',
  'automations.emptyBody': 'Tạo từ template hoặc bắt đầu bằng lịch trống.',
  'automations.targetNewEachRun': 'Project mới mỗi lượt chạy',
  'automations.targetCreateEachRun': 'Project mới mỗi lượt chạy',
  'automations.lastRun': 'Lần chạy gần nhất {time}',
  'automations.openResult': 'Mở kết quả',
  'automations.run': 'Chạy',
  'automations.runNowTitle': 'Chạy ngay và mở cuộc trò chuyện',
  'automations.history': 'Lịch sử',
  'automations.hideHistory': 'Ẩn lịch sử',
  'automations.edit': 'Sửa',
  'automations.pause': 'Tạm dừng',
  'automations.resume': 'Tiếp tục',
  'automations.deleteAria': 'Xóa automation',
  'automations.deleteTitle': 'Xóa automation này',
  'automations.deleteConfirm': 'Xóa automation này? Các lượt chạy cũ và project của chúng vẫn được giữ.',
  'automations.proposalsTitle': 'Đề xuất tiến hóa',
  'automations.proposalsSub': 'Review output automation trước khi nó thay đổi memory, skill hoặc design system.',
  'automations.proposalsPending': '{n} đang chờ',
  'automations.apply': 'Áp dụng',
  'automations.reject': 'Từ chối',
  'automations.proposalsDismissReason': 'Đã bỏ qua trong Automations',
  'automations.templatesTitle': 'Template',
  'automations.templatesSub': 'Orbit và live artifact là template trong cùng flow automation.',
  'automations.templatesCount': '{filtered} / {total}',
  'automations.templateFiltersAria': 'Bộ lọc template',
  'automations.templatesEmptyTitle': 'Chưa có template trong nhóm này.',
  'automations.templatesEmptyBody': 'Thử bộ lọc khác hoặc bắt đầu từ automation trống.',
  'automations.useTemplate': 'Dùng template',
  'automations.runHistoryLoading': 'Đang tải lịch sử chạy...',
  'automations.runHistoryEmpty': 'Chưa có lượt chạy.',
  'automations.runHistoryTitle': 'Lịch sử chạy',
  'automations.runHistoryLatest': '10 lượt gần nhất',
  'automations.crystallize': 'Crystallize',
  'automations.crystallizing': 'Đang crystallize',
  'automations.crystallizeTitle': 'Tạo nháp đề xuất skill và memory từ lượt chạy này',
  'automations.crystallizeFailed': 'Crystallize thất bại: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize đã tạo đề xuất, nhưng Automations không refresh được danh sách. Review các đề xuất đang thấy hoặc thử refresh.',
  'automations.crystallizeRefreshFailed': 'Crystallize hoàn tất, nhưng Automations không refresh được đề xuất. Thử refresh trước khi chạy lại.',
  'automations.crystallizeNoProposals': 'Crystallize hoàn tất nhưng không trả về đề xuất. Thử refresh hoặc kiểm tra chi tiết lượt chạy.',
  'automations.openConversation': 'Mở cuộc trò chuyện',
  'automations.runHistoryAria': 'Lịch sử chạy automation',
  'automations.proposalsAria': 'Đề xuất tiến hóa automation',
  'automations.templatesAria': 'Template automation',
  'automations.runInProgress': 'Đang chạy',
  'automations.promptPlaceholder': 'Lấy hoạt động GitHub + Linear hôm qua và tóm tắt thay đổi.',
  'automations.scheduleStatusPaused': 'Tạm dừng',
  'automations.nextRunManualOnly': 'Chỉ thủ công',
  'automations.nextRunScheduled': 'Theo lịch',
  'automations.nextRunAt': 'Tiếp theo {time}',
  'automations.statusSucceeded': 'Thành công',
  'automations.statusFailed': 'Thất bại',
  'automations.statusRunning': 'Đang chạy',
  'automations.statusQueued': 'Đang chờ',
  'automations.statusCanceled': 'Đã hủy',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Live artifact',
  'automations.kindAutomation': 'Automation',
  'automations.proposalTargetMemory': 'Memory',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Template automation',
  'automations.proposalActionCreate': 'Tạo',
  'automations.proposalActionUpdate': 'Cập nhật',
  'automations.proposalActionMerge': 'Merge',
  'automations.proposalActionMove': 'Di chuyển',
  'automations.proposalActionDelete': 'Xóa',
  'automations.proposalActionPromote': 'Promote',
  'automations.filterAll': 'Tất cả',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Live artifact',
  'automations.filterMemory': 'Memory',
  'automations.filterDesignSystems': 'Design system',
  'automations.filterSkills': 'Skill',
  'automations.filterConnectors': 'Connector',
  'automations.filterCompression': 'Nén',
  'automations.filterRelease': 'Release',
  'automations.filterQuality': 'Chất lượng',
  'automations.tpl.memoryRefresh.title': 'Refresh memory project từ công việc gần đây.',
  'automations.tpl.memoryRefresh.desc': 'Biến quyết định, sở thích và feedback lặp lại thành cập nhật memory dùng lại được.',
  'automations.tpl.designSystemRefresh.title': 'Cập nhật design system từ artifact đã ship.',
  'automations.tpl.designSystemRefresh.desc': 'Tìm token, component và rule có thể tái dùng trong các thiết kế gần đây.',
  'automations.tpl.liveArtifactRegistry.title': 'Audit live artifact và refresh phiên bản cũ.',
  'automations.tpl.liveArtifactRegistry.desc': 'Giữ dashboard, report và preview bền vững luôn mới thay vì tạo bản trùng lặp.',
  'automations.tpl.orbitDashboard.title': 'Tạo dashboard hoạt động connector.',
  'automations.tpl.orbitDashboard.desc': 'Gộp các connector đã chọn vào dashboard live kiểu Orbit.',
  'automations.tpl.releaseNotes.title': 'Soạn release note từ thiết kế đã ship.',
  'automations.tpl.releaseNotes.desc': 'Kết nối PR đã merge, artifact và thay đổi sản phẩm thành release note.',
  'automations.tpl.qualityRegressionWatch.title': 'Theo dõi regression thiết kế và implementation.',
  'automations.tpl.qualityRegressionWatch.desc': 'So sánh thay đổi gần đây với benchmark, trace và reference đã chấp nhận.',
  'automations.tpl.orbitDaily.title': 'Digest connector hằng ngày.',
  'automations.tpl.orbitDaily.desc': 'Refresh digest hoạt động connector theo lịch.',
  'automations.tpl.liveStatusBoard.title': 'Giữ live status artifact luôn mới.',
  'automations.tpl.liveStatusBoard.desc': 'Cập nhật một artifact bền vững thay vì tạo report mới mỗi lượt chạy.',

  'home.recommendation.eyebrow': 'Gợi ý cho bạn',
  'home.recommendation.primaryCta': 'Bắt đầu tạo',
  'home.recommendation.change': 'Thử gợi ý khác',
  'home.recommendation.browseAll': 'Tất cả loại',
  'home.recommendation.defaultProjectName': 'Project mới',
  'home.recommendation.startFailed': 'Không thể bắt đầu tạo. Vui lòng thử lại.',
  'home.starter.product_ui_prototype.title': 'Bắt đầu với prototype sản phẩm có thể sửa',
  'home.starter.product_ui_prototype.desc': 'Dựa trên mục tiêu của bạn, bắt đầu bằng giao diện có thể click và tinh chỉnh.',
  'home.starter.product_ui_prototype.firstPrompt': 'Thiết kế prototype sản phẩm có thể sửa cho [your product] với các màn hình chính và flow chính rõ ràng.',
  'home.starter.product_ui_component.title': 'Bắt đầu từ component tái dùng',
  'home.starter.product_ui_component.desc': 'Tạo một component trước, rồi ghép thành màn hình đầy đủ.',
  'home.starter.product_ui_component.firstPrompt': 'Thiết kế component [component name] có thể tái dùng với các state và variant chính.',
  'home.starter.product_ui_lowfi.title': 'Bắt đầu với prototype low-fidelity',
  'home.starter.product_ui_lowfi.desc': 'Phác cấu trúc trước, rồi nâng độ hoàn thiện sau.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Tạo wireframe low-fidelity cho các màn hình chính của [your product].',
  'home.starter.marketing_landing.title': 'Bắt đầu với landing page',
  'home.starter.marketing_landing.desc': 'Biến campaign thành landing page có thể ship.',
  'home.starter.marketing_landing.firstPrompt': 'Thiết kế landing page cho [your product] với hero, lợi ích chính và call to action rõ ràng.',
  'home.starter.marketing_multivariant.title': 'Bắt đầu với nhiều variant landing',
  'home.starter.marketing_multivariant.desc': 'Tạo vài phiên bản để so sánh trước khi chốt.',
  'home.starter.marketing_multivariant.firstPrompt': 'Tạo 3 variant landing page cho [your product] với thông điệp hero khác nhau để so sánh.',
  'home.starter.internal_dashboard.title': 'Bắt đầu với dashboard nội bộ',
  'home.starter.internal_dashboard.desc': 'Khởi đầu từ layout dashboard cho workflow của bạn.',
  'home.starter.internal_dashboard.firstPrompt': 'Thiết kế dashboard nội bộ hiển thị [key metrics] với bộ lọc và bảng dữ liệu.',
  'home.starter.internal_report.title': 'Bắt đầu với report',
  'home.starter.internal_report.desc': 'Mô tả dữ liệu và field bạn muốn xem.',
  'home.starter.internal_report.firstPrompt': 'Tạo trang report tóm tắt [describe the data, fields, and metrics you care about].',
  'home.starter.general_menu.title': 'Bắt đầu với project đầu tiên',
  'home.starter.general_menu.desc': 'Mô tả điều bạn muốn và chúng tôi sẽ tạo phiên bản đầu có thể sửa.',
  'home.starter.general_menu.firstPrompt': 'Tạo phiên bản đầu có thể sửa của [describe what you want to make].',

  'homeHero.templatesScrollHint': 'Cuộn lên để xem thêm mẫu',
  'homeHero.templatesCollapse': 'Thu gọn mẫu',
  'homeHero.subtitlePrefix': 'Giải pháp thay thế Claude Design dạng source-available.',
  'homeHero.carousel.onePageBrief': 'Soạn brief project một trang',
  'homeHero.carousel.notesToDeck': 'Biến ghi chú của tôi thành bài trình chiếu',
  'homeHero.carousel.signupFlow': 'Mockup flow đăng ký',
  'homeHero.carousel.improveBrief': 'Cải thiện brief project hiện có',
  'homeHero.carousel.loadingAnimation': 'Tạo animation loading',
  'homeHero.carousel.teamUpdateSlides': 'Thiết kế slide cập nhật team',
  'homeHero.carousel.ordersDashboard': 'Prototype dashboard theo dõi đơn hàng',
  'homeHero.carousel.productDetail': 'Dàn layout trang chi tiết sản phẩm',
  'homeHero.carousel.caseStudy': 'Lập dàn ý case study',
  'homeHero.carousel.landingIntro': 'Thiết kế intro ngắn cho landing page',
  'homeHero.carousel.pitchDeck': 'Tạo pitch deck cho sản phẩm mới',
  'homeHero.carousel.appIdea': 'Mô tả ý tưởng app',
  'homeHero.carousel.landingLayout': 'Phác layout landing page',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePluginAria': 'Gỡ plugin {title}',
  'homeHero.contextSurfaces': 'Bề mặt context',
  'homeHero.footer.autoDesignSystemSummary': 'Tự động khớp hệ thiết kế và phong cách visual tốt nhất cho nội dung hiện tại.',
  'homeHero.railAria': 'Chọn category project hoặc shortcut bắt đầu',
  'homeHero.subTypeAria': 'Chọn subtype',
  'homeHero.subTypeMore': 'Thêm',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'Trải nghiệm WebGL',
  'homeHero.chip.webglDesc': 'Shader, 3D và visual GPU sinh động',
  'homeHero.chip.worker': 'Worker visualizer',
  'homeHero.chip.workerDesc': 'Mô phỏng off-thread, particle và data viz',
  'homeHero.chip.createBrandKit': 'Tạo hệ thiết kế',
  'homeHero.chip.liveArtifactHint': 'Tạo tài liệu HTML/CSS/JS tương tác có thể xem trước trực tiếp.',
  'homeHero.chip.hyperframesHint': 'Soạn motion dựa trên HTML: caption, visual phản ứng âm thanh, chuyển cảnh.',
  'homeHero.chip.createBrandKitHint': 'Trích xuất hệ thiết kế từ website rồi áp dụng trong mọi chat.',
  'homeHero.chip.createPluginHint': 'Tạo tiện ích EduDeck tái dùng và thêm vào mục tiện ích của tôi.',
  'homeHero.chip.figmaHint': 'Chuyển frame Figma vào hệ thiết kế đang dùng.',
  'homeHero.chip.folderHint': 'Nhập thư mục local hiện có và tiếp tục chỉnh sửa.',
  'homeHero.chip.templateHint': 'Bắt đầu từ mẫu đi kèm.',
  'homeHero.chip.wireframe': 'Khung dây',
  'homeHero.chip.prototypeDesc': 'Mockup app tương tác',
  'homeHero.chip.webCloneDesc': 'Tái dựng website ưu tiên source',
  'homeHero.chip.wireframeDesc': 'Màn hình và luồng lo-fi',
  'homeHero.chip.mobileDesc': 'Màn hình iOS và Android',
  'homeHero.chip.deckDesc': 'Bài trình bày, bài giảng và pitch deck',
  'homeHero.chip.documentDesc': 'CV, report và PDF',
  'homeHero.chip.imageDesc': 'Poster, graphic và art',
  'homeHero.chip.videoDesc': 'Clip, reel và promo',
  'homeHero.chip.audioDesc': 'Voiceover, nhạc và SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphic và loop',
  'homeHero.chip.liveArtifactDesc': 'Dashboard trực tiếp có dữ liệu',
  'homeHero.chip.createBrandKitDesc': 'Trích xuất hệ thiết kế thương hiệu',
  'homeHero.chip.prototypeNext': 'Mở chat tạo bản mẫu web hoàn thiện cao có thể click và tinh chỉnh từng lượt.',
  'homeHero.chip.webCloneNext': 'Mở chat hỏi URL mục tiêu, dựng lại website và audit bản clone.',
  'homeHero.chip.wireframeNext': 'Mở chat phác màn hình và flow lo-fi để kiểm chứng cấu trúc trước.',
  'homeHero.chip.mobileNext': 'Mở chat dàn layout màn hình mobile cho iOS và Android.',
  'homeHero.chip.deckNext': 'Mở chat tạo slides có thể trình chiếu và export.',
  'homeHero.chip.documentNext': 'Mở chat soạn tài liệu hoàn thiện như CV, report hoặc PDF.',
  'homeHero.chip.imageNext': 'Mở chat tạo ảnh đúng brand để lặp lại.',
  'homeHero.chip.videoNext': 'Mở chat tạo video ngắn có thể tinh chỉnh.',
  'homeHero.chip.audioNext': 'Mở chat tạo voiceover, nhạc hoặc sound effect.',
  'homeHero.chip.webClonePromptSeed': 'URL website cần clone: ',

  'newproj.toggleSpeakerNotesHint': 'Giảm chữ trên slide, để ý chính trong notes.',
  'newproj.toggleAnimationsHint': 'Thêm motion như entrance, hover, transition trên mẫu.',
  'newproj.targetPlatformsHint': 'Chọn một hoặc nhiều. Responsive web chỉ phủ breakpoint trình duyệt; thêm iOS, Android, tablet app hoặc desktop app nếu cần variant native.',
  'newproj.platform.responsive.label': 'Web responsive',
  'newproj.platform.responsive.hint': 'Một trải nghiệm web thích ứng desktop, tablet và mobile browser',
  'newproj.platform.webDesktop.label': 'Desktop web',
  'newproj.platform.webDesktop.hint': 'Sản phẩm hoặc landing page ưu tiên browser',
  'newproj.platform.mobileIos.label': 'App iOS',
  'newproj.platform.mobileIos.hint': 'Frame iPhone và quy tắc tương tác iOS',
  'newproj.platform.mobileAndroid.label': 'App Android',
  'newproj.platform.mobileAndroid.hint': 'Frame Pixel và quy tắc tương tác Material',
  'newproj.platform.tablet.label': 'App tablet',
  'newproj.platform.tablet.hint': 'Trải nghiệm tablet kiểu native với split view',
  'newproj.platform.desktopApp.label': 'App desktop',
  'newproj.platform.desktopApp.hint': 'Chrome app macOS/Windows',
  'newproj.includeLandingPage': 'Gồm landing page',
  'newproj.includeLandingPageHint': 'Thêm trang marketing responsive cho ads, waitlist, launch campaign, tải app hoặc giải thích sản phẩm.',
  'newproj.includeOsWidgets': 'Gồm OS widget',
  'newproj.includeOsWidgetsHint': 'Thêm widget màn hình chính, màn hình khóa hoặc truy cập nhanh kiểu native cho mobile/tablet app.',
  'newproj.includeOsWidgetsDisabledHint': 'Khả dụng khi chọn iOS, Android hoặc tablet app làm target platform.',
  'newproj.locationExternalBase': 'Base bên ngoài',
  'newproj.importClaudeZip': 'Nhập Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Nhập file export .zip từ Claude Design',
  'newproj.importingClaudeZip': 'Đang import...',
  'newproj.dsNoneSubtitleEmpty': 'Không dùng system token, tự chọn palette',
  'newproj.dsNoneSubtitleSelected': 'Bỏ qua system token. Agent tự chọn palette.',
  'newproj.dsCategoryFallback': 'Hệ thiết kế',
  'newproj.dsModeAria': 'Chế độ chọn',
  'newproj.dsModeSingle': 'Một',
  'newproj.dsModeMulti': 'Nhiều',
  'newproj.dsNoneTitle': 'Không dùng - freeform',
  'newproj.dsNoneSub': 'Bỏ qua system token. Agent tự chọn palette.',
  'newproj.dsFootSingular': 'chỉ dùng làm cảm hứng.',
  'newproj.dsFootPlural': 'chỉ dùng làm cảm hứng.',
  'newproj.dsBadgeDefault': 'MẶC ĐỊNH',
  'newproj.dsPrimaryFallback': 'Chính',
  'newproj.surfaceImage': 'Ảnh',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Âm thanh',
  'newproj.modelMissingTitle': 'Chọn model',
  'newproj.modelMissingSub': 'Chọn model xử lý bề mặt này.',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.connectorsCountOne': '{n} đã kết nối',
  'newproj.connectorsCountMany': '{n} đã kết nối',
  'newproj.promptTemplateNoneTitle': 'Không dùng - tự viết',
  'newproj.promptTemplateNoneSub': 'Bỏ qua gallery, tự mô tả brief',
  'newproj.promptTemplateRefSub': 'Mẫu tham chiếu',
  'newproj.promptTemplateBodyLabel': 'Prompt (có thể chỉnh)',
  'newproj.promptTemplateOptimizeHint': 'Sửa tùy ý, thay đổi của bạn sẽ đi vào brief cho agent.',
  'newproj.promptTemplateBodyEmpty': 'Body rỗng, agent sẽ không có mẫu tham chiếu.',
  'newproj.deleteTemplateTitle': 'Xóa mẫu',
  'newproj.deleteTemplateConfirm': 'Xóa "{name}"? Không thể hoàn tác.',
  'newproj.deleteTemplateConfirmCta': 'Xóa mẫu',
  'newproj.deleteTemplateError': 'Không xóa được mẫu này. Vui lòng thử lại.',

  'workspace.designFiles': 'File thiết kế',
  'workspace.focusMode': 'Chế độ tập trung',
  'workspace.showChat': 'Hiện chat',
  'workspace.closeTab': 'Đóng tab',
  'workspace.fileSyncDownloading': 'Đang tải file xuống...',
  'workspace.fileSyncUploading': 'Đang upload file...',
  'workspace.deleteFileConfirm': 'Xóa file {name}?',
  'workspace.readonlyNotice': 'Project này đang ở chế độ chỉ đọc.',
  'workspace.readonlyNoticeBy': 'Dự án này đang ở chế độ chỉ đọc bởi {owner}.',
  'workspace.deleteSelectedFilesConfirm': 'Xóa {n} file đã chọn?',
  'workspace.deleteSelectedFilesPartial': '{n} file đã chọn không thể xóa.',
  'workspace.openFromDesignFiles': 'Mở từ File thiết kế',
  'workspace.designFilesLink': 'File thiết kế',
  'workspace.loadingSketch': 'Đang tải sketch...',
  'workspace.newTab': 'Tab mới',
  'workspace.searchFilesPlaceholder': 'Tìm file...',
  'workspace.openTabs': 'Tab đang mở',
  'workspace.searchTabs': 'Tìm tab',
  'workspace.noTabsFound': 'Không tìm thấy tab.',
  'workspace.openFile': 'Mở file',
  'workspace.noFilesMatch': 'Không có file khớp.',
  'workspace.allFiles': 'Tất cả file',
  'workspace.createNew': 'Tạo mới',
  'workspace.tabOpen': 'Đang mở',
  'workspace.sideChatContextBanner': 'Chat bên cạnh đang dùng context từ tab hiện tại.',
  'workspace.sideChatDefaultTitle': 'Chat bên cạnh',
  'workspace.newTerminal': 'Terminal mới',
  'workspace.newTerminalDescription': 'Mở terminal trong workspace project.',
  'workspace.newBrowser': 'Browser mới',
  'workspace.newBrowserDescription': 'Mở browser preview cạnh workspace.',
  'workspace.newSketchDescription': 'Tạo sketch mới.',
  'workspace.terminalStarting': 'Đang khởi động terminal',
  'workspace.terminalStartingDescription': 'Đang chuẩn bị phiên terminal...',
  'workspace.terminalSessionEnded': 'Phiên terminal đã kết thúc.',
  'workspace.terminalReconnecting': 'Đang kết nối lại terminal...',
  'workspace.terminalStartFailed': 'Không khởi động được terminal.',
  'workspace.terminalRestart': 'Khởi động lại terminal',
  'workspace.pages': 'Trang',
  'workspace.allProjectFiles': 'Tất cả file project',
  'workspace.newBlankPage': 'Trang trắng mới',
  'workspace.noPagesYet': 'Chưa có trang.',
  'workspace.pageCreateFailed': 'Không tạo được trang.',
  'workspace.pageCreatorTitle': 'Tạo trang',
  'workspace.pageCreatorSearch': 'Tìm template',
  'workspace.pageCreatorCategoryAll': 'Tất cả scene',
  'workspace.pageCreatorEmpty': 'Không có loại trang nào khớp tìm kiếm.',
  'workspace.pageCreatorPreview': 'Preview',
  'workspace.pageCreatorUse': 'Dùng',

  'assistant.role': 'Assistant',
  'assistant.workingLabel': 'Đang làm',
  'assistant.doneLabel': 'Xong',
  'assistant.copyMarkdown': 'Copy markdown phản hồi',
  'assistant.forkConversation': 'Fork cuộc trò chuyện',
  'assistant.forkingConversation': 'Đang fork cuộc trò chuyện...',
  'assistant.shareToEduDeck': 'Chia sẻ tới EduDeck',
  'assistant.shareToEduDeckBusy': 'Đang chia sẻ...',
  'assistant.feedbackPrompt': 'Phản hồi này thế nào?',
  'assistant.feedbackPositive': 'Tốt',
  'assistant.feedbackNegative': 'Chưa tốt',
  'assistant.feedbackReasonTitle': 'Cho biết lý do',
  'assistant.feedbackReasonPositiveMatched': 'Đúng yêu cầu',
  'assistant.feedbackReasonPositiveVisual': 'Visual tốt',
  'assistant.feedbackReasonPositiveUseful': 'Hữu ích',
  'assistant.feedbackReasonPositiveEasy': 'Dễ chỉnh sửa',
  'assistant.feedbackReasonPositiveDesignSystem': 'Đúng design system',
  'assistant.feedbackReasonNegativeMissed': 'Lệch yêu cầu',
  'assistant.feedbackReasonNegativeVisual': 'Visual chưa tốt',
  'assistant.feedbackReasonNegativeIncomplete': 'Chưa hoàn chỉnh',
  'assistant.feedbackReasonNegativeHard': 'Khó chỉnh sửa',
  'assistant.feedbackReasonNegativeDesignSystem': 'Sai design system',
  'assistant.feedbackReasonOther': 'Khác',
  'assistant.feedbackReasonPlaceholder': 'Thêm ghi chú...',
  'assistant.feedbackReasonSubmit': 'Gửi phản hồi',
  'assistant.emptyResponseLabel': 'Phản hồi rỗng',
  'assistant.emptyResponseMessage': 'Agent không trả về nội dung.',
  'assistant.unfinishedLabel': 'Chưa hoàn tất',
  'assistant.unfinishedSummary': 'Phản hồi có thể chưa hoàn tất. Còn {n} phần.',
  'assistant.unfinishedMore': 'Xem thêm {n}',
  'assistant.continueRemaining': 'Tiếp tục phần còn lại',
  'assistant.outTokens': 'Ra {n}',
  'assistant.producedFiles': 'File đã tạo',
  'assistant.openFile': 'Mở file',
  'assistant.downloadFile': 'Tải file',
  'assistant.thinking': 'Đang suy nghĩ',
  'assistant.thought': 'Suy nghĩ',
  'assistant.thoughtFor': 'Suy nghĩ trong {s}s',
  'assistant.systemReminder': 'Nhắc từ hệ thống',
  'assistant.possiblePromptInjection': 'Có thể là prompt injection',
  'assistant.waitingFirstOutput': 'Đang chờ output đầu tiên',
  'assistant.statusBootingAgent': 'Đang khởi động agent',
  'assistant.statusPreparing': 'Đang chuẩn bị',
  'assistant.statusStarting': 'Đang bắt đầu',
  'assistant.statusRequesting': 'Đang gửi request',
  'assistant.statusThinking': 'Đang suy nghĩ',
  'assistant.statusStreaming': 'Đang stream',
  'assistant.slowHint': 'Tác vụ này đang mất nhiều thời gian hơn bình thường.',
  'assistant.verbEditing': 'đang sửa',
  'assistant.verbWriting': 'đang ghi',
  'assistant.verbReading': 'đang đọc',
  'assistant.verbSearching': 'đang tìm',
  'assistant.verbRunning': 'đang chạy',
  'assistant.verbTodos': 'đang cập nhật todo',
  'assistant.verbFetching': 'đang fetch',
  'assistant.verbCalling': 'đang gọi tool',

  'mcpClient.title': 'MCP Client',
  'mcpClient.subtitle': 'Cấu hình server MCP được forward vào agent.',
  'mcpClient.addServer': 'Thêm server',
  'mcpClient.emptyTitle': 'Chưa có server MCP',
  'mcpClient.emptyBody': 'Thêm server để agent có thể gọi tool MCP.',
  'mcpClient.saveChanges': 'Lưu thay đổi',
  'mcpClient.storedAt': 'Đã lưu',
  'mcpClient.daemonError': 'Không kết nối được daemon.',
  'mcpClient.saveFailed': 'Không lưu được cấu hình MCP.',
  'mcpClient.forwardedToLabel': 'Đang forward tới',
  'mcpClient.notForwardedToLabel': 'Chưa forward tới',
  'mcpClient.forwardedAcpNote': 'Server này được forward vào ACP agent.',
  'mcpClient.notForwardedNote': 'Server này đang không được forward vào agent.',

  'recentProjects.title': 'Project gần đây',
  'recentProjects.viewAll': 'Xem tất cả',
  'recentProjects.empty': 'Chưa có project gần đây.',
  'recentProjects.ownerAll': 'Tất cả owner',
  'recentProjects.ownerMine': 'Của tôi',
  'recentProjects.ownerOthers': 'Của người khác',
  'recentProjects.kindAll': 'Tất cả loại',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Khác',
  'recentProjects.inviteTeammates': 'Mời đồng đội',
  'recentProjects.multiSelect': 'Chọn nhiều',
  'recentProjects.sortAria': 'Sắp xếp project',
  'recentProjects.sortNewest': 'Mới nhất',
  'recentProjects.sortOldest': 'Cũ nhất',
  'recentProjects.sortName': 'Theo tên',
  'recentProjects.viewList': 'Xem dạng danh sách',
  'recentProjects.sharedBadge': 'Đã chia sẻ',
  'recentProjects.sharedProjectFallbackName': 'Project được chia sẻ',
  'recentProjects.creatorLine': 'Tạo bởi {name}',
  'recentProjects.selfCreator': 'bạn',
  'recentProjects.teamMemberCreator': 'member team',
  'recentProjects.ownOnlyMutation': 'Chỉ owner mới có thể đổi nơi lưu project.',
  'recentProjects.shareInProgress': 'Đang chia sẻ...',
  'recentProjects.sharedInTeam': 'Đã ở team',
  'recentProjects.moveToTeam': 'Chuyển vào team',
  'recentProjects.moveToTeamDescPre': 'Chuyển ',
  'recentProjects.moveToTeamDescStrong': 'Dự án này',
  'recentProjects.moveToTeamDescPost': ' vào team workspace?',
  'recentProjects.moveToPersonalDescPre': 'Chuyển ',
  'recentProjects.moveToPersonalDescStrong': 'Dự án này',
  'recentProjects.moveToPersonalDescPost': ' về Personal?',
  'recentProjects.moveDontRemind': 'Đừng nhắc lại',
  'recentProjects.confirmMoveToTeam': 'Chuyển vào team',
  'recentProjects.confirmMoveToPersonal': 'Chuyển về Personal',
  'recentProjects.unshareInProgress': 'Đang gỡ chia sẻ...',
  'recentProjects.moveOutOfTeam': 'Chuyển khỏi team',
  'recentProjects.unshareFailed': 'Không gỡ chia sẻ được',
  'recentProjects.shareFailed': 'Không chia sẻ được',
  'recentProjects.shareOwnerConflict': 'Chỉ owner project mới có thể chia sẻ project này.',
  'recentProjects.clearFilters': 'Xóa bộ lọc',

  'entry.tabDesigns': 'Thiết kế',
  'entry.tabTemplates': 'Mẫu',
  'entry.tabDesignSystems': 'Hệ thiết kế',
  'entry.tabConnectors': 'Connector',
  'entry.discordLabel': 'Tham gia Discord',
  'entry.discordAria': 'Tham gia Discord của EduDeck',
  'entry.discordAriaWithOnline': 'Tham gia Discord của EduDeck - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.mailAria': 'Email EduDeck',
  'entry.followXLabel': 'Theo dõi @EduDeckHQ trên X',
  'entry.followThreadsLabel': 'Theo dõi EduDeck trên Threads',
  'entry.youtubeLabel': 'EduDeck trên YouTube',
  'entry.followInstagramLabel': 'Theo dõi @opendesign.ai trên Instagram',
  'entry.followLinkedinLabel': 'Theo dõi EduDeck trên LinkedIn',
  'entry.followXiaohongshuLabel': 'Theo dõi EduDeck trên Xiaohongshu',
  'entry.resizeAria': 'Đổi kích thước sidebar',
  'entry.useEverywhereTitle': 'Dùng ở mọi nơi',
  'entry.useEverywhereAria': 'Mở hướng dẫn Use Everywhere (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Team',
  'entry.primaryNavAria': 'Chính',
  'entry.billingTierTeam': 'Team',
  'entry.billingTierFree': 'Free',
  'entry.billingTierPro': 'Pro',
  'entry.billingFamilyCreator': 'Creator',
  'entry.upgradeTitle': 'Nâng cấp gói',
  'entry.upgradeCreditsExhaustedTitle': 'Hết credit',
  'entry.upgradeAutoRechargeTitle': 'Tự động nạp lại',
  'entry.upgradeDialogAria': 'Nâng cấp gói',
  'entry.upgradeSubtitle': 'Nâng cấp lên gói cao hơn để tăng quota ngay. Phí được tính theo phần còn lại của chu kỳ billing hiện tại.',
  'entry.upgradeCreditsExhaustedSubtitle': 'Bạn cần thêm credit để tiếp tục. Nâng cấp lên gói cao hơn để tăng quota ngay. Phí được tính theo phần còn lại của chu kỳ billing hiện tại.',
  'entry.upgradeAutoRechargeMemberSubtitle': 'Bật allowance riêng cho {member}. Lưu cài đặt này không thu phí ngay; credit chỉ refill khi member này xuống dưới ngưỡng.',
  'entry.upgradeAutoRechargeTeamSubtitle': 'Bật allowance cho toàn bộ đồng đội. Lưu cài đặt này không thu phí ngay; credit team chỉ refill khi balance xuống dưới ngưỡng.',
  'entry.upgradeScopeLabel': 'Phạm vi',
  'entry.upgradeScopeMember': '{member} · allowance một member',
  'entry.upgradeScopeTeam': 'Tất cả đồng đội · allowance dùng chung',
  'entry.upgradePaymentHint': 'Mặc định dùng phương thức thanh toán subscription. Bạn có thể quản lý bất cứ lúc nào.',
  'entry.upgradeManagePayment': 'Quản lý phương thức thanh toán',
  'entry.upgradeMonthlyLimit': 'Giới hạn hằng tháng',
  'entry.upgradeLimitCustom': '',
  'entry.upgradeLimitUnlimited': '∞ không giới hạn (không có cap hằng tháng)',
  'entry.upgradeBillingCycleAria': 'Chu kỳ billing',
  'entry.upgradeAnnual': 'Hằng năm',
  'entry.upgradeAnnualSave': 'Tiết kiệm 20%',
  'entry.upgradeMonthly': 'Hằng tháng',
  'entry.upgradePlanPlus': 'Personal Plus',
  'entry.upgradePlanPlusDesc': 'Allowance token cơ bản · model SOTA',
  'entry.upgradePlanPro': 'Personal Pro',
  'entry.upgradePlanProDesc': 'Allowance token 3x · model multimodal hàng đầu',
  'entry.upgradePlanMax': 'Personal Max',
  'entry.upgradePlanMaxDesc': 'Allowance token 10x · model multimodal hàng đầu',
  'entry.upgradePlanTeam': 'Team',
  'entry.upgradePlanTeamDesc': 'Collaboration · asset dùng chung · quyền theo role',
  'entry.upgradePriceUnitMonth': '/tháng',
  'entry.upgradePriceUnitSeat': '/seat/tháng',
  'entry.upgradeProrateAnnualPrefix': 'Billing hằng năm tiết kiệm 20%; ',
  'entry.upgradeProrateMonthlyPrefix': 'Billing hằng tháng; ',
  'entry.upgradeProrateSuffix': 'nâng cấp được tính prorate cho chu kỳ billing hiện tại và có hiệu lực ngay.',
  'entry.upgradeBack': 'Quay lại',
  'entry.upgradeAutoRechargeSaved': 'Đã lưu cài đặt tự động nạp lại',
  'entry.upgradeConfirm': 'Xác nhận thanh toán và nâng cấp',
  'entry.creditsAria': '{tier} · allowance còn lại',
  'entry.creditsAriaWithBalance': '{tier} · còn {balance} allowance',
  'entry.creditsGrantTip': 'Allowance team được cấp bởi subscription. Usage có trong billing.',
  'entry.creditsUpgrade': 'Nâng cấp',
  'entry.creditsOpening': 'Đang mở...',
  'entry.creditsRemaining': 'Allowance còn lại',
  'entry.creditsUsage': 'Xem usage',
  'entry.creditsMemberNoticeTitle': 'Cần thêm allowance?',
  'entry.creditsMemberNoticeBody': 'Bạn hiện là Member và không thể tự nạp. Hãy nhờ Admin team tăng allowance khi cần thêm.',
  'entry.creditsMemberNoticeAction': 'Nhờ Admin tăng allowance',
  'entry.accountToggleTheme': 'Đổi theme',
  'entry.accountSwitchLanguage': 'Đổi ngôn ngữ',
  'entry.accountLanguageMeta': 'Tiếng Việt / English',
  'entry.accountGithubHelp': 'Nhận hỗ trợ trên GitHub',
  'entry.accountFeatureRequest': 'Gửi yêu cầu tính năng',
  'entry.accountAddAccount': 'Thêm tài khoản',
  'entry.accountSignOut': 'Đăng xuất',
  'entry.navRecents': 'Home',
  'entry.navDashboard': 'Dashboard',
  'entry.blankDraftsTitle': 'Bắt đầu draft riêng tư',
  'entry.blankDraftsDescription': 'Tạo project ở đây trước. Project sẽ riêng tư cho đến khi bạn chuyển vào team space.',
  'entry.blankAllProjectsTitle': 'Chưa có project team',
  'entry.blankAllProjectsDescription': 'Project chia sẻ cho team sẽ hiện ở đây cho mọi người trong workspace.',
  'entry.blankCreate': 'Project mới',
  'entry.workspaceTeamsTitle': 'Workspace cho Team - cho chúng tôi biết team bạn cần gì',
  'entry.workspaceTeamsAria': 'Mở trang Workspace for Teams',
  'entry.teamSlotNote': 'Không gian này được cung cấp bởi team service. Integration đang được thực hiện.',
  'entry.cloudCalloutTitle': 'Chế độ local',
  'entry.cloudCalloutBody': 'Dùng local CLI hoặc API key của bạn',
  'entry.cloudCalloutDismissAria': 'Ẩn ghi chú chế độ local',
  'entry.workspaceLockedNote': 'Workspace này đang bị khóa. Khôi phục billing để tiếp tục sửa project chia sẻ.',
  'entry.workspaceLockedRecover': 'Khôi phục quyền truy cập',
  'entry.helpAria': 'Trợ giúp',
  'entry.helpMenuAria': 'Menu trợ giúp',
  'entry.helpGetHelp': 'Nhận hỗ trợ trên GitHub',
  'entry.helpSubmitFeature': 'Gửi yêu cầu tính năng',
  'entry.helpWhatsNew': 'Có gì mới',
  'entry.helpDownloadDesktop': 'Tải app desktop',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Bấm để star chúng tôi trên GitHub',
  'entry.githubStarAria': 'Star EduDeck trên GitHub',
  'entry.tabImageTemplates': 'Mẫu ảnh',
  'entry.tabVideoTemplates': 'Mẫu video',

  'connectors.title': 'Connector',
  'connectors.subtitle': 'Nguồn dữ liệu local và tương lai dùng để chạy live artifact.',
  'connectors.account': 'Tài khoản',
  'connectors.noAccount': 'Chưa kết nối',
  'connectors.tools': 'Tool',
  'connectors.connect': 'Kết nối',
  'connectors.disconnect': 'Ngắt kết nối',
  'connectors.authorizationPending': 'Đang chờ cấp quyền...',
  'connectors.authorizationPendingHint': 'Hoàn tất cấp quyền trong cửa sổ đã mở.',
  'connectors.cancelAuthorization': 'Hủy',
  'connectors.configure': 'Cấu hình',
  'connectors.unavailable': 'Không khả dụng',
  'connectors.phaseStubTitle': 'API connector sẽ có ở Phase 3; đây là bề mặt preview.',
  'connectors.statusAvailable': 'Khả dụng',
  'connectors.statusConnected': 'Đã kết nối',
  'connectors.statusError': 'Lỗi',
  'connectors.statusDisabled': 'Đã tắt',
  'connectors.gateTitle': 'Thêm Composio API key để tiếp tục',
  'connectors.gateBody': 'Dán key phía trên và bấm Lưu key để tải integration có sẵn.',
  'connectors.aboutLabel': 'Giới thiệu',
  'connectors.detailsLabel': 'Chi tiết',
  'connectors.statusLabel': 'Trạng thái',
  'connectors.category.aiAgents': 'AI agent',
  'connectors.category.aiInfrastructure': 'Hạ tầng AI',
  'connectors.category.accounting': 'Kế toán',
  'connectors.category.admin': 'Admin',
  'connectors.category.advertising': 'Quảng cáo',
  'connectors.category.analytics': 'Analytics',
  'connectors.category.automation': 'Automation',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Lịch',
  'connectors.category.commerce': 'Thương mại',
  'connectors.category.communication': 'Giao tiếp',
  'connectors.category.contacts': 'Danh bạ',
  'connectors.category.dataPlatform': 'Nền tảng dữ liệu',
  'connectors.category.database': 'Database',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Developer',
  'connectors.category.documentation': 'Tài liệu',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Giáo dục',
  'connectors.category.email': 'Email',
  'connectors.category.events': 'Sự kiện',
  'connectors.category.fieldService': 'Field service',
  'connectors.category.finance': 'Tài chính',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Form',
  'connectors.category.gaming': 'Game',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hospitality',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integration',
  'connectors.category.localization': 'Localization',
  'connectors.category.logistics': 'Logistics',
  'connectors.category.maps': 'Map',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Cuộc họp',
  'connectors.category.nonprofit': 'Phi lợi nhuận',
  'connectors.category.observability': 'Observability',
  'connectors.category.payments': 'Thanh toán',
  'connectors.category.personal': 'Cá nhân',
  'connectors.category.presentations': 'Presentation',
  'connectors.category.procurement': 'Mua sắm',
  'connectors.category.product': 'Sản phẩm',
  'connectors.category.productivity': 'Năng suất',
  'connectors.category.projectManagement': 'Quản lý project',
  'connectors.category.recruiting': 'Tuyển dụng',
  'connectors.category.research': 'Nghiên cứu',
  'connectors.category.salesIntelligence': 'Sales intelligence',
  'connectors.category.scheduling': 'Lên lịch',
  'connectors.category.search': 'Tìm kiếm',
  'connectors.category.security': 'Bảo mật',
  'connectors.category.signing': 'Ký tài liệu',
  'connectors.category.social': 'Mạng xã hội',
  'connectors.category.spreadsheets': 'Bảng tính',
  'connectors.category.storage': 'Lưu trữ',
  'connectors.category.support': 'Hỗ trợ',
  'connectors.category.surveys': 'Khảo sát',
  'connectors.category.tasks': 'Task',
  'connectors.category.timeTracking': 'Theo dõi thời gian',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Whiteboard',
  'connectors.categoryLabel': 'Category',
  'connectors.providerLabel': 'Provider',
  'connectors.toolsSection': 'Tool',
  'connectors.toolsLoading': 'Đang tải tool...',
  'connectors.noToolsAvailable': 'Chưa có tool. Kết nối để xem integration này cung cấp gì.',
  'connectors.toolDetailsUnavailable': 'Không có chi tiết tool, nhưng connector này báo có {n} tool.',
  'connectors.loadMoreTools': 'Tải thêm tool',
  'connectors.openDetailsAria': 'Mở chi tiết {name}',
  'connectors.toolsBadgeNone': 'Không có tool',
  'connectors.toolsBadgeOne': '{n} tool',
  'connectors.toolsBadgeMany': '{n} tool',
  'connectors.searchPlaceholder': 'Tìm connector...',
  'connectors.searchAriaLabel': 'Tìm connector theo tên, provider hoặc tool',
  'connectors.searchClear': 'Xóa tìm kiếm',
  'connectors.emptyNoMatchTitle': 'Không có connector khớp "{query}"',
  'connectors.emptyNoMatchBody': 'Thử từ khóa khác hoặc xóa tìm kiếm để xem toàn bộ catalog.',
  'connectors.emptyNoMatchAction': 'Xóa tìm kiếm',

  'memory.connectorReadFailed': 'Không đọc được {name}.',
  'memory.connectorNoReadableContent': 'Không có nội dung đọc được từ {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Model memory',
  'memory.extractionSourceConnector': 'Connected app đã được đọc, nhưng EduDeck không chuyển được context đó thành memory.',
  'memory.extractionSourceChat': 'EduDeck không chạy được trích xuất memory cho chat này.',
  'memory.failureAuthExpiredTitle': 'Xác thực {provider} đã hết hạn',
  'memory.failureAuthActionCli': 'Đăng nhập vào Local CLI đã chọn hoặc chọn model Memory khác.',
  'memory.failureAuthActionKey': 'Cập nhật key model trích xuất Memory hoặc đăng nhập lại.',
  'memory.failureQuotaTitle': '{provider} đã chạm quota hoặc rate limit',
  'memory.failureQuotaAction': 'Thử lại sau hoặc đổi model trích xuất Memory.',
  'memory.failureRequestTitle': 'Request {provider} thất bại',
  'memory.failureRequestActionCli': 'Kiểm tra Local CLI đã chọn rồi thử lại.',
  'memory.failureRequestActionProvider': 'Kiểm tra kết nối model provider rồi thử lại.',
  'memory.failureGenericTitle': 'Trích xuất memory thất bại',
  'memory.failureGenericActionCli': 'Thử lại sau khi kiểm tra Local CLI đã chọn.',
  'memory.failureGenericActionSettings': 'Thử lại sau khi kiểm tra cài đặt model trích xuất Memory.',
  'memory.noData': 'Không có dữ liệu',
  'memory.attemptReadTitle': 'Đọc {name}',
  'memory.attemptFailedTitle': 'Không đọc được {name}',
  'memory.attemptSkippedTitle': 'Đã bỏ qua {name}',
  'memory.skipChatDisabled': 'Học từ cuộc trò chuyện đang tắt.',
  'memory.kindConnectedApps': 'Connected app',
  'memory.timeAgo': '{time} trước',
  'memory.scanRunningTitle': 'Đang quét connected app',
  'memory.scanFailedTitle': 'Quét connected app thất bại',
  'memory.scanSkippedTitle': 'Đã bỏ qua quét connected app',
  'memory.scanSavedOne': 'Đã lưu {count} memory',
  'memory.scanSavedOther': 'Đã lưu {count} memory',
  'memory.scanNoNewMemories': 'Không tìm thấy memory mới',
  'memory.scanTitle': 'Quét connected app',
  'memory.scanMetaChecking': 'Đang kiểm tra app đã chọn',
  'memory.scanMetaNeedsAttention': 'Cần chú ý',
  'memory.scanMetaFromConnectedApps': 'Từ connected app',
  'memory.scanMetaCheckedApps': 'Đã kiểm tra app đã chọn',
  'memory.scanBusyLabel': 'Đang quét app',
  'memory.scanSelectPrompt': 'Chọn app để quét',
  'memory.scanSelectedApps': 'Quét app đã chọn',
  'memory.connectorReadFailedRetry': 'Không đọc được connected app. Thử lại từ tab Connectors.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} app',
  'memory.foundSuggestionsOne': 'Tìm thấy {count} memory gợi ý từ {apps}. Review trước khi lưu.',
  'memory.foundSuggestionsOther': 'Tìm thấy {count} memory gợi ý từ {apps}. Review trước khi lưu.',
  'memory.noSuggestionsFound': 'Không tìm thấy memory gợi ý. EduDeck chưa đọc được nội dung hữu ích từ app đã chọn.',
  'memory.checkedNoSuggestionsOne': 'Đã kiểm tra {count} app đã chọn nhưng không thấy memory gợi ý mới.',
  'memory.checkedNoSuggestionsOther': 'Đã kiểm tra {count} app đã chọn nhưng không thấy memory gợi ý mới.',
  'memory.savedFromConnectedAppsOne': 'Đã lưu {count} memory từ connected app.',
  'memory.savedFromConnectedAppsOther': 'Đã lưu {count} memory từ connected app.',
  'memory.savedPartial': 'Đã lưu {saved}/{total} memory đã chọn. Vui lòng thử lại các mục còn lại.',
  'memory.tabManual': 'Thêm thủ công',
  'memory.tabManualCaption': 'Viết fact hoặc preference',
  'memory.tabConnected': 'Import từ app',
  'memory.tabConnectedCaption': 'Quét tool đã kết nối',
  'memory.storagePathAria': 'Đường dẫn lưu memory - bấm để copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Context brand',
  'memory.flowChatSignals': 'Tín hiệu chat',
  'memory.flowSavedMemory': 'Memory đã lưu',
  'memory.howCopy': 'Memory được thu thập tự động từ thiết lập profile, trích xuất project/brand, connected app và các fact hữu ích học trong chat. Danh sách đã lưu bên dưới là nơi review; phần còn lại ẩn đi trừ khi bạn mở Add hoặc Advanced.',
  'memory.areasAria': 'Khu vực memory',
  'memory.manualPanelHint': 'Tự thêm fact, preference hoặc context project. Hành vi cố định của assistant nằm trong Instructions & rules.',
  'memory.connectedPanelHint': 'Chọn app để quét preference thiết kế, context project và reference visual. Không có gì được quét cho đến khi bạn chọn app.',
  'memory.loading': 'Đang tải',
  'memory.connectedCount': '{count} đã kết nối',
  'memory.manage': 'Quản lý',
  'memory.chooseSources': 'Chọn nguồn',
  'memory.chooseSourcesHint': 'Chọn connected app trước. EduDeck chỉ quét app bạn chọn.',
  'memory.selectedCount': '{count} đã chọn',
  'memory.connectorListAria': 'App memory đã kết nối',
  'memory.readToolsCount': '{count} read tool',
  'memory.checkingConnectionStatus': 'Đang kiểm tra trạng thái kết nối...',
  'memory.finishAuthorization': 'Hoàn tất cấp quyền trong trình duyệt rồi quay lại đây',
  'memory.connectBeforeExtraction': 'Kết nối app này trước khi trích xuất',
  'memory.useConnectorAria': 'Dùng {name} để trích xuất memory',
  'memory.selected': 'Đã chọn',
  'memory.select': 'Chọn',
  'memory.reconnectConnectorAria': 'Kết nối lại {name}',
  'memory.connectConnectorAria': 'Kết nối {name}',
  'memory.connectStateChecking': 'Đang kiểm tra',
  'memory.connectStateWaiting': 'Đang chờ',
  'memory.connectStateConnecting': 'Đang kết nối',
  'memory.reconnect': 'Kết nối lại',
  'memory.selectedOfConnectedOne': 'Đã chọn {count}/{total} app đã kết nối.',
  'memory.selectedOfConnectedOther': 'Đã chọn {count}/{total} app đã kết nối.',
  'memory.suggestedMemories': 'Memory gợi ý',
  'memory.suggestedMemoriesHint': 'Review memory liên quan tới thiết kế trước khi lưu.',
  'memory.saving': 'Đang lưu',
  'memory.saveSelected': 'Lưu mục đã chọn',
  'memory.discard': 'Bỏ',
  'memory.diagnosticsAria': 'Trạng thái đọc connected app',
  'memory.lastScan': 'Lần quét gần nhất',
  'memory.bytesRead': 'Đã đọc {bytes}',
  'memory.recentScans': 'Lượt quét gần đây',
  'memory.runHistoryAria': 'Trạng thái chạy memory connected app',
  'memory.savedMemoryHint': 'Fact, preference và context project đã lưu để dùng trong chat sau.',
  'memory.savedCount': '{count} đã lưu',
  'memory.extractionCountOne': '{count} lần trích xuất',
  'memory.extractionCountOther': '{count} lần trích xuất',
  'memory.emptyHintBefore': 'Nói cho assistant một fact trong chat, ví dụ',
  'memory.emptyHintAfter': ', và nó sẽ tự lưu ở đây.',
  'memory.advancedHint': 'Kiểm tra hoặc sửa index memory bên dưới.',
  'memory.memoryTree': 'Cây memory',
  'memory.memoryTreeHint': 'Góc nhìn kỹ thuật của cùng memory đã lưu. Hầu hết người dùng chỉ cần danh sách memory đã lưu phía trên.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} node',

  'mcp.aboutTemplate': 'Giới thiệu {name}',
  'mcp.approvedRefresh': 'Tôi đã duyệt - Refresh',
  'mcp.approveInBrowserHint': 'Duyệt trong tab trình duyệt đã mở. Callback sẽ được bắt tự động, hoặc bấm Refresh bên dưới nếu bạn đã hoàn tất.',
  'mcp.argsPlaceholder': 'cách nhau bằng khoảng trắng',
  'mcp.authModeNone': 'Không quản lý OAuth',
  'mcp.authModeOAuth': 'OAuth được quản lý',
  'mcp.browserDidntOpen': 'Trình duyệt không mở?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Biểu đồ và sơ đồ dưới dạng image artifact chuẩn.',
  'mcp.categoryDesignSystems': 'Design system',
  'mcp.categoryDesignSystemsHint': 'Đọc/ghi Figma, chuyển đổi design-token, cảm hứng brand.',
  'mcp.categoryImageEditing': 'Sửa ảnh',
  'mcp.categoryImageEditingHint': 'Hậu xử lý local, OCR và sửa dựa trên computer vision.',
  'mcp.categoryImageGeneration': 'Tạo ảnh',
  'mcp.categoryImageGenerationHint': 'Model tạo asset raster, vector hoặc video.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Đẩy artifact đã tạo lên URL công khai.',
  'mcp.categoryUiComponents': 'UI component',
  'mcp.categoryUiComponentsHint': 'Component, block và chất liệu landing-page cấp designer.',
  'mcp.categoryUtilities': 'Tiện ích',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub và các tool chung tương tự.',
  'mcp.categoryWebCapture': 'Chụp web',
  'mcp.categoryWebCaptureHint': 'Render URL thành ảnh để agent thấy thứ nó đã tạo.',
  'mcp.checking': 'Đang kiểm tra...',
  'mcp.clickConnectHint': 'Bấm Kết nối để cấp quyền EduDeck qua OAuth flow của provider.',
  'mcp.closePicker': 'Đóng picker',
  'mcp.collapse': 'Thu gọn',
  'mcp.collapseServerAria': 'Thu gọn MCP server này',
  'mcp.commandPlaceholder': 'ví dụ npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command là bắt buộc cho stdio transport.',
  'mcp.completedAuthTitle': 'Tôi đã cấp quyền xong - kiểm tra trạng thái kết nối ngay',
  'mcp.connect': 'Kết nối',
  'mcp.connected': 'Đã kết nối.',
  'mcp.connecting': 'Đang kết nối...',
  'mcp.customServer': 'Server tùy chỉnh',
  'mcp.customServerDesc': 'Form trống. Chọn stdio hoặc SSE / HTTP rồi tự điền field.',
  'mcp.disabled': 'Đã tắt',
  'mcp.disconnect': 'Ngắt kết nối',
  'mcp.disconnectFailed': 'Ngắt kết nối thất bại. Kiểm tra log daemon.',
  'mcp.disconnecting': 'Đang ngắt kết nối...',
  'mcp.displayNamePlaceholder': 'Tên hiển thị (tùy chọn)',
  'mcp.enabled': 'Đã bật',
  'mcp.enableServerAria': 'Bật MCP server này',
  'mcp.expand': 'Mở rộng',
  'mcp.expandServerAria': 'Mở rộng MCP server này',
  'mcp.expandToEdit': 'Mở rộng để sửa',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Header (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'Chế độ OAuth',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID phải bắt đầu bằng chữ hoặc số và chỉ chứa chữ, số, dấu gạch nối hoặc underscore (tối đa 64 ký tự).',
  'mcp.jsonHelperExampleHead': 'Ví dụ MCP JSON',
  'mcp.jsonHelperHttpNote': 'dùng url + header thay cho command / args',
  'mcp.jsonHelperToggle': 'Cần trợ giúp? Map JSON config MCP server bằng ví dụ bên dưới.',
  'mcp.moveDown': 'Di chuyển xuống',
  'mcp.moveUp': 'Di chuyển lên',
  'mcp.noManagedOAuth': 'Không có OAuth được quản lý.',
  'mcp.noManagedOAuthSaveDirect': 'Lưu server này và EduDeck sẽ dùng trực tiếp.',
  'mcp.noManagedOAuthUseAsConfigured': 'EduDeck sẽ dùng server này đúng như cấu hình. Thêm header bên dưới nếu server cần token.',
  'mcp.nonExpiringToken': 'Token không hết hạn.',
  'mcp.notConnected': 'Chưa kết nối.',
  'mcp.openAuthorizationPage': 'Mở trang cấp quyền',
  'mcp.pickerFilterPlaceholder': 'Lọc theo tên, transport, capability...',
  'mcp.pickerHint': 'Tự điền form trước. Bạn vẫn có thể sửa mọi field sau đó.',
  'mcp.pickerNoMatch': 'Không có template khớp "{query}". Thử xóa bộ lọc hoặc dùng tùy chọn server tùy chỉnh bên dưới.',
  'mcp.pickTemplate': 'Chọn template',
  'mcp.reauthenticateTitle': 'Xác thực lại (thay token hiện có)',
  'mcp.recheckTokenTitle': 'Kiểm tra lại trạng thái token với daemon',
  'mcp.reconnect': 'Kết nối lại',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Gỡ MCP server này',
  'mcp.saveFirstThenClick': 'Lưu trước, rồi bấm',
  'mcp.starting': 'Đang khởi động...',
  'mcp.toGrantOAuthAccess': 'để cấp quyền EduDeck qua OAuth flow của provider.',
  'mcp.tokenExpires': 'Token hết hạn {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Thử:',
  'mcp.tryPromptTitle': 'Dán prompt này vào chat composer để thử server end-to-end',
  'mcp.unnamedServer': 'MCP server chưa đặt tên',
  'mcp.urlMalformed': 'URL sai định dạng.',
  'mcp.urlProtocolInvalid': 'URL phải dùng http:// hoặc https://.',
  'mcp.urlRequired': 'URL là bắt buộc cho SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Đang chờ cấp quyền...',

  'settings.testMissingFields': 'Điền {fields} để test kết nối.',
  'settings.testSuccessApi': 'Đã kết nối. Phản hồi trong {ms} ms - "{sample}"',
  'settings.testSuccessCli': '{agentName} phản hồi trong {ms} ms - "{sample}"',
  'settings.testAuthFailed': 'Xác thực thất bại. Kiểm tra API key.',
  'settings.testForbidden': 'Bị chặn truy cập. Kiểm tra tài khoản, region hoặc organization.',
  'settings.testNotFoundModel': 'Không tìm thấy model "{model}" trên endpoint này.',
  'settings.testInvalidModelId': 'Model id "{model}" không hợp lệ. Custom id phải bắt đầu bằng chữ hoặc số và không chứa khoảng trắng.',
  'settings.testInvalidBaseUrl': 'Base URL không hợp lệ hoặc không truy cập được.',
  'settings.testRateLimited': 'Provider rate-limit lượt test. Cấu hình có vẻ hợp lệ.',
  'settings.testUpstream': 'Provider trả về {status}. Thử lại sau một lát.',
  'settings.testTimeout': 'Test timeout sau {ms} ms.',
  'settings.testAgentMissing': '{agentName} chưa cài hoặc không có trong PATH.',
  'settings.testAgentSpawn': 'Không khởi động được {agentName}: {detail}.',
  'settings.testUnknown': 'Test thất bại: {detail}',
  'settings.apiKeyInvalid': 'API key không hợp lệ.',
  'settings.apiKeyCleaned': 'Đã xóa khoảng trắng thừa khỏi API key.',
  'settings.azureBaseUrlPlaceholder': 'Dán Azure endpoint URL',
  'settings.azureBaseUrlHint': 'Tìm trong Azure portal -> resource của bạn -> Endpoint.',
  'settings.azureDeploymentModel': 'Tên deployment',
  'settings.azureCustomDeploymentName': 'Tên deployment tùy chỉnh',
  'settings.azureModelFetchHint': 'Nhập tên deployment từ Azure resource. Azure deployment không thể fetch tự động.',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Đã cấu hình',
  'settings.mediaProviderUnset': 'Chưa đặt',
  'settings.mediaProviderClear': 'Xóa cấu hình',
  'settings.mediaProviderClearConfirm': 'Xóa cài đặt {name} đã lưu? Bạn sẽ cần nhập lại để dùng {name}.',
  'settings.mediaProviderPlaceholder': 'Dán API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'Ghi đè base URL mặc định',
  'settings.mediaProviderReload': 'Refresh provider',
  'settings.mediaProviderReloadError': 'Không refresh được cài đặt provider.',
  'settings.mediaProviderReloadSuccess': 'Đã refresh cài đặt provider.',
  'settings.mediaProviderComingSoonHint': 'Các provider này đã được lên kế hoạch nhưng chưa thể cấu hình.',
  'settings.mediaProviderModelProviders': 'Provider',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Dùng mặc định của provider',
  'settings.mediaProviderDocsTitle': 'Tài liệu',
  'settings.mediaProviderDocsHint': 'Xem hướng dẫn thiết lập cho provider này.',
  'settings.mediaProviderSaveHint': 'Thay đổi chưa được lưu cho đến khi bạn chọn Lưu.',
  'settings.mediaProviderNoKeyRequired': 'Không cần key',
  'settings.mediaProviderNoKeyHint': 'Provider này dùng đăng nhập local hoặc runtime đi kèm.',
  'settings.privacy': 'Quyền riêng tư',
  'settings.privacyHint': 'Dữ liệu nào được chia sẻ với team EduDeck',
  'settings.about': 'Giới thiệu',
  'settings.aboutHint': 'Chi tiết phiên bản và runtime',
  'settings.appVersion': 'Phiên bản',
  'settings.appChannel': 'Channel',
  'settings.appRuntime': 'Runtime',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Architecture',
  'settings.runtimePackaged': 'App đóng gói',
  'settings.runtimeDevelopment': 'Development',
  'settings.versionUnavailable': 'Không có chi tiết phiên bản khi daemon offline.',
  'settings.allowSilentUpdates': 'Cho phép tự động cài update trong app sau này',
  'settings.allowSilentUpdatesDesc': 'Khi có update trong app, tự động cài ở lần EduDeck khởi động tiếp theo. Không nâng cấp phiên hiện tại. Installer update vẫn sẽ hỏi trước.',
  'settings.systemPrefsTitle': 'Tùy chọn hệ thống',
  'settings.systemPrefsHint': 'Âm thanh hoàn tất, thông báo desktop và cảnh báo trạng thái task.',
  'settings.notifications': 'Thông báo',
  'settings.notificationsHint': 'Âm thanh và thông báo desktop khi task hoàn tất',
  'settings.connectorsComposioApiKey': 'Composio API Key',
  'settings.connectorsSavedTitle': 'Đã lưu vào daemon local',
  'settings.connectorsSavedWithTail': 'Đã lưu · ••••{tail}',
  'settings.connectorsSaved': 'Đã lưu',
  'settings.connectorsGetApiKey': 'Lấy API Key',
  'settings.connectorsReplaceKeyPlaceholder': 'Nhập key mới để thay key đã lưu',
  'settings.connectorsApiKeyPlaceholder': 'Dán Composio API key',
  'settings.connectorsClear': 'Xóa',
  'settings.connectorsClearConfirmTitle': 'Xóa Composio API key đã lưu?',
  'settings.connectorsClearConfirmBody': 'Xóa key sẽ ngắt mọi Composio connector liên kết với workspace này. Tài khoản đã kết nối, OAuth grant và quyền tool đều bị xóa.',
  'settings.connectorsClearConfirmContinue': 'Tiếp tục',
  'settings.connectorsClearFinalTitle': 'Thao tác này sẽ ngắt tất cả connector',
  'settings.connectorsClearFinalBody': 'Không thể hoàn tác. Bạn sẽ cần kết nối lại từng integration từ đầu sau khi dán key mới.',
  'settings.connectorsClearFinalConfirm': 'Xóa key và ngắt kết nối',
  'settings.connectorsClearArming': 'Chờ một chút...',
  'settings.connectorsClearCancel': 'Hủy',
  'settings.connectorsSaveKey': 'Lưu key',
  'settings.connectorsSaveKeyTitle': 'Gửi key này tới daemon local',
  'settings.connectorsKeySaving': 'Đang lưu...',
  'settings.connectorsKeySaved': 'Đã lưu ✓',
  'settings.connectorsKeyError': 'Không lưu được key. Kiểm tra daemon local đang chạy rồi thử lại.',
  'settings.connectorsHelpSaved': 'Key của bạn được lưu trong daemon local. Dán key mới để thay thế hoặc Xóa để gỡ.',
  'settings.connectorsHelpUnsaved': 'Có thay đổi chưa lưu - bấm Lưu key để lưu credential này vào daemon local và refresh catalog bên dưới.',
  'settings.connectorsHelpEmpty': 'Key được lưu local và không chia sẻ đi đâu.',
  'settings.connectorsLoadingSavedKey': 'Đang kiểm tra key đã lưu trong daemon local...',
  'settings.autosaveSaving': 'Đang lưu...',
  'settings.autosaveSaved': 'Mọi thay đổi đã lưu',
  'settings.autosaveError': 'Không lưu được thay đổi. Daemon local có thể đang offline.',
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Fact và context đã lưu cho chat sau',
  'settings.customInstructionsTitle': 'Rule toàn cục',
  'settings.customInstructionsPlaceholder': 'ví dụ "Luôn dùng TypeScript. Ưu tiên functional component. Trả lời ngắn gọn."',
  'settings.memoryModelInlineLabel': 'Model memory',
  'settings.instructionsTitle': 'Instructions & rules',
  'settings.instructionsSubtitle': 'Hành vi cố định assistant cần làm theo',
  'settings.instructionsNavSub': 'Hành vi assistant cố định',
  'settings.customInstructionsDesc': 'Instruction cố định EduDeck làm theo trong mọi chat. Đây không phải memory đã lưu; dùng Memory cho fact, preference và context project.',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Chạy lại thiết lập lần đầu, gồm trích xuất brand.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Xóa cache update',
  'settings.clearUpdaterCacheHint': 'Xóa update đã tải và cache updater cũ, rồi reset trạng thái update. Dùng khi update có vẻ bị kẹt.',
  'settings.clearUpdaterCacheButton': 'Xóa cache',
  'settings.clearUpdaterCacheConfirmButton': 'Xác nhận xóa',
  'settings.clearUpdaterCacheSuccess': 'Đã xóa cache update.',
  'settings.clearUpdaterCacheFailed': 'Không xóa được cache update.',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Chào mừng đến EduDeck',
  'settings.welcomeSubtitle': '',
  'settings.kicker': 'Cài đặt',
  'settings.agentInstall.install': 'Cài đặt',
  'settings.agentInstall.docs': 'Xem tài liệu',
  'settings.agentInstall.pathHint': 'Nếu bạn đã cài CLI bằng npm hoặc Homebrew mà vẫn hiện là chưa cài, hãy bảo đảm thư mục bin của tool nằm trong PATH mà daemon EduDeck nhận được (Terminal và app GUI có thể khác trên macOS). Xem QUICKSTART.md, mục "Local agent CLI and PATH".',
  'settings.agentInstall.stepOpenLinks': 'Mở Install hoặc Docs cho agent bạn muốn dùng.',
  'settings.agentInstall.stepAuth': 'Xác thực với CLI của vendor (đăng nhập hoặc thêm credential API) trước khi quay lại EduDeck.',
  'settings.agentInstall.stepRescan': 'Bấm Rescan trong phần này.',
  'settings.agentInstall.stepSelect': 'Chọn card agent khi nó hiện là đã cài.',
  'settings.noAgentsDetected': 'Chưa phát hiện agent. Cài một trong Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen hoặc GitHub Copilot CLI, rồi bấm Rescan.',
  'settings.agentInstalledGroup': 'CLI đã cài ({count})',
  'settings.agentInstallGroup': 'CLI có sẵn ({count})',
  'settings.agentAuthRequired': 'Cần xác thực',
  'settings.agentAuthUnknown': 'Chưa rõ trạng thái auth',
  'settings.amrAuthorize': 'Cấp quyền',
  'settings.amrBenefitOfficial': 'Chính thức',
  'settings.amrBenefitManyModels': 'Nhiều model',
  'settings.amrSignedIn': 'Sẵn sàng',
  'settings.amrWalletUnavailable': 'Balance tạm thời không khả dụng',
  'settings.amrPlan': 'Gói',
  'settings.amrUpgrade': 'Nâng cấp',
  'settings.amrModelUpgradeHint': 'Nâng cấp để dùng',
  'settings.modelSourceAccount': 'Từ tài khoản của bạn',
  'settings.modelSourceSuggested': 'Gợi ý',
  'settings.byokImageModel': 'Model tạo ảnh',
  'settings.byokVideoModel': 'Model tạo video',
  'settings.byokSpeechModel': 'Model speech',
  'settings.byokSpeechVoice': 'Giọng speech',
  'settings.byokModelDefaultOption': 'Mặc định',
  'settings.maxTokens': 'Max tokens (tùy chọn)',
  'settings.maxTokensHint': 'Độ dài phản hồi tối đa. Để trống để dùng mặc định của model.',
  'settings.envConfigure': 'Model Codex',
  'settings.cliEnvTitle': 'Nâng cao: proxy & path tùy chỉnh',
  'settings.cliEnvHint': 'Dùng các mục này để ghi đè môi trường CLI đã chọn: API key, proxy base URL, custom home hoặc binary path không chuẩn. Nếu không có base URL, CLI dùng endpoint mặc định. Secret nằm trong config app local và chỉ CLI đã chọn thấy.',
  'settings.mcpServerTitle': 'EduDeck MCP',
  'settings.mcpServerHint': 'Expose EduDeck như MCP server cho coding agent của bạn.',
  'settings.externalMcpTitle': 'MCP bên ngoài',
  'settings.externalMcpHint': 'Thêm MCP tool từ dịch vụ bên ngoài (Higgsfield, GitHub, ...).',
  'settings.updateViewReleases': 'Xem release note',
  'settings.updateActionFailed': 'Không hoàn tất được thao tác update.',
  'settings.mcpTitle': 'Kết nối EduDeck với coding agent',
  'settings.mcpDaemonError': 'Không gọi được daemon local để resolve install path ({error}). Bảo đảm EduDeck đang chạy rồi mở lại panel này.',
  'settings.mcpBuildDaemon': 'Build daemon trước.',
  'settings.mcpNodeMissing': 'Thiếu Node binary.',
  'settings.mcpBuildHint': 'Thiếu apps/daemon/dist/cli.js. Chạy `pnpm --filter @open-design/daemon build` rồi refresh.',
  'settings.mcpMethodCli': 'Lệnh setup',
  'settings.mcpInstructionCli': 'Chạy lệnh này trong terminal:',
  'settings.mcpMethodToml': 'TOML config',
  'settings.mcpInstructionCodex': 'Append table này vào {path}. Cùng config được dùng cho Codex CLI và Codex IDE extension.',
  'settings.mcpMethodOneClick': 'Cài một chạm',
  'settings.mcpInstructionCursor': 'Bấm "Install in Cursor" để cài qua hộp thoại duyệt, hoặc merge JSON này vào {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Cài trong Cursor',
  'settings.mcpMethodJson': 'JSON config',
  'settings.mcpInstructionKiro': 'Mở {path} và merge JSON này. Với config cấp workspace, dùng .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Mở Command Palette ({shortcut}), chạy "MCP: Open User Configuration", rồi merge JSON này. Copilot Chat phải ở Agent mode thì tool mới hiện.',
  'settings.mcpInstructionAntigravity': 'Trong Antigravity: Agent panel, menu "..." -> MCP Servers -> Manage MCP Servers -> View raw config. Merge JSON này.',
  'settings.mcpInstructionZed': 'Mở Zed Settings ({shortcut}) và merge vào object top-level. Zed dùng "context_servers", không dùng "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Mở {path} (hoặc dùng icon MCPs trong Cascade -> Configure) và merge:',
  'settings.mcpCopyAria': 'Copy lệnh setup',
  'settings.mcpResolvingFailed': '# resolve path thất bại, xem lỗi phía trên',
  'settings.mcpLoadingPaths': '# đang tải install path từ daemon local...',
  'settings.mcpCopied': 'Đã copy',
  'settings.mcpCopy': 'Copy lệnh',
  'settings.mcpCursorApproval': 'Cursor hiện hộp thoại duyệt trước khi ghi config.',
  'settings.mcpCodexOneClickInstall': 'Cài trong Codex',
  'settings.mcpCodexOneClickUninstall': 'Gỡ khỏi Codex',
  'settings.mcpCodexOneClickUnavailable': 'Không tìm thấy Codex CLI trong PATH - cài Codex hoặc tự dán snippet.',
  'settings.mcpCodexBusy': 'Đang xử lý...',
  'settings.mcpCodexInstallError': 'Thao tác thất bại: {error}',
  'settings.mcpCapabilitiesTitle': 'Agent của bạn có thể làm gì',
  'settings.mcpCapabilityRead': 'Đọc hoặc tìm bất kỳ file nào trong project.',
  'settings.mcpCapabilityPull': 'Thu thập file, style, component và font của thiết kế làm context.',
  'settings.mcpCapabilityDefault': 'Dùng project và file đang mở trong EduDeck làm context.',
  'settings.mcpRunningNote': 'Giữ EduDeck đang chạy. Restart coding agent sau khi setup.',
  'settings.notifyCompletionSound': 'Âm thanh hoàn tất',
  'settings.notifySuccessSound': 'Âm thanh thành công',
  'settings.notifyFailureSound': 'Âm thanh thất bại',
  'settings.notifyDesktop': 'Thông báo desktop',
  'settings.notifyDesktopBlocked': 'Thông báo bị trình duyệt chặn. Cho phép trong site settings.',
  'settings.notifyDesktopUnsupported': 'Môi trường này không hỗ trợ thông báo desktop.',
  'settings.notifyTest': 'Gửi test',
  'settings.orbit.eyebrow': 'Automation',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.lede': 'Thu thập hoạt động connector theo lịch và publish kết quả thành live artifact có thể refresh.',
  'settings.orbit.statusOnTitle': 'Lượt chạy hằng ngày đang bật',
  'settings.orbit.statusOffTitle': 'Lượt chạy hằng ngày đang tắt',
  'settings.orbit.statusActive': 'Đang hoạt động',
  'settings.orbit.statusOff': 'Tắt',
  'settings.orbit.runTitle': 'Bắt đầu một lượt Orbit và mở live conversation',
  'settings.orbit.running': 'Đang chạy...',
  'settings.orbit.runOpen': 'Chạy ngay',
  'settings.orbit.dailySummaryTitle': 'Tóm tắt hằng ngày',
  'settings.orbit.dailySummarySub': 'Chạy mỗi ngày một lần theo giờ local đã đặt.',
  'settings.orbit.on': 'Bật',
  'settings.orbit.off': 'Tắt',
  'settings.orbit.runTimeTitle': 'Giờ chạy',
  'settings.orbit.runTimeSub': 'Mặc định 08:00. Lưu để áp dụng vào lịch daemon.',
  'settings.orbit.runTimeAria': 'Giờ chạy Orbit hằng ngày',
  'settings.orbit.nextRun': 'Lượt chạy tiếp theo',
  'settings.orbit.nextRunScheduledAfterSave': 'Sẽ lên lịch sau khi Lưu',
  'settings.orbit.schedule': 'Lịch',
  'settings.orbit.pausedManualOnly': 'Đã tạm dừng - chỉ chạy thủ công',
  'settings.orbit.templateTitle': 'Mẫu nội dung',
  'settings.orbit.templateMissing': 'Mẫu {id} chưa được cài.',
  'settings.orbit.templateMissingOption': '{id} (thiếu)',
  'settings.orbit.templateMissingInstall': 'Cài kỹ năng Orbit để điều hướng nội dung.',
  'settings.orbit.templateMissingPickAnother': 'Chọn mẫu khác từ danh sách.',
  'settings.orbit.templateResetTitle': 'Reset về {id}',
  'settings.orbit.templateReset': 'Reset',
  'settings.orbit.templateHelp': 'Điều hướng Orbit bằng kỹ năng: nội dung ví dụ của mẫu đã chọn được chèn vào mọi lượt Orbit để tóm tắt đúng cấu trúc đó.',
  'settings.orbit.templateAria': 'Mẫu nội dung Orbit',
  'settings.orbit.templatesLoading': 'Đang tải mẫu...',
  'settings.orbit.templatesOptgroup': 'Mẫu kỹ năng Orbit',
  'settings.orbit.lastRun': 'Lần chạy gần nhất',
  'settings.orbit.triggerManual': 'Thủ công',
  'settings.orbit.triggerScheduled': 'Theo lịch',
  'settings.orbit.meterAria': '{succeeded} thành công, {skipped} bỏ qua, {failed} thất bại trong {checked} đã kiểm tra',
  'settings.orbit.countChecked': 'Đã kiểm tra',
  'settings.orbit.countSucceeded': 'Thành công',
  'settings.orbit.countSkipped': 'Bỏ qua',
  'settings.orbit.countFailed': 'Thất bại',
  'settings.orbit.runError': 'Không chạy được Orbit. Bảo đảm daemon local đang chạy và connector đã cấu hình.',
  'settings.orbit.gateAriaLabel': 'Cần connector để dùng Orbit',
  'settings.orbit.gateEyebrow': 'Cần setup',
  'settings.orbit.gateTitle': 'Kết nối một tool để chạy Orbit',
  'settings.orbit.controlsLockedBadge': 'Đã khóa',
  'settings.orbit.controlsLockedHint': 'Kết nối một công cụ để mở khóa điều khiển lịch và mẫu của Orbit.',
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Summary cũ',
  'settings.orbit.artifactTitle': 'Tóm tắt hoạt động Orbit hằng ngày',
  'settings.orbit.artifactMetaLive': 'HTML artifact có thể refresh, tạo từ hoạt động connector.',
  'settings.orbit.artifactMetaLegacy': 'Được tạo trước khi bật hỗ trợ live artifact - chạy Orbit lại để publish bản mới.',
  'settings.orbit.copyMarkdownTitle': 'Copy markdown summary vào clipboard',
  'settings.orbit.copied': 'Đã copy',
  'settings.orbit.copy': 'Copy',
  'settings.orbit.openArtifact': 'Mở artifact',
  'settings.orbit.sourceMarkdown': 'Source markdown',

  'preview.usePlugin': 'Dùng plugin',
  'preview.usePluginOnly': 'Dùng không kèm prompt',
  'preview.usePluginOnlyDesc': 'Dùng cấu trúc plugin mà không nạp prompt ví dụ',
  'preview.replicateContent': 'Dùng',
  'preview.replicateContentDesc': 'Dùng prompt ví dụ để tạo lại preview',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remix ví dụ này thành project mới có thể sửa',
  'preview.shareMenu': 'Chia sẻ',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy link template',
  'preview.copyShareText': 'Copy text chia sẻ',
  'preview.shareSocialGroup': 'Chia sẻ lên mạng xã hội',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export file',
  'preview.shareCopied': 'Đã copy',
  'preview.shareCopyFailed': 'Copy thất bại',
  'preview.shareTextDefault': 'Template EduDeck: {title}',
  'preview.openInNewTab': 'Mở trong tab mới',
  'preview.exit': '⤓ Thoát',
  'preview.fullscreen': '⤢ Toàn màn hình',
  'preview.closeTitle': 'Đóng (Esc)',
  'preview.loading': 'Đang tải {label}...',
  'preview.errorTitle': 'Không tải được ví dụ này.',
  'preview.errorBody': 'Không fetch được HTML ví dụ. Bảo đảm EduDeck đang chạy rồi thử lại.',
  'preview.retry': 'Thử lại',
  'preview.unavailableTitle': 'Chưa có preview đã ship cho {noun}.',
  'preview.unavailableBody': 'Chạy prompt trong chat để tạo output {kind}.',
  'preview.nounSkill': 'skill này',
  'preview.nounPlugin': 'plugin này',
  'preview.nounTemplate': 'template này',
  'preview.showSidebar': 'Hiện {label}',
  'preview.hideSidebar': 'Ẩn {label}',

  'artifact.odCardTaskBriefChip': 'Đã áp dụng memory · xem brief',
  'artifact.odCardScorecardTitle': 'Tự kiểm tra',
  'artifact.odCardScorecardStatusPass': 'Đạt',
  'artifact.odCardScorecardStatusPartial': 'Một phần',
  'artifact.odCardScorecardStatusFail': 'Cần sửa',
  'artifact.odCardRuleKicker': 'Rule đề xuất',
  'artifact.odCardRuleNameLabel': 'Tên',
  'artifact.odCardRuleDescriptionLabel': 'Mô tả',
  'artifact.odCardRuleAssertionLabel': 'Điều phải đúng',
  'artifact.odCardRuleCheckLabel': 'Cách kiểm tra',
  'artifact.odCardRuleRationaleLabel': 'Lý do',
  'artifact.odCardRuleKeep': 'Giữ',
  'artifact.odCardRuleEdit': 'Sửa',
  'artifact.odCardRuleDone': 'Xong',
  'artifact.odCardRuleDiscard': 'Bỏ',
  'artifact.odCardRuleSaving': 'Đang lưu...',
  'artifact.odCardRuleSaved': 'Đã lưu "{name}" thành rule',
  'artifact.odCardRuleError': 'Không lưu được rule. Thử lại.',
  'artifact.odCardBrandAssistDone': 'Browser đã mở',
  'artifact.odCardBrandAssistKicker': 'Cần browser assist: {reason}',
  'artifact.odCardBrandAssistBody': 'Mở Browser và xử lý mọi bước kiểm tra người dùng. Sau đó bấm More, chọn Download Page, chờ thông báo lưu snapshot thành công, rồi dùng card Next Step bên trái để tiếp tục trích xuất. Nếu không thấy card, tự mở tab Browser bên phải và làm theo More > Download Page > Continue extraction.',
  'artifact.odCardBrandAssistError': 'Không khởi động được browser assist. Thử lại.',
  'artifact.odCardBrandAssistWorking': 'Đang khởi động...',
  'artifact.odCardBrandAssistConfirm': 'Mở browser assist',

  'project.backToProjects': 'Quay lại project',
  'project.brandReadyTitle': 'Design system {name} đã sẵn sàng',
  'project.brandReadyTitleGeneric': 'Design system của bạn đã sẵn sàng',
  'project.brandReadyCta': 'Preview trong Design systems',
  'project.brandReadyDismiss': 'Ẩn',
  'project.brandReadyRefineHint': 'Trích xuất tự động có thể bỏ sót chi tiết. Tinh chỉnh trước khi dùng system này rộng rãi.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Sửa thủ công',
  'project.brandReadyPreviewOpened': 'Đã mở preview design system.',
  'project.previewCommentSaveFailed': 'Không lưu được comment. Vui lòng thử lại.',
  'project.previewCommentReorderFailed': 'Không lưu được thứ tự comment và có thể reset khi reload.',
  'project.metaFreeform': 'freeform',
  'project.typePrototype': 'Prototype',
  'project.typeDeck': 'Slides',
  'project.typeTemplate': 'Template',
  'project.typeImage': 'Ảnh',
  'project.typeVideo': 'Video',
  'project.typeAudio': 'Âm thanh',
  'project.customInstructions': 'Instruction project',
  'project.customInstructionsPlaceholder': 'Instruction cho project này (inject vào mọi message)...',
  'project.resizeChatPanel': 'Đổi kích thước panel chat',
  'project.instructionsActive': 'Đang bật - được đưa vào mọi message',
  'project.missing': 'Project này đã bị xóa hoặc không còn tồn tại.',

  'designFiles.library.label': 'Import từ thư viện',
  'designFiles.library.title': 'Import từ thư viện',
  'designFiles.title': 'File thiết kế',
  'designFiles.upload': 'Upload file',
  'designFiles.pasteText': 'Dán thành file text',
  'designFiles.newSketch': 'Sketch mới',
  'designFiles.newDocument': 'Tài liệu mới',
  'designFiles.newDocumentTitle': 'Tạo tài liệu Markdown mới',
  'designFiles.empty': 'Sản phẩm tạo ra sẽ hiện ở đây',
  'designFiles.syncing': 'Đang sync file từ team...',
  'designFiles.refresh': 'Refresh',
  'designFiles.delete': 'Xóa',
  'designFiles.searchPlaceholder': 'Tìm file...',
  'designFiles.up': 'Lên',
  'designFiles.back': 'Quay lại',
  'designFiles.crumbs': 'Project',
  'designFiles.rowMenu': 'Menu dòng',
  'designFiles.openInTab': 'Mở trong tab',
  'designFiles.download': 'Tải xuống',
  'designFiles.downloadSelected': 'Tải {n} thành ZIP',
  'designFiles.deleteSelected': 'Xóa {n}',
  'designFiles.clearSelection': 'Xóa chọn',
  'designFiles.selectPage': 'Chọn tất cả trên trang',
  'designFiles.selectAll': 'Chọn mọi thứ',
  'designFiles.dropTitle': '⤓ Thả file vào đây',
  'designFiles.dropDesc': 'Ảnh, tài liệu, reference hoặc thư mục - agent sẽ dùng chúng làm context.',
  'designFiles.dropLabel': 'Thả file vào đây',
  'designFiles.upload.title': 'Upload file',
  'designFiles.paste.title': 'Dán text thành file',
  'designFiles.upload.label': 'Upload',
  'designFiles.paste.label': 'Dán',
  'designFiles.documentTemplate.titleFallback': 'Tài liệu',
  'designFiles.documentTemplate.goalHeading': 'Mục tiêu',
  'designFiles.documentTemplate.goalBody': 'Mô tả EduDeck nên tạo, sửa hoặc quyết định điều gì từ tài liệu này.',
  'designFiles.documentTemplate.capabilitiesHeading': 'Cách dùng tài liệu này',
  'designFiles.documentTemplate.capabilityMarkdown': 'Dùng bất kỳ định dạng Markdown nào: heading, bảng, checklist, link, quote, code block và ảnh.',
  'designFiles.documentTemplate.capabilityAgent': 'Agent EduDeck có thể đọc, sửa và dùng file này làm context project.',
  'designFiles.documentTemplate.capabilityImages': 'Dán ảnh hoặc kéo file ảnh vào editor; ảnh upload sẽ được chèn tại con trỏ.',
  'designFiles.documentTemplate.scenarioHeading': 'Gợi ý scenario',
  'designFiles.documentTemplate.scenario.prototype': 'Với prototype, mô tả mục tiêu sản phẩm, user mục tiêu, flow, màn hình, module, state tương tác, breakpoint responsive và design token như màu, type, spacing, radius, motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'Với wireframe, mô tả user flow, danh sách màn hình, hierarchy layout, block nội dung, ràng buộc low-fidelity và câu hỏi cấu trúc cần trả lời trước khi visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'Với app mobile, liệt kê platform mục tiêu, màn hình, navigation model, gesture, pattern native, kích thước thiết bị, state và mobile design token.',
  'designFiles.documentTemplate.scenario.slideDeck': 'Với slide, viết outline PPT theo trang: mỗi slide có title, mục đích, thông điệp chính, bằng chứng, hướng visual, speaker notes và nhu cầu export.',
  'designFiles.documentTemplate.scenario.document': 'Với tài liệu, xác định audience, tone, cấu trúc section, source material, citation hoặc data, kỳ vọng layout và yêu cầu PDF/export.',
  'designFiles.documentTemplate.scenario.image': 'Với ảnh, nêu subject, aspect ratio, composition, visual style, brand token, file reference và ràng buộc negative.',
  'designFiles.documentTemplate.scenario.video': 'Với video, phác storyboard với scene, timing, caption, motion, asset, ghi chú audio và định dạng output.',
  'designFiles.documentTemplate.scenario.hyperframes': 'Với HyperFrames, mô tả motion HTML: scene, timeline, caption, khoảnh khắc phản ứng audio, transition và yêu cầu capture/export.',
  'designFiles.documentTemplate.scenario.audio': 'Với audio, xác định hướng voice hoặc nhạc, duration, mood, script hoặc copy, pacing, ghi chú phát âm và mục đích dùng cuối.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'Với live artifact, mô tả nguồn dữ liệu, nhịp refresh, widget, filter, interaction, state empty/loading/error và mọi alert hoặc automation.',
  'designFiles.documentTemplate.scenario.designSystem': 'Với design system, liệt kê mục tiêu brand, token, typography, màu, spacing, component, asset, reference và rule cần theo hoặc tránh.',
  'designFiles.documentTemplate.scenario.default': 'Mô tả audience, deliverable, nội dung cần có, reference, ràng buộc và thế nào là xong.',
  'designFiles.documentTemplate.nextHeading': 'Bước tiếp theo',
  'designFiles.documentTemplate.nextBody': 'Review và sửa tài liệu này, rồi yêu cầu EduDeck tạo, chỉnh hoặc vận hành dựa trên nó.',
  'designFiles.projectMenu': 'Thao tác project',
  'designFiles.createDesignSystemFromProject': 'Tạo design system từ project này',
  'designFiles.duplicateProject': 'Nhân bản project',
  'designFiles.previewOpen': 'Mở',
  'designFiles.previewClose': 'Đóng preview',
  'designFiles.modified': 'Sửa {time} · {size}',
  'designFiles.weeksAgo': '{n} tuần trước',
  'designFiles.groupBy': 'Nhóm theo',
  'designFiles.groupByKind': 'Loại',
  'designFiles.groupByModified': 'Thời gian sửa',
  'designFiles.filterBy': 'Lọc theo loại',
  'designFiles.filterClear': 'Xóa',
  'designFiles.filterCount': '{n} loại',
  'designFiles.expandGroup': 'Mở rộng',
  'designFiles.collapseGroup': 'Thu gọn',
  'designFiles.sectionPages': 'Trang',
  'designFiles.sectionScripts': 'Script',
  'designFiles.sectionImages': 'Ảnh',
  'designFiles.sectionSketches': 'Sketch',
  'designFiles.sectionLiveArtifacts': 'Live artifact',
  'designFiles.sectionOther': 'Khác',
  'designFiles.modifiedToday': 'Hôm nay',
  'designFiles.modifiedYesterday': 'Hôm qua',
  'designFiles.modifiedPrevious7Days': '7 ngày trước',
  'designFiles.modifiedPrevious30Days': '30 ngày trước',
  'designFiles.modifiedOlder': 'Cũ hơn',
  'designFiles.showMore': 'Hiện thêm +{n}',
  'designFiles.kindHtml': 'Trang HTML',
  'designFiles.kindImage': 'Ảnh',
  'designFiles.kindSketch': 'Sketch',
  'designFiles.kindText': 'Text',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Tài liệu',
  'designFiles.kindPresentation': 'Presentation',
  'designFiles.kindSpreadsheet': 'Bảng tính',
  'designFiles.kindLiveArtifact': 'Live artifact',
  'designFiles.kindBinary': 'Binary',
  'designFiles.kindFolder': 'Thư mục',
  'designFiles.folderCount': '{n} file',
  'designFiles.newFolderTitle': 'Thư mục mới',
  'designFiles.newFolderLabel': 'Tên thư mục',
  'designFiles.moveTitle': 'Chuyển vào thư mục',
  'designFiles.moveLabel': 'Thư mục đích',
  'designFiles.moveRoot': 'Root project',
  'designFiles.moveNewFolder': 'Thư mục mới...',
  'designFiles.move': 'Di chuyển',
  'designFiles.copyPath': 'Copy path',
  'designFiles.copiedPath': 'Đã copy path',
  'designFiles.copyLocalPath': 'Copy path file local',
  'designFiles.copiedLocalPath': 'Đã copy path file local',
  'designFiles.deleteFolderConfirm': 'Xóa thư mục "{name}" và toàn bộ nội dung?',
  'designFiles.folderCreated': 'Đã tạo thư mục "{name}"',
  'designFiles.folderDeleted': 'Đã xóa thư mục "{name}"',
  'designFiles.filesMoved': 'Đã chuyển {n} tới {dest}',
  'designFiles.colName': 'Tên',
  'designFiles.colKind': 'Loại',
  'designFiles.colModified': 'Đã sửa',
  'designFiles.perPage': 'Hiện',
  'designFiles.all': 'Tất cả',
  'designFiles.prev': 'Trước',
  'designFiles.next': 'Sau',
  'designFiles.jumpToPage': 'Tới trang',
  'designFiles.pageInfo': '{start}-{end} / {total}',
  'designFiles.sectionFolders': 'Thư mục',
  'designFiles.sectionStylesheets': 'Stylesheet',
  'designFiles.sectionDocuments': 'Tài liệu',
  'designFiles.kindStylesheet': 'Stylesheet',
  'designFiles.modifiedExt': 'Sửa {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Thông tin hữu ích',
  'designFiles.usefulInfoTip': 'Nhấp đúp file bất kỳ để mở trong tab đầy đủ.',
  'designFiles.usefulInfoTip2': 'Gõ @ trong chat để reference một file làm context.',
  'designFiles.usefulInfoTip4': 'Chọn design system để thiết kế được tạo đúng brand.',
  'designFiles.usefulInfoTip5': 'Bí ý tưởng? Thử plugin template từ Cộng đồng trên trang Home.',
  'designFiles.usefulInfoTip6': 'Có câu hỏi hoặc feedback? Tham gia Discord.',
  'designFiles.usefulInfoTip7': 'Thích EduDeck? Star chúng tôi trên GitHub.',
  'designFiles.usefulInfoTip8': 'Theo dõi @EduDeckHQ trên X để nhận cập nhật mới nhất.',
  'designFiles.usefulInfoTip9': 'Kéo ảnh, tài liệu hoặc cả thư mục vào panel này - agent dùng chúng làm context.',
  'designFiles.usefulInfoTip10': 'Bấm New sketch để vẽ layout thô và để agent dựng từ đó.',
  'designFiles.usefulInfoTip11': 'Chọn phần tử bất kỳ trong preview để comment - agent sẽ sửa đúng mục tiêu.',
  'designFiles.usefulInfoTip12': 'Chưa ưng kết quả? Khoanh vùng trong preview thường rõ hơn mô tả lại.',
  'designFiles.usefulInfoTip13': 'Export mọi thiết kế thành PDF, ảnh hoặc HTML độc lập chỉ với một click.',
  'designFiles.usefulInfoTip14': 'Ưng project? Lưu nó làm template từ menu Share để dùng lại bất cứ lúc nào.',
  'designFiles.usefulInfoTip15': 'Sau khi deploy, tạo social share card trong một bước.',
  'designFiles.usefulInfoTip16': 'Theo dõi @opendesign.ai trên Threads để xem cập nhật hậu trường.',
  'designFiles.usefulInfoTip17': 'Theo dõi @opendesign.ai trên Instagram để lấy cảm hứng thiết kế.',
  'designFiles.usefulInfoTip18': 'Subscribe EduDeck trên YouTube để xem tutorial và demo.',
  'designFiles.usefulInfoTip19': 'Theo dõi EduDeck trên LinkedIn để xem tin sản phẩm.',
  'designFiles.usefulInfoTip20': 'Theo dõi EduDeck trên Xiaohongshu để xem tip và cảm hứng.',

  'browserUse.title': 'Cảm hứng',
  'browserUse.summary': '{count} web action, ưu tiên trích xuất asset, ngôn ngữ thiết kế, motion, kiểm tra visual và cấu trúc component.',
  'browserUse.searchAria': 'Tìm cảm hứng',
  'browserUse.searchPlaceholder': 'Tìm screenshot, font, màu, a11y...',
  'browserUse.empty': 'Không có cảm hứng khớp',
  'browserUse.unavailable': 'Cảm hứng không khả dụng ở đây',
  'browserUse.added': 'Đã thêm vào composer',
  'browserUse.category.assets': 'Trích xuất asset',
  'browserUse.category.tokens': 'Ngôn ngữ thiết kế',
  'browserUse.category.motion': 'Motion',
  'browserUse.category.visual': 'Kiểm tra visual',
  'browserUse.category.structure': 'Component',
  'browserUse.category.project': 'Chạy project',
  'browserUse.category.general': 'Chung',
  'browserUse.input.none': 'Không cần input',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Selector tùy chọn',
  'browserUse.input.requirementSelector': 'Yêu cầu, selector tùy chọn',
  'browserUse.input.selectorOptional': 'Selector tùy chọn',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selector, scale=2',
  'browserUse.input.gridOverlay': '12 cột, max 1200, gap 24',
  'browserUse.input.bodySelector': "selector='body'",
  'browserUse.input.navigate': 'URL, domain hoặc từ khóa tìm kiếm',
  'browserUse.input.selector': 'Selector',
  'browserUse.input.selectorText': 'Selector và text',
  'browserUse.input.scroll': 'Pixel, top, bottom hoặc page',
  'browserUse.input.terminalRun': 'Command, timeout 120s',
  'browserUse.input.command': 'Command',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Ứng viên logo tốt nhất từ header, nav, class name, vị trí, OG image và fallback favicon.',
  'browserUse.action.list_images.output': 'Tất cả ảnh img, srcset, source và CSS background với kích thước và alt text.',
  'browserUse.action.download_assets.output': 'Thư mục asset đã tải kèm _manifest.json có hỗ trợ referer và cookie.',
  'browserUse.action.extract_svgs.output': 'SVG inline và file .svg liên kết được lưu thành từng file SVG riêng.',
  'browserUse.action.optimize_svgs.output': 'File SVG đã optimize kèm tỷ lệ nén.',
  'browserUse.action.extract_colors.output': 'Palette có trọng số kèm CSS color variable :root thành palette.json và palette.html.',
  'browserUse.action.extract_fonts.output': 'Font family, size, weight hàng đầu và rule @font-face thành typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radius, shadow, spacing và CSS variable thành tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Type scale heading, body và button với size, weight, line-height và ratio.',
  'browserUse.action.extract_buttons.output': 'Thư viện style button đã dedupe thành buttons.html và buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Grid và flex container, direction, gap, column và max width thành layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoint responsive media-query thành breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS gradient thành gradients.css, gradients.json và preview HTML.',
  'browserUse.action.extract_shadows.output': 'Box shadow, text shadow và drop shadow thành shadows.json kèm preview.',
  'browserUse.action.extract_easings.output': 'Transition và animation easing function thành easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js và style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, transition và transform rule, thư viện motion phát hiện, motion.css và motion.json.',
  'browserUse.action.validate_view.output': 'Path screenshot kèm issue visual và layout có cấu trúc.',
  'browserUse.action.audit_layout.output': 'Lỗi layout gồm overflow, bounds, overlap và text bị cắt thành audit.json.',
  'browserUse.action.audit_accessibility.output': 'Issue a11y với selector, label, role, focus, contrast và screenshot khi hữu ích.',
  'browserUse.action.responsive_screenshots.output': 'Screenshot mobile 390, tablet 834 và desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Screenshot toàn trang vượt viewport.',
  'browserUse.action.screenshot_element.output': 'Screenshot một phần tử, mặc định 2x.',
  'browserUse.action.screenshot_with_grid.output': 'Screenshot kèm overlay layout grid.',
  'browserUse.action.screenshot_dark_mode.output': 'Screenshot với prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Style guide một trang với màu, type scale, radius và shadow.',
  'browserUse.action.extract_html.output': 'HTML sạch tự chứa, không có script, noscript hoặc inline event attribute.',
  'browserUse.action.extract_component_inventory.output': 'Pattern component lặp lại, selector, số lượng và screenshot.',
  'browserUse.action.extract_copy.output': 'Heading, CTA, body copy và mô tả thành copy.md và copy.json.',
  'browserUse.action.extract_nav.output': 'Navigation chính và footer link thành sitemap.md và nav.json.',
  'browserUse.action.extract_forms.output': 'Field form, label, hint validation và submit action thành forms.json.',
  'browserUse.action.run_project.output': 'URL dev server phát hiện được mở trong tab Browser.',
  'browserUse.action.detect_project.output': 'Framework, package manager, lệnh install, lệnh dev và port.',
  'browserUse.action.page_info.output': 'URL, title, description, OG image, theme color, favicon và viewport.',
  'browserUse.action.snapshot.output': 'Tối đa 120 phần tử text và tương tác đang thấy với tag, label, href và tọa độ.',
  'browserUse.action.navigate.output': 'Mở trang và trả về page_info.',
  'browserUse.action.click.output': 'Click phần tử khớp đầu tiên sau khi scroll vào view.',
  'browserUse.action.type_text.output': 'Điền input và dispatch event input/change.',
  'browserUse.action.scroll.output': 'Vị trí scroll hiện tại và tối đa.',
  'browserUse.action.extract_og_metadata.output': 'Meta title, description, canonical URL, OG/Twitter card, social image và theme color.',
  'browserUse.action.terminal_run.output': 'stdout, stderr và exit code.',
  'browserUse.action.terminal_run_background.output': 'Background task id và output gần đây.',
  'browserUse.action.terminal_read.output': 'Output terminal chung gần đây.',

  'designBrowser.savePageBrief': 'Lưu Page Brief',
  'designBrowser.viewport.desktop': 'Desktop',
  'designBrowser.viewport.desktopTitle': 'Dùng toàn bộ kích thước tab browser',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Preview rộng 820px',
  'designBrowser.viewport.mobile': 'Mobile',
  'designBrowser.viewport.mobileTitle': 'Preview rộng 390px',
  'designBrowser.menu': 'Menu browser',
  'designBrowser.copyScreenshot': 'Copy Screenshot',
  'designBrowser.hardReload': 'Hard Reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Mở trong Browser',
  'designBrowser.downloadPage': 'Download Page',
  'designBrowser.downloadPageBusy': 'Đang download page...',
  'designBrowser.clearHistory': 'Xóa lịch sử duyệt',
  'designBrowser.clearCookies': 'Xóa cookie',
  'designBrowser.clearAllData': 'Xóa toàn bộ dữ liệu',
  'designBrowser.status.noUrlToCopy': 'Không có URL để copy.',
  'designBrowser.status.urlCopied': 'Đã copy URL.',
  'designBrowser.status.openHttpFirst': 'Mở trang http hoặc https trước.',
  'designBrowser.status.openBeforeScreenshot': 'Mở một trang trước khi chụp screenshot.',
  'designBrowser.status.screenshotSaved': 'Đã lưu screenshot.',
  'designBrowser.addImageToChatButton': 'Thêm vào Chat',
  'designBrowser.status.imageAddedToChat': 'Đã thêm ảnh vào chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot thất bại.',
  'designBrowser.status.openBeforeBrief': 'Mở một trang trước khi lưu brief.',
  'designBrowser.status.briefSaveFailed': 'Lưu page brief thất bại.',
  'designBrowser.status.openBeforeDownload': 'Mở một trang trước khi lưu snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Đang lưu page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'Trang này không thể archive.',
  'designBrowser.status.pageSnapshotFailed': 'Lưu page snapshot thất bại.',
  'designBrowser.status.pageSnapshotSaved': 'Đã lưu page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'Xem File thiết kế',
  'designBrowser.status.downloadAssistHint': 'Khi trang sẵn sàng, bấm Download Page. Quay lại chat sau khi lưu xong.',
  'designBrowser.status.desktopDataUnavailable': 'Dữ liệu desktop browser không khả dụng ở đây.',
  'designBrowser.status.browserDataCleared': 'Đã xóa dữ liệu browser.',
  'designBrowser.status.browserDataClearFailed': 'Xóa dữ liệu browser thất bại.',
  'designBrowser.status.historyCleared': 'Đã xóa lịch sử.',
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Quay lại',
  'designBrowser.goForward': 'Tiến tới',
  'designBrowser.reload': 'Reload',
  'designBrowser.stopLoading': 'Dừng tải',
  'designBrowser.viewportAria': 'Viewport browser',
  'designBrowser.addressPlaceholder': 'Nhập URL hoặc tìm kiếm...',
  'designBrowser.addressAria': 'Địa chỉ browser',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'Lịch sử',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Mở trong Browser',
  'designBrowser.menu.savePageBrief': 'Lưu Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Xóa lịch sử duyệt',
  'designBrowser.menu.clearCookies': 'Xóa cookie',
  'designBrowser.menu.clearAllData': 'Xóa toàn bộ dữ liệu',
  'designBrowser.status.openHttpUrlFirst': 'Mở URL http trước',
  'designBrowser.status.openPageBeforeScreenshot': 'Mở một trang trước khi chụp screenshot',
  'designBrowser.status.screenshotCopied': 'Đã copy screenshot vào clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Mở một trang trước khi lưu brief',
  'designBrowser.status.openPageBeforeTools': 'Mở một trang trước khi dùng browser tool',
  'designBrowser.status.clickElementToComment': 'Click phần tử để comment',
  'designBrowser.status.clickElementToTune': 'Click phần tử để tune',
  'designBrowser.status.noElementSelected': 'Chưa chọn phần tử browser',
  'designBrowser.status.addBrowserComment': 'Thêm browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune phần tử rồi lưu HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune chỉ live với trang không thuộc project',
  'designBrowser.status.pickerFailed': 'Browser element picker thất bại',
  'designBrowser.status.applyStyleFailed': 'Không áp dụng được style trong browser page',
  'designBrowser.status.editTextFailed': 'Không sửa được text trong browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Chỉ trang HTML local trong project mới lưu được',
  'designBrowser.status.htmlSaved': 'Đã lưu thay đổi HTML',
  'designBrowser.status.htmlSaveFailed': 'Lưu HTML thất bại',
  'designBrowser.status.commentSavingUnavailable': 'Không thể lưu comment',
  'designBrowser.status.commentSaved': 'Đã lưu browser comment',
  'designBrowser.status.commentSendingUnavailable': 'Không thể gửi comment',
  'designBrowser.comments.aria': 'Browser comment',
  'designBrowser.comments.openFor': 'Mở browser comment cho {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Phần tử browser',
  'designBrowser.comment.close': 'Đóng browser comment',
  'designBrowser.comment.noteAria': 'Ghi chú browser comment',
  'designBrowser.comment.placeholder': 'Mô tả thay đổi hoặc vấn đề...',
  'designBrowser.comment.addNote': 'Thêm ghi chú',
  'designBrowser.comment.saveComment': 'Lưu comment',
  'designBrowser.comment.sending': 'Đang gửi...',
  'designBrowser.comment.sendToChat': 'Gửi vào chat',
  'designBrowser.inspect.editTitle': 'Sửa phần tử HTML',
  'designBrowser.inspect.tuneTitle': 'Tune phần tử browser',
  'designBrowser.inspect.closeTune': 'Đóng browser tune',
  'designBrowser.inspect.colors': 'Màu',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Nội dung',
  'designBrowser.inspect.elementText': 'Text phần tử',
  'designBrowser.inspect.saving': 'Đang lưu...',
  'designBrowser.inspect.saveHtml': 'Lưu HTML',
  'designBrowser.inspect.liveOnly': 'Chỉ live',
  'designBrowser.reference.kicker': 'EduDeck browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'Bộ reference được tuyển chọn về cảm hứng, UI sản phẩm thật, motion, màu, type, asset và design system. Mở một mục để duyệt live trong khi gom ngôn ngữ thiết kế cho artifact tiếp theo.',
  'designBrowser.reference.categoryAria': 'Category reference',
  'designBrowser.reference.searchPlaceholder': 'Tìm reference...',
  'designBrowser.reference.searchAria': 'Tìm reference',
  'designBrowser.reference.clearSearch': 'Xóa tìm kiếm',
  'designBrowser.reference.noMatches': 'Không có reference khớp "{query}".',
  'designBrowser.reference.clearFilters': 'Xóa bộ lọc',
  'designBrowser.reference.open': 'Mở',
  'designBrowser.reference.group.inspiration': 'Cảm hứng',
  'designBrowser.reference.group.interfaces': 'Giao diện thật',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Màu',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icon',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockup',
  'designBrowser.reference.group.systems': 'Design System',
  'designBrowser.reference.group.components': 'Component',
  'designBrowser.reference.group.guidelines': 'Guideline & A11y',
  'designBrowser.reference.group.tools': 'Tool & Resource',
  'designBrowser.reference.site.dribbble.detail': 'Design shot và cảm hứng UI.',
  'designBrowser.reference.site.behance.detail': 'Portfolio sáng tạo và case study.',
  'designBrowser.reference.site.awwwards.detail': 'Website design đoạt giải.',
  'designBrowser.reference.site.godly.detail': 'Modern web design được tuyển chọn.',
  'designBrowser.reference.site.land_book.detail': 'Gallery landing page và pattern.',
  'designBrowser.reference.site.mobbin.detail': 'Màn hình app thật và UI pattern.',
  'designBrowser.reference.site.screenlane.detail': 'UI design pattern mới nhất từ app.',
  'designBrowser.reference.site.pageflows.detail': 'User flow và onboarding sản phẩm thật.',
  'designBrowser.reference.site.uisources.detail': 'Interaction pattern từ các app hàng đầu.',
  'designBrowser.reference.site.collectui.detail': 'Bộ sưu tập Daily UI theo category.',
  'designBrowser.reference.site.gsap.detail': 'Animation engine production và ví dụ.',
  'designBrowser.reference.site.animations.detail': 'Animation pattern và ví dụ interaction.',
  'designBrowser.reference.site.transitions.detail': 'Transition pattern cho interface hiện đại.',
  'designBrowser.reference.site.motionsites.detail': 'Reference motion và interaction cao cấp.',
  'designBrowser.reference.site.motion.detail': 'Cảm hứng scroll và timeline animation.',
  'designBrowser.reference.site.animography.detail': 'Animated type và kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'Reference text animation React cho kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Tạo color palette nhanh.',
  'designBrowser.reference.site.colorhunt.detail': 'Color palette được tuyển chọn.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palette trên UI thật.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel và rule hài hòa màu.',
  'designBrowser.reference.site.happyhues.detail': 'Palette hiển thị trong context thật.',
  'designBrowser.reference.site.fonts_google.detail': 'Thư viện font open-source.',
  'designBrowser.reference.site.fontshare.detail': 'Font chất lượng miễn phí cho thương mại.',
  'designBrowser.reference.site.typewolf.detail': 'Font đang dùng thật và gợi ý pairing.',
  'designBrowser.reference.site.fontpair.detail': 'Gợi ý ghép font.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography trong thiết kế thực tế.',
  'designBrowser.reference.site.thesvg.detail': 'Asset SVG và vector reference.',
  'designBrowser.reference.site.svglogos.detail': 'Logo SVG sạch cho mock product và brand.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Icon sản phẩm và AI-brand cho interface.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ icon open-source trong một nơi.',
  'designBrowser.reference.site.lucide.detail': 'Bộ icon open sạch và nhất quán.',
  'designBrowser.reference.site.heroicons.detail': 'Icon SVG do Tailwind làm.',
  'designBrowser.reference.site.svgrepo.detail': 'Vector và icon SVG miễn phí.',
  'designBrowser.reference.site.storyset.detail': 'Vector illustration có thể tùy chỉnh.',
  'designBrowser.reference.site.undraw.detail': 'Illustration MIT open-source.',
  'designBrowser.reference.site.blush.detail': 'Illustration mix-and-match.',
  'designBrowser.reference.site.lummi.detail': 'Visual AI miễn phí.',
  'designBrowser.reference.site.whirrls.detail': 'Reference ảnh vẽ tay.',
  'designBrowser.reference.site.worldindots.detail': 'Reference dot-map và data-viz.',
  'designBrowser.reference.site.unsplash.detail': 'Ảnh độ phân giải cao miễn phí.',
  'designBrowser.reference.site.pexels.detail': 'Ảnh stock và video miễn phí.',
  'designBrowser.reference.site.pixabay.detail': 'Ảnh và media royalty-free.',
  'designBrowser.reference.site.cosmos.detail': 'Khám phá visual và mood board.',
  'designBrowser.reference.site.spline.detail': 'Thiết kế 3D trên browser.',
  'designBrowser.reference.site.threejs.detail': 'Reference và demo WebGL 3D.',
  'designBrowser.reference.site.womp.detail': 'Tạo 3D trong browser dễ dùng.',
  'designBrowser.reference.site.pixcap.detail': 'Icon 3D, mockup và scene.',
  'designBrowser.reference.site.shots.detail': 'Mockup thiết bị và browser.',
  'designBrowser.reference.site.mockuuups.detail': 'Mockup thiết bị kéo-thả.',
  'designBrowser.reference.site.angle.detail': 'Thư viện mockup thiết bị 3D.',
  'designBrowser.reference.site.rotato.detail': 'Mockup sản phẩm 3D animated.',
  'designBrowser.reference.site.impeccable.detail': 'Reference style và interface chất lượng cao.',
  'designBrowser.reference.site.styles_refero.detail': 'Reference style thiết kế và visual system.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand asset, logo và identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery design system công khai.',
  'designBrowser.reference.site.startups.detail': 'Reference sản phẩm và brand startup hàng đầu.',
  'designBrowser.reference.site.base_ui.detail': 'Primitive accessible không style cho custom system.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Component React composable dựng trên Radix và Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Thư viện component React và design system hiện đại.',
  'designBrowser.reference.site.radix_ui.detail': 'Primitive UI low-level accessible.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Primitive hành vi accessible từ Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Component accessible không style cho project Tailwind.',
  'designBrowser.reference.site.mui.detail': 'Hệ sinh thái component React dựa trên Material.',
  'designBrowser.reference.site.mantine.detail': 'Component và hook React đầy đủ tính năng.',
  'designBrowser.reference.site.chakra_ui.detail': 'Component React accessible với theme token.',
  'designBrowser.reference.site.ant.detail': 'Component system và pattern enterprise.',
  'designBrowser.reference.site.ark_ui.detail': 'Component headless cho các framework hiện đại.',
  'designBrowser.reference.site.daisyui.detail': 'Class component và theme Tailwind CSS.',
  'designBrowser.reference.site.developer_apple.detail': 'Guideline thiết kế platform Apple.',
  'designBrowser.reference.site.m3_material.detail': 'Material Design 3 của Google.',
  'designBrowser.reference.site.lawsofux.detail': 'Nguyên tắc và heuristic UX.',
  'designBrowser.reference.site.webaim.detail': 'Công cụ kiểm tra color contrast.',
  'designBrowser.reference.site.a11yproject.detail': 'Checklist và pattern accessibility.',
  'designBrowser.reference.site.toolfolio.detail': 'Tool, resource và collection thiết kế.',
  'designBrowser.reference.site.getdesign.detail': 'Resource thiết kế được tuyển chọn.',
  'designBrowser.reference.site.tasteskill.detail': 'Reference luyện taste thiết kế và critique.',
  'designBrowser.reference.site.uigoodies.detail': 'Resource thiết kế được chọn lọc.',
  'designBrowser.reference.site.sidebar.detail': 'Năm link thiết kế mỗi ngày.',
  'designBrowser.reference.site.github.detail': 'Implementation reference cho workflow browser nhúng.',

  'chat.connectionDropped': 'Kết nối tới dịch vụ model bị ngắt trước khi phản hồi hoàn tất, thường do mạng hoặc proxy không ổn định. Vui lòng thử lại.',
  'chat.selectFromLibrary': 'Nhập từ thư viện',
  'chat.importFigma': 'Nhập từ Figma',
  'chat.plus.group.files': 'File',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Thiết kế',
  'chat.plus.group.other': 'Khác',
  'chat.plus.attachFiles': 'Đính kèm file',
  'chat.plus.referenceProject': 'Dự án tham chiếu khác',
  'chat.plus.linkLocalCode': 'Liên kết code local',
  'chat.plus.uploadFig': 'Tải file .fig lên',
  'chat.plus.learnHow': 'Tìm hiểu cách làm',
  'chat.plus.designSystem': 'Hệ thiết kế',
  'chat.plus.skills': 'Kỹ năng',
  'chat.plus.noSkills': 'Không có kỹ năng',
  'chat.plus.connectors': 'Kết nối',
  'chat.plus.plugins': 'Tiện ích',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Dự án tham chiếu khác',
  'chat.referenceProject.search': 'Tìm dự án...',
  'chat.referenceProject.empty': 'Không có dự án khớp "{query}"',
  'chat.referenceProject.emptyAll': 'Chưa có dự án khác',
  'chat.referenceProject.loadFailed': 'Không tải được dự án. Kiểm tra daemon đang chạy rồi thử lại.',
  'chat.referenceProject.confirm': 'Dự án tham chiếu',
  'chat.contextPrompt.referenceProject': 'Dùng project EduDeck "{name}" làm context tham chiếu. Path local của nó là: {path}. Trước khi thiết kế hoặc sửa gì, hãy tìm và đọc thư mục này khi hữu ích.',
  'chat.contextPrompt.localCode': 'Dùng thư mục code local "{name}" làm code reference. Path tuyệt đối là: {path}. Đọc các file liên quan khi hữu ích và giữ nhất quán với implementation hiện có.',
  'chat.figmaHelp.title': 'Cách tải file .fig',
  'chat.figmaHelp.intro': 'Từ Figma web hoặc desktop app:',
  'chat.figmaHelp.step1': 'Mở file trong Figma.',
  'chat.figmaHelp.step2': 'Vào File -> Save local copy... (web: main menu -> File).',
  'chat.figmaHelp.step3': 'Figma sẽ tải file .fig. Thả file vào composer hoặc tải lên.',
  'chat.figmaHelp.note': 'File .fig được parse local và không tải lên Figma.',
  'chat.collapsePane': 'Thu gọn panel cuộc trò chuyện',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comment',
  'chat.commentsSoon': 'Comment - sắp có',
  'chat.annotationNotePlaceholder': 'Thêm ghi chú cho mark này',
  'chat.annotationAttachImage': 'Đính kèm ảnh',
  'chat.annotationAttachedImages': 'Ảnh đã đính kèm',
  'chat.annotationAttachedRemove': 'Gỡ ảnh cuối',
  'chat.annotationAddToInput': 'Thêm vào input',
  'chat.annotationAddingToInput': 'Đang thêm...',
  'chat.annotationQueue': 'Xếp hàng',
  'chat.annotationQueueing': 'Đang xếp hàng...',
  'chat.annotationSubmitOptions': 'Tùy chọn gửi',
  'chat.annotationSending': 'Đang gửi...',
  'chat.annotationSendDisabledReason': 'Một task đang chạy',
  'chat.annotationPreviewMissing': 'Không chụp được preview. Vui lòng thử lại.',
  'chat.annotationPreviewMissingInk': 'Không chụp được preview. Thử lại để tránh chỉ gửi nét vẽ.',
  'chat.annotationSentWithoutScreenshot': 'Không chụp được preview. Annotation đã được gửi không kèm screenshot.',
  'chat.annotationTimeout': 'Gửi annotation timeout. Vui lòng thử lại.',
  'chat.annotationFailed': 'Gửi annotation thất bại. Vui lòng thử lại.',
  'chat.annotationProjectCreateFailed': 'Không tạo được project nên annotation chưa được gửi.',
  'chat.annotationUploadFailed': 'Tải attachment lên thất bại. Vui lòng thử lại.',
  'chat.conversationsTitle': 'Cuộc trò chuyện',
  'chat.conversationsAria': 'Lịch sử cuộc trò chuyện',
  'chat.newConversation': 'Cuộc trò chuyện mới',
  'chat.newConversationsTitle': 'Cuộc trò chuyện mới',
  'chat.conversationsHeading': 'Cuộc trò chuyện',
  'chat.new': 'Mới',
  'chat.emptyConversations': 'Chưa có cuộc trò chuyện.',
  'chat.deleteConversation': 'Xóa cuộc trò chuyện',
  'chat.renameConversationLabel': 'Đổi tên "{title}"',
  'chat.deleteConversationConfirm': 'Xóa "{title}"? Thao tác này xóa tin nhắn của nó.',
  'chat.untitledConversation': 'Cuộc trò chuyện chưa đặt tên',
  'chat.forkedConversationTitle': 'Fork của {title}',
  'chat.forkConversationFailed': 'Không fork được cuộc trò chuyện này.',
  'chat.startTitle': 'Bắt đầu cuộc trò chuyện',
  'chat.startHint': 'Mô tả thứ bạn muốn tạo, hoặc bắt đầu từ một trong các ví dụ này:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist cần desktop app để EduDeck đọc được trang browser live.',
  'chat.brandBrowserAssistReadFailed': 'Không đọc được trang browser. Bảo đảm site brand đã mở và tải xong.',
  'chat.brandBrowserAssistMessage': 'EduDeck cần browser assist để hoàn tất trích xuất brand này. Dùng card bên dưới để mở Browser, sau đó bấm More, chọn Download Page, chờ thông báo thành công, rồi dùng card Next Step bên trái để tiếp tục trích xuất. Nếu không thấy card, tự mở tab Browser bên phải và làm theo More > Download Page > Continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'Không có page snapshot đã lưu cho URL này.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Không đọc được page snapshot đã lưu.',
  'chat.brandBrowserSnapshotSaveFailed': 'Không lưu được page snapshot từ browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser đã mở',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Bước 1: mở hoặc chuyển sang tab Browser bên phải và xử lý mọi kiểm tra người dùng. Bước 2: bấm More, rồi Download Page. Bước 3: chờ thông báo lưu snapshot thành công. Bước 4: quay lại card Next Step bên trái và bấm Continue extraction để tiếp tục trích xuất bằng chương trình.',
  'chat.fillInputTitle': 'Bấm để điền input',
  'chat.jumpToLatest': 'Nhảy tới mới nhất',
  'chat.scrollToLatest': 'Cuộn tới mới nhất',
  'chat.messageRail.aria': 'Điều hướng tin nhắn người dùng',
  'chat.messageRail.jumpAria': 'Nhảy tới tin nhắn người dùng {index}',
  'chat.messageRail.empty': '(Không có nội dung)',
  'chat.you': 'Bạn',
  'chat.openFile': 'Mở {name}',
  'chat.copyPrompt': 'Sao chép nội dung yêu cầu',
  'chat.copyErrorDiagnostic': 'Copy chẩn đoán lỗi',
  'chat.copyDone': 'Đã copy!',
  'chat.inspect.noEditableTargets': 'Không tìm thấy text hoặc style target có thể sửa.',
  'chat.inspect.noCommentTargets': 'Không tìm thấy text hoặc visual target có thể comment.',
  'chat.inspect.editHint': 'Chọn text hoặc style target trong preview để sửa.',
  'chat.inspect.commentHint': 'Chọn text hoặc một vùng trong preview để comment.',
  'chat.composerPlaceholder': 'Mô tả thứ bạn muốn tạo...',
  'chat.activeFileEditingLabel': 'Đang sửa',
  'chat.activeFilePlaceholder': 'Yêu cầu EduDeck thay đổi {file}...',
  'chat.designArtifactsShowMore': 'Hiện thêm {count} file thiết kế',
  'chat.mode.chat.label': 'Hỏi',
  'chat.mode.chat.title': 'Chế độ hỏi',
  'chat.mode.chat.summary': 'Cho câu trả lời nhanh, chỉnh sửa, lập kế hoạch và thảo luận mà không giả định phải tạo artifact thiết kế.',
  'chat.mode.chat.solves': 'Dùng để làm rõ ý tưởng, debug nội dung yêu cầu, so sánh lựa chọn hoặc hỏi về công việc hiện có.',
  'chat.mode.chat.query1': 'Tóm tắt draft này và chỉ ra lỗ hổng.',
  'chat.mode.chat.query2': 'Giúp tôi quyết định cấu trúc tốt nhất cho landing page này.',
  'chat.mode.chat.query3': 'Review thiết kế này và gợi ý cải thiện cụ thể.',
  'chat.mode.plan.label': 'Plan',
  'chat.mode.plan.title': 'Chế độ plan',
  'chat.mode.plan.summary': 'Tạo tài liệu kế hoạch có thể sửa trước, rồi chuyển sang Design sau khi bạn review.',
  'chat.mode.plan.solves': 'Dùng cho PRD, outline slide, brief prototype, wireframe, storyboard và yêu cầu rộng cần xác nhận trước khi tạo.',
  'chat.mode.plan.query1': 'Tạo outline PPT từng slide trước.',
  'chat.mode.plan.query2': 'Soạn PRD trước khi tạo prototype.',
  'chat.mode.plan.query3': 'Biến ý tưởng này thành plan thiết kế có thể sửa.',
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Chế độ design',
  'chat.mode.design.summary': 'Để tạo hoặc thay đổi output cụ thể: trang, bản mẫu, tài liệu tương tác, slide, ảnh, video, HyperFrames, audio, dashboard và file dự án.',
  'chat.mode.design.solves': 'Dùng khi bạn muốn EduDeck tạo file, cập nhật workspace hoặc biến brief thành sản phẩm bàn giao đa phương tiện.',
  'chat.mode.design.query1': 'Tạo landing page launch sản phẩm và prototype HyperFrames từ brief này.',
  'chat.mode.design.query2': 'Tạo investor deck 10 slide có speaker notes.',
  'chat.mode.design.query3': 'Tạo concept ảnh, video và audio cho campaign này.',
  'chat.mode.cardBestFor': 'Phù hợp nhất cho',
  'chat.mode.cardTry': 'Thử hỏi',
  'chat.mode.cardCost': 'Mức dùng thường gặp',
  'chat.mode.chat.cost': 'Nhẹ',
  'chat.mode.chat.costNote': 'Chỉ là cuộc trò chuyện, không generate gì nên dùng ít nhất.',
  'chat.mode.plan.cost': 'Chuẩn',
  'chat.mode.plan.costNote': 'Tạo một tài liệu plan có thể sửa trước mọi generation.',
  'chat.mode.design.cost': 'Nặng',
  'chat.mode.design.costNote': 'Generate file và media đa phương tiện, nên một lượt có thể dùng nhiều nhất.',
  'chat.modePicker.choose': 'Chọn chế độ',
  'chat.modePicker.current': 'Chế độ: {name}',
  'chat.modePicker.clear': 'Xóa chế độ',
  'chat.modePicker.mode': 'Chế độ',
  'chat.composerHint': '⌘/Ctrl + Enter để gửi · gồm mục tiêu, nội dung, style và format',
  'chat.cliSettingsTitle': 'Cài đặt CLI & model',
  'chat.cliSettingsAria': 'Mở cài đặt CLI và model',
  'chat.attachTitle': 'Đính kèm file (hoặc dán / thả)',
  'chat.addContextTitle': 'Thêm context',
  'chat.attachAria': 'Đính kèm file',
  'chat.importTitle': 'Nhập nguồn (sắp có)',
  'chat.importLabel': 'Nhập',
  'chat.importComingSoon': 'Sắp có',
  'chat.importSoon': 'Sớm',
  'chat.importFig': 'Tải file .fig lên',
  'chat.importGitHub': 'Kết nối GitHub',
  'chat.importWeb': 'Lấy phần tử web',
  'chat.importFolder': 'Liên kết thư mục code',
  'chat.importSkills': 'Hệ thiết kế',
  'chat.importProject': 'Dự án tham chiếu khác',
  'chat.importDesignSystemHeader': 'Chọn hệ thiết kế',
  'chat.importDesignSystemBack': 'Quay lại',
  'chat.importDesignSystemSearch': 'Tìm hệ thiết kế...',
  'chat.importDesignSystemEmpty': 'Không có hệ thiết kế khớp "{query}"',
  'chat.importDesignSystemNone': 'Không dùng - freeform',
  'chat.importDesignSystemNoneSub': 'Không neo vào system nào trong lượt này',
  'chat.importDesignSystemActive': 'Đang dùng',
  'chat.importDesignSystemSwitched': 'Đã đổi hệ thiết kế sang {title}',
  'chat.importDesignSystemFailed': 'Không đổi được hệ thiết kế. Vui lòng thử lại.',
  'chat.importDesignSystemLoadFailed': 'Không tải được hệ thiết kế.',
  'chat.designToolbox.title': 'Hộp công cụ thiết kế',
  'chat.designToolbox.tooltip': 'Design toolbox',
  'chat.designToolbox.aria': 'Mở design toolbox',
  'chat.designToolbox.searchPlaceholder': 'Tìm file slide, design token và tab đang mở...',
  'chat.designToolbox.searchAria': 'Tìm resource trong design toolbox',
  'chat.designToolbox.followupSection': 'Theo sau',
  'chat.designToolbox.resourcesSection': 'Resource toàn cục',
  'chat.designToolbox.selected': 'Đã chọn',
  'chat.designToolbox.noResources': 'Không tìm thấy resource cho "{query}".',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Ảnh',
  'chat.designToolbox.badge.motion': 'Motion',
  'chat.designToolbox.badge.polish': 'Polish',
  'chat.designToolbox.action.auto-match.title': 'Khớp bước tiếp theo',
  'chat.designToolbox.action.auto-match.badge': 'Khớp',
  'chat.designToolbox.action.auto-match.description': 'Xác định taste bar trước, rồi khớp skill, MCP, plugin, connector và file.',
  'chat.designToolbox.action.asset-search.title': 'Tìm ảnh / reference',
  'chat.designToolbox.action.asset-search.badge': 'Asset',
  'chat.designToolbox.action.asset-search.description': 'Tìm ảnh dùng được, screenshot reference, moodboard và ứng viên nguồn cho thiết kế hiện tại.',
  'chat.designToolbox.action.icon-workflow.title': 'Tìm / thay icon',
  'chat.designToolbox.action.icon-workflow.badge': 'Icon',
  'chat.designToolbox.action.icon-workflow.description': 'Tìm, tạo hoặc thay iconography, SVG, icon Lucide và ký hiệu visual với style nhất quán.',
  'chat.designToolbox.action.image-replace.title': 'Thay ảnh trên trang',
  'chat.designToolbox.action.image-replace.badge': 'Đổi',
  'chat.designToolbox.action.image-replace.description': 'Audit imagery hiện tại và thay ảnh hero, section, background hoặc card yếu bằng asset tốt hơn.',
  'chat.designToolbox.action.reference-extract.title': 'Trích xuất visual reference',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Phân tích screenshot hoặc site reference để lấy palette, typography, posture layout, motion và hướng asset.',
  'chat.designToolbox.action.motion.title': 'Thêm animation / motion',
  'chat.designToolbox.action.motion.badge': 'Motion',
  'chat.designToolbox.action.motion.description': 'Thêm motion entrance, scroll, state-transition và micro-interaction vào HTML hoặc phần tử trang hiện tại.',
  'chat.designToolbox.action.motion-polish.title': 'Polish motion',
  'chat.designToolbox.action.motion-polish.badge': 'Timing',
  'chat.designToolbox.action.motion-polish.description': 'Review timing, easing, performance và fallback reduced-motion cho motion hiện có.',
  'chat.designToolbox.action.transition-motion.title': 'Thiết kế transition',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Thiết kế transition page, scene, loading và state với timing tiết chế và fallback reduced-motion.',
  'chat.designToolbox.action.threejs-scene.title': 'Scene 3D / Three.js',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Thêm hoặc lên plan visual tương tác kiểu Three.js, Spline, Vanta, particle, WebGL, map hoặc deck.gl.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Bỏ cảm giác AI',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Taste',
  'chat.designToolbox.action.anti-ai-polish.description': 'Loại bỏ cảm giác template, gradient AI, stack card rẻ tiền và copy mơ hồ.',
  'chat.designToolbox.action.visual-polish.title': 'Polish thiết kế / sẵn sàng ship',
  'chat.designToolbox.action.visual-polish.badge': 'Polish',
  'chat.designToolbox.action.visual-polish.description': 'Audit visual hierarchy, type, spacing, responsive, accessibility và chất lượng bàn giao.',
  'chat.designToolbox.action.image-gen.title': 'Tạo ảnh / visual reference',
  'chat.designToolbox.action.image-gen.badge': 'Ảnh',
  'chat.designToolbox.action.image-gen.description': 'Tạo reference section, asset, icon, social image hoặc moodboard cho trang hiện tại.',
  'chat.designToolbox.action.chart-gen.title': 'Tạo chart / diagram',
  'chat.designToolbox.action.chart-gen.badge': 'Chart',
  'chat.designToolbox.action.chart-gen.description': 'Tạo ECharts, React Flow, diagram, dashboard, relationship map hoặc asset data-visualization.',
  'chat.designToolbox.action.logo-gen.title': 'Tạo logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Tạo route logo, wordmark, lockup, mark và prompt identity-system cho brand hiện tại.',
  'chat.designToolbox.action.plan-outline.title': 'Tạo outline PPT từ ý tưởng',
  'chat.designToolbox.action.plan-outline.badge': 'Plan',
  'chat.designToolbox.action.plan-outline.description': 'Biến ý tưởng thô thành outline deck Markdown có thể sửa trước khi tạo slide.',
  'chat.designToolbox.action.video-gen.title': 'Tạo video / motion script',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Biến thiết kế thành video ngắn, storyboard Remotion / Hyperframes hoặc prompt sẵn sàng generate.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Template MCP',
  'chat.designToolbox.kind.connector': 'Connector',
  'chat.designToolbox.kind.designFile': 'File thiết kế',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'File thiết kế',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Thư mục',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat bên cạnh',
  'chat.designToolbox.context.liveArtifact': 'Live artifact',
  'chat.designToolbox.context.file': 'File',
  'chat.designToolbox.prompt.contextGeneric': 'Mục tiêu hiện tại: HTML / file thiết kế / phần tử web đang mở.',
  'chat.designToolbox.prompt.contextSpecific': 'Mục tiêu hiện tại: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Giữ nguyên ý định đã có trong composer: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill đã chọn: {skill}. Dùng nó làm workflow chính cho lượt này.',
  'chat.designToolbox.prompt.noSkill': 'Nếu không có skill cụ thể khớp, trước tiên chọn tổ hợp tốt nhất từ skill, MCP, plugin, connector và file thiết kế có sẵn.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Hãy đóng vai Creative Director orchestrator và hoàn tất một workflow thiết kế:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Trước tiên định nghĩa "thiết kế đẹp" nghĩa là gì: audience, mục tiêu kinh doanh, cảm giác brand, style reference, mật độ thông tin, chuẩn màu/type/motion/asset và pattern AI/template cần tránh.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Tìm và khớp toàn bộ resource index phía trên. Đừng chỉ dùng gợi ý design toolbox; kết hợp skill, MCP, plugin, connector và file thiết kế khi hữu ích.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Nếu target hoặc aesthetic bar vẫn chưa rõ, hãy hướng dẫn tôi bằng question-form có cấu trúc, gồm default khuyến nghị, và mỗi câu hỏi lựa chọn hữu hạn phải có field custom answer có thể sửa. Nếu đủ rõ, thực hiện trực tiếp bước tiếp theo.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Hoàn tất flow theo thứ tự: chẩn đoán -> hướng style -> chọn resource -> sửa/generate cụ thể -> kiểm chứng. Ở mỗi bước, giải thích vì sao chọn các resource này và điều gì cần xác nhận tiếp.',
  'chat.designToolbox.prompt.assetSearch': 'Tìm asset ảnh/reference tốt nhất cho thiết kế hiện tại. Tìm trong file có sẵn, connector, MCP, browser capture và tool generation. Trả về ứng viên cụ thể kèm ghi chú sử dụng, lưu ý license/source khi cần, và prompt generation dự phòng nếu không có asset dùng được.',
  'chat.designToolbox.prompt.iconWorkflow': 'Cải thiện hệ icon cho thiết kế hiện tại: tìm icon thiếu, thay icon yếu, giữ stroke/fill/radius/weight nhất quán, ưu tiên thư viện icon hiện có khi có, và chỉ tạo SVG/prompt icon khi icon thư viện không đủ.',
  'chat.designToolbox.prompt.imageReplace': 'Audit mọi slot ảnh đang thấy trong thiết kế hiện tại, xác định ảnh yếu hoặc placeholder, rồi thay hoặc chỉ định ảnh hero, section, background, card và social tốt hơn. Giữ layout và cung cấp lựa chọn file/prompt/source cụ thể.',
  'chat.designToolbox.prompt.referenceExtract': 'Dùng ảnh/site/file thiết kế reference hiện tại làm input visual. Trích xuất palette, type scale, rhythm layout, posture component, cue motion và style asset, rồi áp dụng kết quả đó vào thiết kế hiện tại mà không copy nguyên văn asset brand được bảo hộ.',
  'chat.designToolbox.prompt.motion': 'Thêm motion chất lượng cao vào HTML / phần tử trang hiện tại: chọn 1-2 khoảnh khắc entrance, scroll, state-transition, transition, motion icon kiểu Rive/Lottie hoặc micro-interaction GSAP/Motion hữu ích nhất. Giữ tiết chế, ưu tiên transform / opacity và gồm fallback prefers-reduced-motion.',
  'chat.designToolbox.prompt.planOutline': 'Tạo hoặc cập nhật tài liệu planning Markdown cho outline PPT/deck từ ý tưởng này. Chưa tạo deck cuối. Gồm title từng slide, mục tiêu, bullet nội dung, hướng visual, dữ liệu/asset cần có và câu hỏi mở. Lưu thành file `.md` trong File thiết kế và nói tôi cần review file nào.',
  'chat.designToolbox.prompt.motionPolish': 'Review và polish timing, easing, performance và accessibility của motion hiện có. Gỡ animation đột ngột, rẻ tiền hoặc hại khả năng đọc; dùng timeline tinh tế hơn khi cần.',
  'chat.designToolbox.prompt.transitionMotion': 'Thiết kế transition chất lượng cao cho thiết kế hiện tại: đổi page/scene, loading bridge, state change và handoff giữa section. Dùng GSAP/Motion/CSS khi phù hợp, giữ hiệu năng tốt và có reduced-motion.',
  'chat.designToolbox.prompt.threejsScene': 'Lên plan hoặc implement visual Three.js/WebGL tập trung cho thiết kế hiện tại. Cân nhắc Three.js, scene kiểu Spline, Vanta background, particle system, layer dữ liệu Mapbox/deck.gl hoặc hiệu ứng browser portal, nhưng giữ scene hữu ích và kiểm chứng nó render.',
  'chat.designToolbox.prompt.antiAiPolish': 'Làm một lượt polish chống cảm giác AI: bỏ layout template, gradient/glow rẻ, stack card vô nghĩa và copy mơ hồ. Giữ thông tin và làm nó giống sản phẩm do designer thật bàn giao.',
  'chat.designToolbox.prompt.visualPolish': 'Polish thiết kế này tới mức sẵn sàng ship: kiểm tra hierarchy, typography, spacing, responsive, button state, empty/loading/error state và accessibility; sửa trực tiếp các vấn đề quan trọng nhất.',
  'chat.designToolbox.prompt.imageGen': 'Tạo plan visual-asset tiếp theo cho thiết kế này: reference section, asset hero, illustration, icon, social image hoặc moodboard. Trước tiên quyết định thiếu loại ảnh nào, rồi cung cấp prompt generation / file plan có thể thực thi.',
  'chat.designToolbox.prompt.chartGen': 'Tạo chart, diagram hoặc data-visualization đúng cho thiết kế hiện tại. Chọn giữa ECharts, React Flow, diagram SVG/CSS, radar chart, relationship map, dashboard hoặc visualization deck.gl/map dựa trên dữ liệu và mục tiêu người dùng.',
  'chat.designToolbox.prompt.logoGen': 'Tạo hướng logo và identity cho brand hiện tại. Tạo nhiều route cho wordmark, symbol, lockup, palette, rule sử dụng và prompt generation; bảo đảm kết quả nguyên bản và dùng được trong artifact hiện tại.',
  'chat.designToolbox.prompt.videoGen': 'Chuyển thiết kế này theo hướng video: tạo storyboard video ngắn, cấu trúc frame Hyperframes / Remotion hoặc prompt sẵn sàng cho Sora/fal. Ưu tiên biến nội dung HTML / trang hiện có thành shot tự nhiên.',
  'chat.designToolbox.prompt.useSkill': 'Dùng {skill} trên thiết kế hiện tại.',
  'chat.designToolbox.prompt.skillInstruction': 'Trước tiên quyết định mục tiêu follow-up tốt nhất, rồi hoàn tất một lượt cụ thể. Nếu phụ thuộc asset ngoài hoặc API, cung cấp fallback chạy được hoặc nói rõ tôi cần cung cấp gì.',
  'chat.designToolbox.prompt.selectedResource': 'Resource đã chọn: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Mô tả resource: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Dùng plugin này làm context chính cho flow thiết kế hiện tại. Nếu nó expose input hoặc GenUI, hướng dẫn tôi chọn khi cần; nếu không khớp target, chọn resource toàn cục tốt hơn và giải thích vì sao.',
  'chat.designToolbox.prompt.mcpResource': 'Ưu tiên capability MCP này cho bước thiết kế tiếp theo. Khi cần asset ngoài, web capture, tạo ảnh/video hoặc dữ liệu, trước tiên quyết định nó có làm được việc không, rồi đưa plan có thể thực thi.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'MCP này là template có thể cấu hình. Nếu nó là tool hữu ích nhất cho bước thiết kế này, hướng dẫn setup trước; nếu có alternative đã cấu hình, tiếp tục với alternative đó.',
  'chat.designToolbox.prompt.connectorResource': 'Dùng connector này khi cần dữ liệu thật, asset, nội dung tài khoản hoặc truy cập workflow bên ngoài. Trước khi dùng, giải thích sẽ đọc/ghi gì và hỏi xác nhận khi phù hợp.',
  'chat.designToolbox.prompt.fileResource': 'Dùng file thiết kế này làm target hiện tại hoặc asset reference và hoàn tất bước tiếp theo từ nó. Nếu cần so sánh file khác, tiếp tục tìm trong toàn bộ file thiết kế.',
  'chat.designToolbox.prompt.resourceIndex': 'Resource index toàn cục: skill({skills}), plugin({plugins}), MCP({mcpEnabled} bật / {mcpTemplates} template), connector({connectors} đã kết nối), file thiết kế({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skill có thể tìm',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugin có thể tìm',
  'chat.designToolbox.prompt.availableMcp': 'MCP có sẵn',
  'chat.designToolbox.prompt.connectedConnectors': 'Connector đã kết nối',
  'chat.designToolbox.prompt.referenceDesignFiles': 'File thiết kế reference',
  'chat.designToolbox.prompt.mcpTemplateName': 'Template {name}',
  'chat.designToolbox.prompt.processRule': 'Rule workflow: định nghĩa mục tiêu thẩm mỹ và ràng buộc trước, rồi tìm và khớp resource; khi cần người dùng chọn, tạo question-form có cấu trúc với custom answer có thể sửa và tiếp tục sau khi xác nhận.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} nữa',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',

  'chat.amrCard.switchTitle': 'Lệnh gọi model thất bại - lượt chạy đang tạm dừng',
  'chat.amrCard.switchBody': 'Đổi sang model local hoặc BYOK rồi chạy lại lượt này.',
  'chat.amrCard.chipOfficial': 'Local/BYOK',
  'chat.amrCard.chipNoKey': 'Chưa có API key',
  'chat.amrCard.chipAutoRetry': 'Tự retry sau khi cấu hình',
  'chat.amrCard.switchCta': 'Đổi model và retry',
  'chat.amrError.authMessage': 'Model này không khả dụng ở chế độ local. Chọn local CLI hoặc provider BYOK rồi thử lại.',
  'chat.amrError.balanceMessage': 'Model này không khả dụng ở chế độ local. Chọn local CLI hoặc provider BYOK rồi thử lại.',
  'chat.amrError.authorizeCta': 'Mở cài đặt và retry',
  'chat.amrBalanceGate.title': 'Chọn model local để tiếp tục',
  'chat.amrBalanceGate.message': 'Model hiện tại không khả dụng ở chế độ local ({balance} còn lại). Đổi sang local CLI hoặc BYOK để bắt đầu tác vụ.',
  'chat.amrBalanceGate.benefitsTitle': 'Thiết lập model local',
  'chat.amrBalanceGate.benefit1': 'Dùng CLI local hoặc API key của bạn',
  'chat.amrBalanceGate.benefit2': 'Chạy agent thiết kế qua cấu hình local/BYOK',
  'chat.amrBalanceGate.benefit3': 'Không cần đăng nhập cloud trong bản local này',
  'chat.amrBalanceGate.benefit4': 'Có thể đổi provider, model và endpoint trong Settings',
  'chat.amrBalanceGate.laterCta': 'Để sau',
  'chat.amrBalanceGate.plansCta': 'Mở cài đặt model',
  'chat.amrBalanceGate.signedOutTitle': 'Chọn model local',
  'chat.amrBalanceGate.signedOutMessage': 'Agent này đã tắt ở chế độ local. Chọn local CLI hoặc provider BYOK để tiếp tục.',
  'chat.amrBalanceGate.signInCta': 'Mở cài đặt',
  'chat.amrBalanceGate.watchingWallet': 'Chúng tôi sẽ tiếp tục tự động sau khi cấu hình model cập nhật.',
  'chat.amrLowBalance.title': 'Model hiện tại không đủ điều kiện chạy',
  'chat.amrLowBalance.message': 'Chỉ còn {balance} allowance, có thể không đủ để hoàn tất tác vụ. Đổi sang model local/BYOK trước.',
  'chat.amrLowBalance.rechargeCta': 'Mở cài đặt model',
  'chat.amrLowBalance.proceedCta': 'Vẫn bắt đầu',
  'chat.amrLowBalance.dontRemind': 'Đừng hỏi lại',
  'chat.amrArtifactUpgrade.title': 'Tiếp tục refine với model đã cấu hình',
  'chat.amrArtifactUpgrade.message': 'Đổi sang model local/BYOK mạnh hơn hoặc tăng cấu hình provider để tiếp tục.',
  'chat.amrArtifactUpgrade.benefit1': 'Chọn model nâng cao từ provider của bạn',
  'chat.amrArtifactUpgrade.benefit2': 'Tùy chỉnh số task chạy song song qua cấu hình local',
  'chat.amrArtifactUpgrade.benefit3': 'Dùng quota từ tài khoản provider của bạn',
  'chat.amrArtifactUpgrade.benefit4': 'Ưu tiên endpoint và runtime bạn kiểm soát',
  'chat.amrArtifactUpgrade.promoBanner': 'Cấu hình local/BYOK để tiếp tục',
  'chat.amrArtifactUpgrade.countdownLabel': 'Trạng thái',
  'chat.amrArtifactUpgrade.plansCta': 'Mở cài đặt model',
  'chat.amrArtifactUpgrade.homePlansCta': 'Cài model',
  'chat.amrArtifactUpgrade.laterCta': 'Tiếp tục với cấu hình hiện tại và gửi',
  'chat.amrArtifactUpgrade.homeTitle': 'Artifact đã sẵn sàng. Tiếp tục với model đã cấu hình.',
  'chat.amrArtifactUpgrade.homeMessage': 'Dùng local CLI hoặc BYOK provider để refine tiếp.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Xem sản phẩm',
  'chat.antigravityError.launchTerminalCta': 'Đăng nhập qua terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Đổi model trong terminal',
  'chat.mentionTabsAria': 'Bề mặt mention',
  'chat.mentionTabAll': 'Tất cả',
  'chat.mentionTabTabs': 'Tab',
  'chat.mentionTabPlugins': 'Plugin',
  'chat.mentionTabSkills': 'Skill',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connector',
  'chat.mentionTabFiles': 'File thiết kế',
  'chat.mentionNoResults': 'Không có kết quả cho "{query}".',
  'chat.mentionSearchPrompt': 'Tìm file slide, design token và tab đang mở.',
  'chat.mentionSectionTabs': 'Tab',
  'chat.mentionSectionPlugins': 'Plugin',
  'chat.mentionSectionSkills': 'Skill',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connector',
  'chat.mentionSectionFiles': 'File thiết kế',
  'chat.mentionActiveSkill': 'Đang dùng',
  'chat.mentionUseMcpTitle': 'Dùng {name}',
  'chat.mentionUseConnectorTitle': 'Dùng {name}',
  'chat.mentionPluginOfficial': 'Chính thức',
  'chat.mentionPluginMine': 'Plugin của tôi',
  'chat.linkedFolderRemoveAria': 'Gỡ thư mục liên kết {path}',
  'chat.linkedFolderNotFound': 'Thư mục không tồn tại',
  'chat.linkedFolderAlready': 'Thư mục này đã được liên kết',
  'chat.linkedFolderPickError': 'Không mở được folder picker',
  'chat.queuedHeader': 'Đang xếp hàng',
  'chat.queuedToSend': 'để gửi',
  'chat.queuedEditQueuedTaskAria': 'Sửa task đang xếp hàng',
  'chat.queuedSave': 'Lưu',
  'chat.queuedCancel': 'Hủy',
  'chat.queuedReorder': 'Kéo để đổi thứ tự',
  'chat.queuedEdit': 'Sửa',
  'chat.queuedMore': 'mục nữa đang xếp hàng',
  'chat.queuedFollowUpFallback': 'Follow-up đang xếp hàng',
  'chat.send': 'Gửi',
  'chat.stop': 'Dừng',
  'chat.removeAria': 'Gỡ {name}',
  'chat.example1Title': 'Pitch deck roadshow',
  'chat.example1Tag': 'Deck',
  'chat.example1Prompt': 'Tạo investor roadshow deck 10 slide cho studio thiết kế seed-stage. Gồm cover, problem, insight, product, market, traction, business model, team, ask và contact. Polish editorial, chart sắc nét, narrative mạnh và đủ tiết chế cho buổi họp investor.',
  'chat.example2Title': 'Landing page app ghi chú',
  'chat.example2Tag': 'Landing',
  'chat.example2Prompt': 'Thiết kế landing page cho app ghi chú AI có thể ghi lại cuộc họp, tìm highlight và biến note thành task. Gồm hero, product preview, feature story, social proof, pricing, FAQ và CTA. Aesthetic năng suất điềm tĩnh với conversion path rõ ràng.',
  'chat.example3Title': 'Prototype mobile thiền',
  'chat.example3Tag': 'Mobile',
  'chat.example3Prompt': 'Prototype bốn màn hình mobile cho app thiền: home, session player, progress and streaks, và sleep collection. Gồm onboarding state, bottom navigation, control accessible và ghi chú motion nhẹ để flow sẵn sàng test.',
  'chat.example4Title': 'Video motion sản phẩm',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Tạo storyboard video motion 15 giây cho launch app năng suất: opening hook, UI close-up, kinetic type, transition tính năng, logo cuối và CTA. Gồm timing, mô tả scene, camera move và text overlay.',
  'chat.resumeRunCta': 'Tiếp tục lượt chạy',

  'dsManager.areaAria': 'Khu vực design system',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Template',
  'dsManager.sourceAria': 'Nguồn design system',
  'dsManager.templateSourceAria': 'Nguồn template',
  'dsManager.yourSystems': 'System của bạn',
  'dsManager.officialPresets': 'Preset chính thức',
  'dsManager.shareToTeam': 'Chia sẻ với team',
  'dsManager.shareToTeamFailed': 'Không chia sẻ được với team',
  'dsManager.syncToTeam': 'Sync vào team',
  'dsManager.syncToTeamFailed': 'Không sync được vào team',
  'dsManager.unshareFromTeam': 'Gỡ khỏi team',
  'dsManager.unshareFromTeamFailed': 'Không gỡ khỏi team được',
  'dsManager.teamSyncedReadOnly': 'Chỉ người chia sẻ hoặc admin workspace mới có thể thay đổi mục này',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Template của bạn',
  'dsManager.yourSystemsAria': 'Design system của bạn',
  'dsManager.eyebrowDesignSystems': 'Design System',
  'dsManager.yourSystemsHeading': 'System của bạn',
  'dsManager.filterAria': 'Lọc design system',
  'dsManager.filterAll': 'Tất cả',
  'dsManager.filterPublished': 'Đã publish',
  'dsManager.filterDraft': 'Draft',
  'dsManager.createTitle': 'Tạo design system mới',
  'dsManager.createBody': 'Dạy EduDeck về brand, sản phẩm, code, asset và reference thiết kế của bạn.',
  'dsManager.createAction': 'Tạo',
  'dsManager.emptyMine': 'Chưa có design system. Tạo một system từ context sản phẩm thật, review draft rồi publish để dùng cho project sau.',
  'dsManager.badgeDefault': 'Mặc định cho chat',
  'dsManager.rowMetaUpdated': 'Bạn · cập nhật {date}',
  'dsManager.edit': 'Sửa',
  'dsManager.openSystem': 'Sửa system',
  'dsManager.editWithAgent': 'Sửa bằng agent',
  'dsManager.downloadTitle': 'Tải design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Tải {title} dạng .zip',
  'dsManager.downloadFailed': 'Không tải được design system. Vui lòng thử lại.',
  'dsManager.deleteConfirm': 'Xóa "{title}"? Thao tác này xóa draft design system khỏi thiết bị này.',
  'dsManager.makeDefault': 'Mặc định cho chat mới',
  'dsManager.statusPublished': 'Đã publish',
  'dsManager.statusDraft': 'Draft',
  'dsManager.openSystemAria': 'Sửa {title}',
  'dsManager.deleteSystemAria': 'Xóa {title}',
  'dsManager.deletePermissionDenied': 'Bạn không có quyền xóa design system này.',
  'dsManager.presetsAria': 'Preset design system chính thức',
  'dsManager.eyebrowLibrary': 'Thư viện',
  'dsManager.eyebrowTemplates': 'Template',
  'dsManager.yourTemplatesAria': 'Template của bạn',
  'dsManager.emptyTemplates': 'Chưa có template. Tạo template từ project đã generate qua Share khi bật template publishing.',
  'dsManager.templateDescFallback': 'Tạo từ project',
  'dsManager.comingSoonBadge': 'Sắp có',
  'dsManager.enterpriseDsTitle': 'Design system enterprise',
  'dsManager.enterpriseDsBody': 'Design system dùng chung cho team và thư viện brand có governance sẽ sớm có.',
  'dsManager.enterpriseTplTitle': 'Template enterprise',
  'dsManager.enterpriseTplBody': 'Template được team duyệt và publishing toàn organization sẽ sớm có.',

  'brand.libraryTitle': 'Design System',
  'brand.librarySubtitle': 'Dạy EduDeck design system của bạn - trích xuất từ website rồi áp dụng trong mọi chat.',
  'brand.newBrand': 'Design System mới',
  'brand.searchPlaceholder': 'Tìm design system của bạn...',
  'brand.empty': 'Chưa có design system. Trích xuất một system từ website để bắt đầu.',
  'brand.colorsCount': '{count} màu',
  'brand.extracting': 'Đang trích xuất...',
  'brand.failed': 'Trích xuất thất bại',
  'brand.needsInput': 'Cần input',
  'brand.needsInputHint': 'Trích xuất đã tạm dừng - mở project để hoàn tất verification hoặc trả lời câu hỏi.',
  'brand.appliedToChat': 'Đang dùng {name}',
  'brand.previewEmpty': 'Chọn design system để preview',
  'brand.viewDetails': 'Xem chi tiết',

  'newBrand.title': 'Design System mới',
  'newBrand.subtitle': 'Dán website hoặc chọn brand bên dưới, chúng tôi sẽ trích xuất màu, font và logo.',
  'newBrand.urlLabel': 'Website brand',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Trích xuất design system',
  'newBrand.cancel': 'Hủy',
  'newBrand.close': 'Đóng',
  'newBrand.stage1': 'Đang fetch site và đo thiết kế',
  'newBrand.stage2': 'Đang dựng preview design system',
  'newBrand.stage3': 'Đang suy ra và đăng ký design system',
  'newBrand.measured': '{colors} màu · {fonts} font · {logos} logo',
  'newBrand.done': 'Design system đã sẵn sàng',

  'dsCreate.notes': 'Ghi chú',
  'dsCreate.notesPlaceholder': 'ví dụ Chúng tôi dùng palette màu ấm, gần gũi với góc bo tròn. Giọng brand vui nhưng chuyên nghiệp...',
  'dsCreate.back': 'Quay lại',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Chọn từ thư viện',
  'dsCreate.libraryPickerConfirm': 'Thêm vào asset',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'Preview DESIGN.md',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'theme mặc định',
  'dsCreate.componentKitTitle': '{name} - component kit',
  'dsCreate.designMdGeneratedDescription': 'Tạo từ token, rationale và hướng dẫn component trong DESIGN.md đã dán.',
  'dsCreate.previewButtons': 'Button',
  'dsCreate.previewButtonsHelp': 'Năm loại trên ba kích thước.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Nhỏ',
  'dsCreate.sizeMedium': 'Vừa',
  'dsCreate.sizeLarge': 'Lớn',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Token DESIGN.md đã trích xuất',
  'dsCreate.addingSourceMaterial': 'Đang thêm source material...',
  'dsCreate.browseFolder': 'Duyệt thư mục',
  'dsCreate.confirmBody': 'Bạn sẽ vào một project được điền live - logo, palette, typography, imagery - trong khi nó đo brand của bạn. Giữ tab mở.',
  'dsCreate.confirmTitle': 'EduDeck sẽ trích xuất design system của bạn.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} đã chọn',
  'dsCreate.extractDesignSystem': 'Trích xuất design system',
  'dsCreate.extractionAlreadyStarting': 'Trích xuất đã bắt đầu. Vui lòng chờ request hiện tại hoàn tất.',
  'dsCreate.figmaFileFallbackLabel': 'File Figma',
  'dsCreate.figmaUrlInvalid': 'Nhập URL file Figma (https://figma.com/file/... hoặc /design/...).',
  'dsCreate.githubAccessAutoBody': 'Link repo GitHub dùng phương thức truy cập hoạt động đầu tiên; link website khác được lưu làm source reference.',
  'dsCreate.githubAccessAutoTitle': 'Truy cập GitHub: Auto',
  'dsCreate.githubAccessMethodsAria': 'Phương thức truy cập repository GitHub',
  'dsCreate.githubAuthorizeFailed': 'Không bắt đầu được cấp quyền GitHub.',
  'dsCreate.githubBadgeAutomatic': 'Tự động',
  'dsCreate.githubBadgeChecking': 'Đang kiểm tra',
  'dsCreate.githubBadgeComingSoon': 'Sắp có',
  'dsCreate.githubBadgeConnected': 'Đã kết nối',
  'dsCreate.githubBadgeNeedsAttention': 'Cần chú ý',
  'dsCreate.githubBadgeNotConfigured': 'Chưa cấu hình',
  'dsCreate.githubBadgeOptional': 'Tùy chọn',
  'dsCreate.githubBadgePending': 'Đang chờ',
  'dsCreate.githubComposioCheckingDesc': 'Đang kiểm tra trạng thái connector trong background; nhập URL không bị chặn.',
  'dsCreate.githubComposioConnectedAsDesc': 'Connector GitHub Composio đã kết nối dưới {account}; dùng làm fallback khi thiết bị này không đọc được repository.',
  'dsCreate.githubComposioConnectedDesc': 'Connector GitHub Composio có sẵn làm fallback khi thiết bị này không đọc được repository.',
  'dsCreate.githubComposioDefaultDesc': 'Quyền truy cập connector GitHub Composio cho agent tool; URL repo vẫn hoạt động với git local hoặc GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Kết nối lại connector GitHub Composio, hoặc tiếp tục bằng git local/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Chỉ thêm Composio API key nếu project này cần tool GitHub dựa trên connector.',
  'dsCreate.githubComposioPendingDesc': 'Hoàn tất cửa sổ cấp quyền Composio; intake GitHub local vẫn dùng được.',
  'dsCreate.githubConfigureComposio': 'Cấu hình Composio',
  'dsCreate.githubConnecting': 'Đang kết nối...',
  'dsCreate.githubConnectorCheckFailed': 'Không kiểm tra được connector GitHub.',
  'dsCreate.githubConnectorCheckTimeout': 'Không hoàn tất được kiểm tra connector GitHub. Bạn vẫn có thể thêm URL repository hoặc kết nối GitHub thủ công.',
  'dsCreate.githubConnectViaComposio': 'Kết nối qua Composio',
  'dsCreate.githubDisconnect': 'Ngắt kết nối',
  'dsCreate.githubDisconnectFailed': 'Không ngắt kết nối GitHub được.',
  'dsCreate.githubDisconnecting': 'Đang ngắt kết nối...',
  'dsCreate.githubHideAccessMethods': 'Ẩn phương thức truy cập',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'Tài khoản EduDeck',
  'dsCreate.githubMethodOdAccountDesc': 'Đăng nhập GitHub native do EduDeck quản lý; bản build này chưa dùng GitHub token do OD quản lý.',
  'dsCreate.githubMethodThisDevice': 'Thiết bị này',
  'dsCreate.githubMethodThisDeviceDesc': 'Dùng public git clone, credential git local hoặc GitHub CLI auth có trên máy này.',
  'dsCreate.githubOpenAuthorization': 'Mở cấp quyền',
  'dsCreate.githubShowAccessMethods': 'Hiện phương thức truy cập',
  'dsCreate.libraryPartiallyAdded': 'Đã thêm {added}/{total} mục từ thư viện.',
  'dsCreate.localCodeFilesSelected': 'Đã chọn {count} file code local',
  'dsCreate.prepareProjectFailed': 'Không chuẩn bị được project design system.',
  'dsCreate.removeFile': 'Gỡ {name}',
  'dsCreate.startingExtraction': 'Đang bắt đầu trích xuất...',

  'ds.surfaceLabel': 'Bề mặt',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Ảnh',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Âm thanh',
  'ds.searchPlaceholder': 'Tìm design system...',
  'ds.emptyNoMatch': 'Không có design system khớp tìm kiếm.',
  'ds.badgeDefault': 'MẶC ĐỊNH',
  'ds.preview': 'Preview toàn bộ system',
  'ds.previewTitle': 'Preview toàn bộ design system',
  'ds.categoryAll': 'Tất cả',
  'ds.categoryUncategorized': 'Chưa phân loại',
  'ds.showcase': 'Showcase',
  'ds.tokens': 'Token',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Đang tải DESIGN.md...',
  'ds.kitVisualize': 'Visualize',
  'ds.kitEdit': 'Sửa',
  'ds.kitSource': 'Source',
  'ds.saveDesignMd': 'Lưu DESIGN.md',
  'ds.saving': 'Đang lưu...',
  'ds.copyDesignMd': 'Copy DESIGN.md',
  'ds.editDesignMd': 'Sửa DESIGN.md',
  'ds.openDesignMd': 'Mở DESIGN.md',
  'ds.copyDesignMdModule': 'Copy section {module}',
  'ds.editDesignMdModule': 'Sửa section {module}',
  'ds.openDesignMdModule': 'Mở section {module}',
  'ds.uploadMd': 'Upload MD',
  'ds.uploadFont': 'Thêm file font',
  'ds.pasteImage': 'Dán ảnh',
  'ds.refresh': 'Refresh',
  'ds.download': 'Tải xuống',
  'ds.importFolder': 'Import thư mục',
  'ds.reset': 'Reset',
  'ds.editingDesignMdHint': 'Sửa Markdown này sẽ cập nhật các kit module đã render.',
  'ds.editingModuleHint': 'Chỉ sửa module {module}.',
  'ds.manualEditModuleHint': 'Sửa {module} tại đây. Hover section này để hiện control.',
  'ds.saveModule': 'Lưu module',
  'ds.uploadLogo': 'Upload logo',
  'ds.uploadImage': 'Upload ảnh',
  'ds.uploading': 'Đang upload...',
  'ds.moduleEmptyLogo': 'Chưa có logo',
  'ds.moduleEmptyFonts': 'Chưa capture font.',
  'ds.actionDone': 'Xong',
  'ds.actionFailed': 'Có lỗi xảy ra. Vui lòng thử lại.',
  'ds.uploadDone': 'Đã upload',
  'ds.uploadFailed': 'Upload thất bại. Vui lòng thử lại.',
  'ds.deleteLogo': 'Xóa logo',
  'ds.deleteImage': 'Xóa {caption}',
  'ds.deleteProjectConfirm': 'Xóa "{title}"? Thao tác này xóa vĩnh viễn design system và project của nó khỏi thiết bị này.',
  'ds.deleteProjectAction': 'Xóa {title}',
  'ds.editColor': 'Sửa {name}',
  'ds.colorLabel': 'Màu',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Giá trị hex',
  'ds.saveColor': 'Lưu màu',
  'ds.invalidHexColor': 'Nhập màu hex hợp lệ, ví dụ #FF6A3D.',
  'ds.colorSaveFailed': 'Không lưu được màu này.',
  'ds.colorResetFailed': 'Không reset được màu này.',
  'ds.designMdSectionLabel': 'Section DESIGN.md {module}',
  'ds.kitErrorTitle': 'View này gặp sự cố.',
  'ds.kitErrorRetry': 'Reload',
  'ds.shortcutsLabel': 'Phím tắt',
  'ds.shortcutsHint': 'Phím tắt: E sửa · C copy · U upload · R refresh · ⌫ xóa logo',
  'ds.moduleEmptyImages': 'Chưa có ảnh',
  'ds.noOriginalColor': 'Không có màu gốc cho swatch này.',
  'ds.manifestReadFailed': 'Không đọc được _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Thu gọn {title}',
  'ds.reviewExpandSection': 'Mở rộng {title}',
  'ds.reviewNeedsReview': 'Cần review',
  'ds.reviewLooksGood': 'Ổn',
  'ds.reviewActionsLabel': 'Review {title}',
  'ds.reviewNeedsWorkEllipsis': 'Cần sửa...',
  'ds.reviewEditFile': 'Sửa {file}',
  'ds.reviewFeedbackLabel': 'Nói agent cần thay đổi gì',
  'ds.reviewFeedbackPlaceholder': 'ví dụ siết spacing trong {title}, generate lại preview này...',
  'ds.reviewChangedAfterFeedback': 'Section này đã thay đổi sau feedback của bạn. Review lại trước khi publish.',
  'ds.reviewChangedDuringRun': 'Section này đã thay đổi trong lượt chạy mới nhất. Review trước khi publish.',
  'ds.reviewLastFeedback': 'Feedback gần nhất',
  'ds.previewGenerating': 'Đang tạo preview...',
  'ds.creatingProjectTitle': 'Đang tạo design system của bạn...',
  'ds.creatingProjectSubtitle': 'Giữ tab này mở. Bạn có thể quay lại sau vài phút.',
  'ds.generationProgressLabel': 'Tiến độ tạo design system {progress}%',
  'ds.publishRepoRequiredTitle': 'Hoàn tất import repo GitHub trước khi publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Đã publish',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Đang trích xuất design system',
  'ds.extractionCompleteTitle': 'Trích xuất hoàn tất',
  'ds.extractionRunningBody': 'EduDeck đang cập nhật system này tại chỗ.',
  'ds.extractionCompleteBody': 'Tất cả module đã trích xuất được hiển thị bên dưới; section rỗng là để trống có chủ ý.',
  'ds.publishCardPublished': 'Project mới của team có thể dùng design system này làm context mặc định.',
  'ds.publishCardDraft': 'Design system của bạn đã sẵn sàng, nhưng feedback của bạn sẽ cải thiện nó. Publish khi nó sẵn sàng dùng cho project sau.',
  'ds.useSystemTitle': 'Dùng system này',
  'ds.useSystemBody': 'Bắt đầu thiết kế mới kế thừa màu, type và component của system này - tự động giữ đúng brand.',
  'ds.createNewDesign': 'Tạo thiết kế mới',
  'ds.openSourceContext': 'Mở source context',
  'ds.manifestNeedsAttention': 'Design manifest cần chú ý',
  'ds.openManifest': 'Mở manifest',
  'ds.workspacePreparing': 'Đang chuẩn bị workspace design system.',
  'ds.workspaceLoadingLabel': 'Workspace design system đang tải',
  'ds.sectionQueued': 'Đang chờ',
  'ds.sectionReviewUpdatedFiles': 'File đã cập nhật cần review',
  'ds.reviewNeedsWork': 'Cần sửa',
  'ds.sectionRequiredFileMissing': 'Thiếu file bắt buộc: {file}',
  'ds.sectionNoFilesYet': 'Chưa có file',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Đang đọc source context đã liên kết và evidence repository.',
  'ds.generationGuidanceTitle': 'Hướng dẫn brand',
  'ds.generationGuidanceDetail': 'Đang viết guidance DESIGN.md và voice.',
  'ds.generationTokensTitle': 'Design token',
  'ds.generationTokensDetail': 'Đang trích xuất token màu, type và spacing.',
  'ds.generationPreviewsTitle': 'Preview card',
  'ds.generationPreviewsDetail': 'Đang render preview card có thể review.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Đang tạo component và pattern tái dùng.',
  'ds.generationAssetsTitle': 'Brand asset',
  'ds.generationAssetsDetail': 'Đang thu thập logo, font, ảnh và icon.',
  'ds.phaseQueuedTypography': 'Typography đang chờ',
  'ds.phaseQueuedTokens': 'Token đang chờ',
  'ds.phaseQueuedSpacing': 'Spacing đang chờ',
  'ds.phaseQueuedUiKit': 'UI kit đang chờ',
  'ds.phaseQueuedAssets': 'Asset đang chờ',
  'ds.phaseReadingTypography': 'Đang đọc typography',
  'ds.phaseReadingTokens': 'Đang đọc token',
  'ds.phaseReadingSpacing': 'Đang đọc spacing',
  'ds.phaseReadingUiKit': 'Đang đọc UI kit',
  'ds.phaseReadingAssets': 'Đang đọc asset',
  'ds.phaseWritingTypography': 'Đang viết typography',
  'ds.phaseWritingTokens': 'Đang viết token',
  'ds.phaseWritingSpacing': 'Đang viết spacing',
  'ds.phaseBuildingUiKit': 'Đang build UI kit',
  'ds.phaseUpdatingAssets': 'Đang cập nhật asset',
  'ds.phaseNeedsAttention': 'Cần chú ý',
  'ds.phaseUpdated': 'Đã cập nhật',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Đã đọc {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Đang đọc context cho {title}.',
  'ds.sectionRunningNow': '{phase} hiện đang chạy.',
  'ds.reviewLastReviewed': 'Review gần nhất {time}',
  'ds.agentFeedbackQueued': 'Feedback cho agent đã xếp hàng',
  'ds.agentFeedbackSent': 'Feedback cho agent đã gửi',
  'ds.agentFeedbackSentAt': 'Feedback cho agent đã gửi {time}',
  'ds.agentFeedbackFailedWithError': 'Feedback cho agent thất bại: {error}',
  'ds.agentFeedbackFailed': 'Feedback cho agent thất bại',
  'ds.agentFeedbackUnknown': 'Không rõ trạng thái feedback cho agent',
  'ds.repoConnectBannerTitle': 'Kết nối repo để kéo các phần của design system',
  'ds.repoConnectCardTitle': 'Kết nối repo',
  'ds.repoConnectPendingBody': 'Đang kiểm tra kết nối GitHub...',
  'ds.repoConnectPendingButton': 'Đang kiểm tra GitHub...',
  'ds.repoConnectedTitle': 'GitHub đã kết nối',
  'ds.repoConnectedBody': 'Import lại repo này để kéo file vào design system của bạn.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Kết nối GitHub để EduDeck đọc repository và kéo màu, type, component vào design system này.',
  'ds.repoConnectCardBody': 'Kéo màu, type và component từ repository vào design system này.',
  'ds.repoConnectButton': 'Kết nối GitHub',

  'dsFlow.activityDetailFailed': 'Tin nhắn chat có chi tiết lượt chạy. Bạn có thể chỉnh request và thử lại.',
  'dsFlow.activityDetailReady': 'Review tab Design System và Design Files đã cập nhật.',
  'dsFlow.activityDetailRunning': 'Đang theo dõi file project và chuẩn bị review draft.',
  'dsFlow.activityFailedTitle': 'Cập nhật workspace cần chú ý',
  'dsFlow.activityProgressAria': 'Tiến độ cập nhật workspace {progress}%',
  'dsFlow.activityReadyTitle': 'Cập nhật workspace đã sẵn sàng',
  'dsFlow.activityRunningTitle': 'EduDeck đang cập nhật system này',
  'dsFlow.addBrandFonts': 'Thêm file font brand',
  'dsFlow.agentMsgCapturedDirection': 'Direction đã capture: {summary}',
  'dsFlow.agentMsgCreating': 'Tôi đang tạo workspace design system, preview card và file hỗ trợ từ context bạn cung cấp.',
  'dsFlow.agentMsgReady': 'Draft design system của bạn đã sẵn sàng. Review tab Design System, kiểm tra file đã tạo, publish hoặc yêu cầu tôi sửa tại đây.',
  'dsFlow.agentMsgRevision': 'Tôi đang áp dụng feedback của bạn vào design system. Bạn vẫn có thể review draft hiện tại khi revision chạy.',
  'dsFlow.agentMsgTokenRebuild': 'Tôi đang chuẩn bị token contract rebuild để review. Contract đang active sẽ không đổi cho đến khi revision được accept.',
  'dsFlow.agentPushLayer': 'Layer agent push',
  'dsFlow.assetsLabel': 'Asset',
  'dsFlow.auditNeedsRepair': '{summary} Review chi tiết audit trước khi chạy repair.',
  'dsFlow.brandFontsMissingBody': 'Preview typography đang dùng web font thay thế cho đến khi thêm file font brand.',
  'dsFlow.brandFontsMissingTitle': 'Thiếu file font brand',
  'dsFlow.chatCreateRequest': 'Tạo design system',
  'dsFlow.chatSeedUpdateSystem': 'Cập nhật design system này: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: dùng AI extraction để refine system này. Lượt chạy dài hơn; update sẽ xuất hiện tại đây.',
  'dsFlow.conversationCreateFailed': 'Không tạo được cuộc trò chuyện design system.',
  'dsFlow.evidenceFallbackTokens': 'Token fallback',
  'dsFlow.evidenceFonts': 'Font',
  'dsFlow.evidenceIndexes': 'Evidence index',
  'dsFlow.evidenceScannedFiles': 'File đã scan',
  'dsFlow.evidenceSnippets': 'Snippet',
  'dsFlow.evidenceSourceTokens': 'Source token',
  'dsFlow.fileDraftPreview': 'Preview file draft',
  'dsFlow.filesTouched': 'File đã chạm',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'Revision chung',
  'dsFlow.generationCompleted': 'Generation hoàn tất',
  'dsFlow.generationProgressAria': 'Tiến độ generation {progress}%',
  'dsFlow.generationStopped': 'Generation đã dừng',
  'dsFlow.generationStoppedWithError': 'Generation đã dừng: {error}',
  'dsFlow.jobCompleted': '{noun} hoàn tất',
  'dsFlow.jobDetailGeneration': 'Đang chuẩn bị các file còn lại.',
  'dsFlow.jobDetailReady': 'Workspace review đã sẵn sàng.',
  'dsFlow.jobDetailRevision': 'Đang áp dụng feedback của bạn.',
  'dsFlow.jobDetailTokenRebuild': 'Đang chuẩn bị draft token contract có thể review.',
  'dsFlow.jobNeedsAttention': '{noun} cần chú ý',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Rebuild token',
  'dsFlow.jobRebuildingTokens': 'EduDeck đang rebuild token',
  'dsFlow.jobRevising': 'EduDeck đang revise',
  'dsFlow.jobStillWorking': 'EduDeck vẫn đang làm',
  'dsFlow.loadingDesignSystem': 'Đang tải design system...',
  'dsFlow.metaEvidenceNotes': 'Ghi chú evidence',
  'dsFlow.metaScannedInventory': 'Inventory file đã scan',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Evidence trích xuất token',
  'dsFlow.metaTokenReport': 'Báo cáo chất lượng token contract',
  'dsFlow.movedBackToDraft': 'Đã chuyển lại về draft',
  'dsFlow.needsWorkSeed': 'Cần sửa ở {title}: ',
  'dsFlow.no': 'Không',
  'dsFlow.openingDesignSystemWorkspace': 'Đang mở workspace design system...',
  'dsFlow.openingWorkspace': 'Đang mở workspace...',
  'dsFlow.packageFallbackMeta': '{source} · fallback chỉ DESIGN.md',
  'dsFlow.packageLegacy': 'Design system legacy',
  'dsFlow.packageManifestMeta': '{source} · chế độ {mode} · manifest đã index',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid sẵn sàng',
  'dsFlow.packageStructured': 'Package import có cấu trúc',
  'dsFlow.pendingRevision': 'Revision đang chờ',
  'dsFlow.pickLocalAgentFirst': 'Chọn local agent trước, rồi yêu cầu EduDeck cập nhật design system này.',
  'dsFlow.previewPages': 'Trang preview',
  'dsFlow.proposedChanges': 'Thay đổi đề xuất',
  'dsFlow.publishCardReady': 'EduDeck đã sẵn sàng để review. Gửi feedback cho phần hiện có, rồi publish khi nó hữu ích cho project sau.',
  'dsFlow.publishCardRevision': 'EduDeck đang áp dụng feedback của bạn. Bạn có thể tiếp tục review khi draft cập nhật đang được chuẩn bị.',
  'dsFlow.publishCardTokenRebuild': 'EduDeck đang chuẩn bị token contract rebuild để review. Contract active không đổi cho đến khi bạn accept.',
  'dsFlow.publishCardWorking': 'EduDeck vẫn đang làm, nhưng bạn có thể bắt đầu gửi feedback cho phần hiện có.',
  'dsFlow.pullLayer': 'Layer pull',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision đã accept',
  'dsFlow.revisionAcceptFailed': 'Không accept được revision',
  'dsFlow.revisionHistory': 'Lịch sử revision',
  'dsFlow.revisionMsgAccepted': 'Đã accept. Draft design system hiện đã gồm update này.',
  'dsFlow.revisionMsgPending': 'Tôi đã chuẩn bị update đề xuất. Review diff card bên phải, rồi accept hoặc yêu cầu thay đổi khác.',
  'dsFlow.revisionMsgRejected': 'Đã reject. Tôi giữ nguyên design system hiện tại.',
  'dsFlow.revisionProgressUnavailable': 'Không đọc được tiến độ revision',
  'dsFlow.revisionReady': 'Revision sẵn sàng review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision đã reject',
  'dsFlow.revisionRejectFailed': 'Không reject được revision',
  'dsFlow.revisionStopped': 'Revision đã dừng',
  'dsFlow.revisionStoppedWithError': 'Revision đã dừng: {error}',
  'dsFlow.saveChangesFailed': 'Không lưu được thay đổi',
  'dsFlow.savedDesignMd': 'Đã lưu DESIGN.md',
  'dsFlow.sectionDraftBody': 'Body draft',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} đã đánh dấu là ổn',
  'dsFlow.sectionNoContent': 'Chưa có nội dung.',
  'dsFlow.sectionNoDetails': 'Chưa có chi tiết.',
  'dsFlow.setDefaultAction': 'Mặc định cho chat mới',
  'dsFlow.setDefaultTitle': 'Chọn sẵn design system này cho chat và project mới.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'Import GitHub',
  'dsFlow.sourceTypeInstalled': 'Đã cài',
  'dsFlow.sourceTypeLocal': 'Import local',
  'dsFlow.sourceTypeUser': 'Workspace người dùng',
  'dsFlow.statusUpdateFailed': 'Không cập nhật được trạng thái',
  'dsFlow.stepReadCurrentSystem': 'Đọc system hiện tại',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Cập nhật file thiết kế',
  'dsFlow.subtitleBrand': 'Logo, voice và rule sử dụng',
  'dsFlow.subtitleColor': 'Palette và role semantic',
  'dsFlow.subtitleComponents': 'Pattern interface tái dùng',
  'dsFlow.subtitleDefault': 'Hướng dẫn thiết kế',
  'dsFlow.subtitleSpacing': 'Spacing scale và token radius',
  'dsFlow.subtitleTypography': 'Hierarchy text và style',
  'dsFlow.tabDesignFiles': 'File thiết kế',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'khuyến nghị rebuild',
  'dsFlow.tokenContractReportAvailable': 'có báo cáo chất lượng',
  'dsFlow.tokenContractScore': 'điểm {score}',
  'dsFlow.tokenRebuildStarted': 'Đã bắt đầu rebuild token contract',
  'dsFlow.tokenRebuildStartFailed': 'Không bắt đầu được rebuild token contract',
  'dsFlow.workspaceOpenFailed': 'Không mở được workspace design system.',
  'dsFlow.workspaceUpdatedReview': 'Workspace đã cập nhật. Review file hoặc yêu cầu thay đổi khác.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace đã cập nhật và DESIGN.md đã sync để review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace đã cập nhật. {summary}',
  'dsFlow.yes': 'Có',

  'designs.subRecent': 'Gần đây',
  'designs.subYours': 'Thiết kế của bạn',
  'designs.filterAria': 'Lọc project',
  'designs.searchPlaceholder': 'Tìm...',
  'designs.emptyNoProjects': 'Chưa có project.',
  'designs.emptyNoMatch': 'Không có project khớp tìm kiếm.',
  'designs.deleteTitle': 'Xóa project',
  'designs.deleteConfirm': 'Xóa "{name}"?',
  'designs.cardFreeform': 'freeform',
  'designs.badgeLive': 'Live',
  'designs.liveArtifactBadgesAria': 'Badge live artifact',
  'designs.liveCount': '{n} live',
  'designs.statusLive': 'Live artifact',
  'designs.statusArchived': 'Đã archive',
  'designs.statusError': 'Lỗi',
  'designs.statusRefreshing': 'Đang refresh...',
  'designs.statusRefreshFailed': 'Refresh thất bại',
  'designs.statusRefreshed': 'Đã refresh',
  'designs.status.notStarted': 'Chưa bắt đầu',
  'designs.status.queued': 'Đang chờ',
  'designs.status.running': 'Đang chạy',
  'designs.status.awaitingInput': 'Cần input',
  'designs.status.incomplete': 'Chưa hoàn tất',
  'designs.status.succeeded': 'Hoàn tất',
  'designs.status.published': 'Đã publish',
  'designs.status.failed': 'Thất bại',
  'designs.status.canceled': 'Đã hủy',
  'designs.viewToggleAria': 'Chế độ xem',
  'designs.viewGrid': 'Xem grid',
  'designs.viewKanban': 'Xem board',
  'designs.kanbanEmptyColumn': 'Không có thiết kế',
  'designs.deleteAria': 'Xóa project {name}',
  'designs.menuMore': 'Thêm thao tác',
  'designs.menuRename': 'Đổi tên',
  'designs.menuDuplicate': 'Nhân bản project',
  'designs.menuDelete': 'Xóa',
  'designs.renamePrompt': 'Tên mới cho "{name}"',
  'designs.selectMode': 'Chọn',
  'designs.cancelSelect': 'Hủy',
  'designs.deleteSelected': 'Xóa mục đã chọn',
  'designs.selectedCount': 'Đã chọn {n}',
  'designs.deleteSelectedConfirm': 'Xóa {n} project?',
  'designs.deleteSelectedSuccess': 'Đã xóa thành công {n} project.',
  'designs.deleteSelectedPartial': 'Đã xóa {deleted} project; {failed} thất bại.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagWebClone': 'Clone website',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Đổi tên project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Hủy',

  'examples.typeLabel': 'Loại',
  'examples.surfaceLabel': 'Bề mặt',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Ảnh',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Âm thanh',
  'examples.scenarioLabel': 'Scenario',
  'examples.modeAll': 'Tất cả',
  'examples.modePrototypeDesktop': 'Prototype · Desktop',
  'examples.modePrototypeMobile': 'Prototype · Mobile',
  'examples.modeDeck': 'Slides',
  'examples.modeDocument': 'Docs & template',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Live',
  'examples.scenarioGeneral': 'Chung',
  'examples.scenarioEngineering': 'Engineering',
  'examples.scenarioProduct': 'Product',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Sales',
  'examples.scenarioFinance': 'Finance',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operations',
  'examples.scenarioSupport': 'Support',
  'examples.scenarioLegal': 'Legal',
  'examples.scenarioEducation': 'Giáo dục',
  'examples.scenarioPersonal': 'Cá nhân',
  'examples.searchPlaceholder': 'Tìm ví dụ...',
  'examples.searchAria': 'Tìm ví dụ theo tên',
  'examples.emptyNoSkills': 'Không có skill. Daemon có đang chạy không?',
  'examples.emptyNoMatch': 'Không có ví dụ khớp bộ lọc này.',
  'examples.openPreview': '⤢ Mở preview',
  'examples.loadingPreview': 'Đang tải preview...',
  'examples.hoverPreview': 'Hover để preview',
  'examples.usePrompt': 'Dùng prompt này',
  'examples.previewModalTitle': 'Mở preview đầy đủ (modal)',
  'examples.shareTitle': 'Chia sẻ ví dụ này',
  'examples.shareLoadFirst': 'Hover để tải preview trước',
  'examples.unavailablePlaceholder': 'Chưa có preview {kind} đã ship - mở để xem thêm',
  'examples.shareUnavailable': 'Không có preview {kind} đã ship để chia sẻ',
  'examples.shareMenu': 'Chia sẻ ▾',
  'examples.exportPdfAllSlides': 'Export PDF (tất cả slide)',
  'examples.exportPptxLocked': 'Export PPTX... (mở template trước)',
  'examples.tagSlideDeck': 'Slides',
  'examples.tagTemplate': 'Template',
  'examples.tagDesignSystem': 'Design system',
  'examples.tagMobilePrototype': 'Prototype mobile',
  'examples.tagDesktopPrototype': 'Prototype desktop',
  'examples.tagImage': 'Ảnh',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Âm thanh',
  'examples.previewLabel': 'Preview',

  'pluginCard.useWithQuery': 'Dùng với query',
  'pluginCard.applying': 'Đang áp dụng...',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Đang remix...',
  'pluginCard.duplicateFailed': 'Không remix được template này.',
  'pluginCard.saved': 'Đã lưu',
  'pluginCard.publish': 'Publish',
  'pluginCard.contribute': 'Contribute',
  'pluginCard.starting': 'Đang bắt đầu...',
  'pluginCard.detailsAria': 'Xem chi tiết {title}',
  'pluginCard.chooseUseAria': 'Chọn cách dùng {title}',
  'pluginCard.useOptionsAria': 'Tùy chọn dùng {title}',
  'pluginCard.duplicateAria': 'Remix {title} thành project mới',
  'pluginCard.saveAria': 'Lưu {title}',
  'pluginCard.savedAria': '{title} đã lưu',
  'pluginCard.shareAria': 'Chia sẻ {title}',
  'pluginCard.publishAria': 'Publish {title} thành GitHub repository',
  'pluginCard.publishTitle': 'Publish plugin thành GitHub repository',
  'pluginCard.contributeAria': 'Contribute {title} cho EduDeck',
  'pluginCard.contributeTitle': 'Contribute plugin cho EduDeck bằng pull request',

  'pluginDetail.backToList': 'Quay lại danh sách',
  'pluginDetail.quickCommands': 'Lệnh nhanh',
  'pluginDetail.noQuickCommands': 'Không có lệnh nhanh.',
  'pluginDetail.dataConnections': 'Kết nối dữ liệu',
  'pluginDetail.noDataConnections': 'Suite này không cần kết nối dữ liệu bên ngoài.',
  'pluginDetail.knowledgeSkills': 'Knowledge skill',
  'pluginDetail.noKnowledgeSkills': 'Suite này chưa có knowledge skill độc lập.',
  'pluginDetail.officialBadge': 'Chính thức từ EduDeck',
  'pluginDetail.loadFailed': 'Không tải được plugin: {error}',
  'pluginDetail.applyFailed': 'Áp dụng thất bại. Bảo đảm daemon truy cập được.',
  'pluginDetail.examples': 'Ví dụ',

  'plugins.availableDetails.provenanceLine': 'từ {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'từ {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.deprecatedPrefix': 'Deprecated: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Phiên bản này đã được đánh dấu deprecated.',
  'plugins.availableDetails.yanked': 'Đã yanked.',
  'plugins.availableDetails.yankedWithReason': 'Yanked: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (deprecated)',
  'plugins.availableDetails.versionYankedSuffix': ' (yanked)',
  'plugins.actions.copyInstallCommand': 'Copy lệnh cài',
  'plugins.actions.copyPluginId': 'Copy plugin ID',
  'plugins.actions.copyReadmeBadge': 'Copy badge README',
  'plugins.actions.openSourceGithub': 'Mở source trên GitHub',
  'plugins.actions.openSource': 'Mở source',
  'plugins.actions.openHomepage': 'Mở homepage',
  'plugins.actions.openMarketplace': 'Mở trong marketplace',

  'library.title': 'Thư viện',
  'library.headerHint': 'Clip bất kỳ page, design system, screenshot, ảnh hoặc JSON import Figma nào vào Thư viện - ưu tiên local, một click, không cần đăng nhập.',
  'library.getClipper': 'Lấy EduDeck Web Clipper',
  'library.searchPlaceholder': 'Tìm caption, tag, title...',
  'library.filterByKind': 'Lọc theo loại',
  'library.filterBySource': 'Lọc theo nguồn',
  'library.kindAll': 'Tất cả loại',
  'library.kindImages': 'Ảnh',
  'library.kindElements': 'Element',
  'library.kindDesignSystems': 'Design system',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Font',
  'library.kindColors': 'Màu',
  'library.kindText': 'Text',
  'library.kindLinks': 'Link',
  'library.sourceAll': 'Tất cả nguồn',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Đã generate',
  'library.viewMode': 'Chế độ xem',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Hiện asset dạng grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Nhóm asset theo ngày, mới nhất trước',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Tải lại danh sách với bộ lọc hiện tại',
  'library.sync': 'Sync',
  'library.syncing': 'Đang sync...',
  'library.syncTooltip': 'Kéo design system và artifact do agent tạo vào Thư viện',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload ảnh, font hoặc file vào Thư viện',
  'library.selectedCount': 'Đã chọn {count}',
  'library.selectAll': 'Chọn tất cả',
  'library.clear': 'Xóa',
  'library.chatToDesign': 'Chat để tạo thiết kế',
  'library.chatToDesignTitle': 'Bắt đầu chat để biến {count} thành thiết kế',
  'library.working': 'Đang làm...',
  'library.useInDesignSystem': 'Dùng trong design system',
  'library.createDesignSystem': 'Tạo design system mới',
  'library.createDesignSystemSub': 'Mở flow tạo với {count} mục này được đính kèm',
  'library.refineExisting': 'Refine system hiện có',
  'library.noEditableDesignSystems': 'Chưa có design system có thể sửa.',
  'library.addAssetsAndRefine': 'Thêm asset và mở để refine',
  'library.deleteCount': 'Xóa {count}',
  'library.loading': 'Đang tải...',
  'library.emptyTitle': 'Chưa có asset.',
  'library.emptyHintBefore': 'Clip từ bất kỳ page nào bằng EduDeck Web Clipper, chạy',
  'library.emptyHintAfter': ', hoặc upload trong project - mọi thứ sẽ nằm ở đây.',
  'library.dropToUpload': 'Thả để upload vào Thư viện',
  'library.confirmDeleteTitleOne': 'Xóa {count} asset?',
  'library.confirmDeleteTitleMany': 'Xóa {count} asset?',
  'library.confirmDeleteBodyOne': 'Thao tác này xóa vĩnh viễn asset khỏi Thư viện. Không thể hoàn tác.',
  'library.confirmDeleteBodyMany': 'Thao tác này xóa vĩnh viễn các asset khỏi Thư viện. Không thể hoàn tác.',
  'library.cancel': 'Hủy',
  'library.today': 'Hôm nay',
  'library.yesterday': 'Hôm qua',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Chọn asset',
  'library.deselectAsset': 'Bỏ chọn asset',
  'library.openDesignSystem': 'Mở design system',
  'library.openProject': 'Mở project',
  'library.opening': 'Đang mở...',
  'library.editAsPage': 'Sửa như page',
  'library.viewSource': 'Source',
  'library.remove': 'Gỡ',

  'pluginsHome.title': 'Cộng đồng',
  'pluginsHome.subtitle': 'Workflow EduDeck sẵn dùng đi kèm runtime này. Chọn một mục để nạp starter prompt, hoặc duyệt registry để xem thêm.',
  'pluginsHome.browseRegistry': 'Duyệt registry',
  'pluginsHome.count': '{filtered} / {total}',
  'pluginsHome.loadingCatalog': 'Đang tải catalog...',
  'pluginsHome.emptyCatalog': 'Catalog đang rỗng. Plugin bundled đi kèm EduDeck và sẽ tự hiện ở đây - thử restart daemon nếu vẫn còn.',
  'pluginsHome.emptyFiltered': 'Không có plugin khớp bộ lọc hiện tại.',
  'pluginsHome.clearFilters': 'Xóa bộ lọc',
  'pluginsHome.modeAria': 'Chế độ plugin',
  'pluginsHome.featured': 'Đã lưu',
  'pluginsHome.totalInCatalog': '{n} trong catalog',
  'pluginsHome.categoryFilterAria': 'Bộ lọc category',
  'pluginsHome.subcategoryFilterAria': 'Bộ lọc subcategory {label}',
  'pluginsHome.allCategory': 'Tất cả {label}',
  'pluginsHome.searchPlaceholder': 'Tìm plugin...',
  'pluginsHome.searchAria': 'Tìm plugin',
  'pluginsHome.clearSearch': 'Xóa tìm kiếm',
  'pluginsHome.sortAria': 'Thứ tự sắp xếp',
  'pluginsHome.sortHot': 'Đang thịnh hành',
  'pluginsHome.sortNewest': 'Mới nhất',
  'pluginsHome.facet.import': 'Import',
  'pluginsHome.facet.create': 'Tạo',
  'pluginsHome.facet.export': 'Export',
  'pluginsHome.facet.share': 'Chia sẻ',
  'pluginsHome.facet.deploy': 'Deploy',
  'pluginsHome.facet.refine': 'Refine',
  'pluginsHome.facet.extend': 'Mở rộng',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Code / thư mục',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Screenshot',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slides',
  'pluginsHome.facet.publicLink': 'Link công khai',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboard',
  'pluginsHome.subfacet.app-prototypes': 'App',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Developer tool',
  'pluginsHome.subfacet.docs-reports': 'Docs / report',
  'pluginsHome.subfacet.brand-design': 'Brand / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / business',
  'pluginsHome.subfacet.course-training': 'Khóa học / training',
  'pluginsHome.subfacet.reports-briefings': 'Report / briefing',
  'pluginsHome.subfacet.product-sales': 'Product / sales',
  'pluginsHome.subfacet.engineering-talks': 'Talk engineering',
  'pluginsHome.subfacet.creative-decks': 'Creative deck',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / mockup sản phẩm',
  'pluginsHome.subfacet.brand-visuals': 'Brand / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboard',
  'pluginsHome.subfacet.social-content': 'Social / content',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portrait',
  'pluginsHome.subfacet.illustration-style': 'Illustration / style',
  'pluginsHome.subfacet.motion-effects': 'Motion / effect',
  'pluginsHome.subfacet.social-short-form': 'Social / short form',
  'pluginsHome.subfacet.marketing-product': 'Marketing / product',
  'pluginsHome.subfacet.data-explainers': 'Data / explainer',
  'pluginsHome.subfacet.cinematic-story': 'Cinematic / story',
  'pluginsHome.commercialCategory.student-coursework': 'Bài tập sinh viên',
  'pluginsHome.commercialCategory.corporate-strategy': 'Chiến lược doanh nghiệp',
  'pluginsHome.commercialCategory.professional-training': 'Training chuyên nghiệp',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Nghiên cứu học thuật',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Pitch gọi vốn',
  'pluginsHome.commercialCategory.government-policy': 'Chính phủ & chính sách',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Sự nghiệp',
  'pluginsHome.commercialCategory.ai-literacy': 'Hiểu biết AI',
  'pluginsHome.commercialCategory.life': 'Đời sống & câu chuyện',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',

  'pluginsView.marketplaceModeAria': 'Chế độ marketplace',
  'pluginsView.marketplaceSourceFiltersAria': 'Bộ lọc nguồn marketplace',
  'pluginsView.modeNote.plugins': 'Suite chuyên gia là toolkit theo vai trò và ngành. Gõ @ hoặc slash trong composer để dùng.',
  'pluginsView.modeNote.skills': 'Skill là workflow task và rule review tái dùng. Dùng trực tiếp hoặc ghép vào suite chuyên gia.',
  'pluginsView.createWithAgentBody': 'Bắt đầu từ prompt trong home composer thay vì import extension có sẵn.',
  'pluginsView.createPluginBody': 'Import plugin từ GitHub hoặc thư mục local, rồi upload để team dùng.',
  'pluginsView.createSkillBody': 'Tạo workflow task hoặc rule review tái dùng để sau này plugin có thể dùng lại.',
  'pluginsView.importUrlBody': 'Dán link công khai cho {kind}. EduDeck sẽ fetch manifest, validate capability và upload vào team space.',
  'pluginsView.uploadFolderBody': 'Chọn thư mục local chứa {manifest}. Sau validation, nó sẽ upload thành {kind} của team.',
  'pluginsView.emptyTeamTitle': 'Chưa có nội dung chia sẻ cho team',
  'pluginsView.emptyTeamHint': 'Chia sẻ suite chuyên gia hoặc skill từ Personal sang Team, chúng sẽ hiện ở đây.',
  'pluginsView.emptyPersonalPluginsTitle': 'Chưa có suite chuyên gia cá nhân',
  'pluginsView.emptyPersonalSkillsTitle': 'Chưa có skill cá nhân',
  'pluginsView.emptyPersonalHint': 'Cài từ EduDeck official, hoặc dùng Add ở góc phải trên để tạo.',
  'pluginsView.emptyOfficialPluginsTitle': 'Chưa có suite chuyên gia official',
  'pluginsView.emptyOfficialSkillsTitle': 'Chưa có skill official',
  'pluginsView.emptyOfficialHint': 'Quay lại sau hoặc thêm marketplace trong nguồn plugin.',
  'pluginsView.teamSharedBadge': 'Đã chia sẻ với team',
  'pluginsView.categoriesAria': 'Category',
  'pluginsView.statSkills': '{count} skill',
  'pluginsView.statConnectors': '{count} connector',
  'pluginsView.sharing': 'Đang chia sẻ...',
  'pluginsView.unsharing': 'Đang gỡ...',
  'pluginsView.syncToTeam': 'Sync vào team',
  'pluginsView.unshareFromTeam': 'Gỡ khỏi team',
  'pluginsView.skillUrlUnsupported': 'Skill chưa hỗ trợ import từ link. Dùng Upload thư mục local thay thế.',
  'pluginsView.importPluginSuccess': 'Đã import và upload suite chuyên gia',
  'pluginsView.importFailed': 'Import thất bại. Kiểm tra link rồi thử lại.',
  'pluginsView.uploadPluginSuccess': 'Đã upload suite chuyên gia',
  'pluginsView.uploadFailed': 'Upload thất bại. Kiểm tra nội dung thư mục.',
  'pluginsView.importSkillSuccess': 'Đã import Skill "{name}". Bạn có thể chia sẻ nó với team từ Personal.',
  'pluginsView.shareSuccess': 'Đã chia sẻ "{title}" với team. Đồng đội hiện có thể dùng.',
  'pluginsView.shareUnavailable': 'Chưa thể chia sẻ "{title}". Xác nhận bạn đang ở team workspace.',
  'pluginsView.shareFailed': 'Chia sẻ "{title}" thất bại. Thử lại sau.',
  'pluginsView.syncSuccess': 'Đã sync bản mới nhất của "{title}" vào team.',
  'pluginsView.syncUnavailable': 'Chưa thể sync "{title}". Xác nhận bạn đang ở team workspace.',
  'pluginsView.syncFailed': 'Sync "{title}" vào team thất bại. Thử lại sau.',
  'pluginsView.unshareSuccess': 'Đã gỡ "{title}" khỏi chia sẻ team.',
  'pluginsView.unshareUnavailable': 'Không gỡ "{title}" khỏi chia sẻ team được. Xác nhận bạn có quyền.',
  'pluginsView.unshareFailed': 'Gỡ "{title}" khỏi chia sẻ team thất bại. Thử lại sau.',
  'pluginsView.installSuccess': 'Đã cài "{title}"',
  'pluginsView.installFailed': 'Cài "{title}" thất bại',
  'pluginsView.skillMissingFile': 'Không tìm thấy SKILL.md trong thư mục đã chọn.',
  'pluginsView.skillReadFailed': 'Không đọc được SKILL.md. Thử lại.',
  'pluginsView.skillMissingName': 'SKILL.md thiếu field name.',
  'pluginsView.skillEmptyBody': 'Nội dung SKILL.md đang rỗng.',
  'pluginsView.teamTitle': 'Marketplace team riêng tư',
  'pluginsView.teamBody': 'Khu vực này dành cho catalog enterprise/team, trust policy riêng và control vòng đời plugin dùng chung.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Đóng xác nhận chia sẻ',
  'pluginsView.shareWhatStarts': 'Thao tác này bắt đầu gì',
  'pluginsView.shareSourcePlugin': 'Plugin nguồn',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Đã copy tới',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Đang bắt đầu...',

  'invite.header.eyebrow': 'Lời mời team',
  'invite.loading': 'Đang tải lời mời...',
  'invite.landing.title': 'Tham gia team',
  'invite.landing.subtitle': 'Bạn được mời cộng tác trong EduDeck.',
  'invite.landing.roleLabel': 'Vai trò',
  'invite.landing.invitedEmail': 'Email được mời',
  'invite.landing.expires': 'Hết hạn',
  'invite.role.admin': 'Admin',
  'invite.role.member': 'Member',
  'invite.role.admin.desc': 'Có thể quản lý member, seat và mọi cài đặt project.',
  'invite.role.member.desc': 'Có thể tạo project riêng, xem và comment project team được chia sẻ.',
  'invite.accept.cta': 'Chấp nhận lời mời',
  'invite.accountMismatch.title': 'Bạn đang dùng tài khoản khác',
  'invite.accountMismatch.body': 'Lời mời này được gửi tới email khác. Bạn có thể tiếp tục với tài khoản hiện tại hoặc đổi tài khoản.',
  'invite.accountMismatch.continue': 'Tiếp tục với tài khoản hiện tại',
  'invite.accountMismatch.switch': 'Đổi tài khoản',
  'invite.accepting.title': 'Đang tham gia team...',
  'invite.accepting.body': 'Đang thiết lập membership.',
  'invite.success.title': 'Bạn đã vào team',
  'invite.success.body': 'Đang mở EduDeck để bạn bắt đầu cộng tác.',
  'invite.success.roleReceipt': 'Tham gia với vai trò',
  'invite.success.enter': 'Vào workspace',
  'invite.open.cta': 'Mở EduDeck',
  'invite.open.opening': 'Đang mở EduDeck...',
  'invite.open.retry': 'Đã cài rồi? Thử mở lại',
  'invite.notInstalled.title': 'Không tự mở?',
  'invite.notInstalled.body': 'Có thể bạn chưa cài EduDeck. Cài xong rồi mở lại link này để hoàn tất tham gia.',
  'invite.notInstalled.download': 'Tải EduDeck',
  'invite.error.title': 'Không thể chấp nhận lời mời này',
  'invite.error.invite_expired': 'Lời mời này đã hết hạn. Nhờ admin gửi lời mời mới.',
  'invite.error.invite_consumed': 'Lời mời này đã được sử dụng.',
  'invite.error.workspace_seat_limit_reached': 'Team không còn seat. Nhờ admin giải phóng seat hoặc thêm seat.',
  'invite.error.workspace_subscription_locked': 'Subscription của team không active nên hiện không thể thêm member.',
  'invite.error.workspace_not_found': 'Workspace này không còn tồn tại.',
  'invite.error.workspace_forbidden': 'Tài khoản của bạn không được phép chấp nhận lời mời này.',
  'invite.error.invite_unavailable': 'Lời mời này không còn khả dụng.',
  'invite.error.generic': 'Có lỗi xảy ra. Vui lòng thử lại.',
  'invite.error.retry': 'Thử lại',

  'workspaceInvite.dialogAria': 'Mời member',
  'workspaceInvite.title': 'Mời member vào team',
  'workspaceInvite.freePlanBody': 'Gói free gồm 1 seat. Mời đồng đội sẽ hướng bạn nâng cấp lên Teams.',
  'workspaceInvite.teamPlanBody': 'Mời đồng đội để cùng chia sẻ project, design system và plugin.',
  'workspaceInvite.seatsExhaustedBody': 'Workspace này không còn seat. Thêm seat để mời đồng đội.',
  'workspaceInvite.seatsExhaustedAction': 'Xem seat và gói',
  'workspaceInvite.emailLabel': 'Mời member bằng email',
  'workspaceInvite.roleLabel': 'Gán vai trò',
  'workspaceInvite.defaultRoleLabel': 'Vai trò mặc định',
  'workspaceInvite.emailPlaceholder': 'Nhập địa chỉ email...',
  'workspaceInvite.removeRow': 'Gỡ',
  'workspaceInvite.addMember': 'Thêm member',
  'workspaceInvite.visibilityQuestion': 'Member team có thấy thiết kế của tôi không?',
  'workspaceInvite.visibilityAnswer': 'Member team có thể thấy thiết kế bạn chia sẻ vào team space. Thiết kế riêng trong project Personal không hiển thị với người khác.',
  'workspaceInvite.sent': 'Đã gửi lời mời',
  'workspaceInvite.sending': 'Đang mời...',
  'workspaceInvite.confirm': 'Xác nhận và mời',
  'workspaceInvite.submitFailed': 'Gửi lời mời thất bại. Thử lại sau.',
  'workspaceInvite.errorAlreadyMember': 'Email này đã là member team hoặc có lời mời đang chờ.',
  'workspaceInvite.errorNoSession': 'Mở/cấu hình tài khoản team trước khi mời member.',
  'workspaceInvite.errorNoWorkspace': 'Chưa có team workspace để mời member.',
  'workspaceInvite.errorUnreachable': 'Không gửi được lời mời. Vui lòng thử lại sau.',

  'socialShare.openDesignSection': 'Chia sẻ EduDeck',
  'socialShare.openDesignTitle': 'EduDeck trên GitHub',
  'socialShare.openDesignText': 'EduDeck là workspace source-available để tạo, sửa, deploy và bàn giao design artifact.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'SOCIAL SHARE',
  'socialShare.publishPageTitle': 'Publish trang chia sẻ',
  'socialShare.publishPageSubtitle': 'Publish preview này để có thể chia sẻ trên nền tảng social.',
  'socialShare.projectTitle': '{title} · EduDeck',
  'socialShare.projectText': 'Tạo bằng EduDeck: {title}. Xem artifact đã deploy và star repo: {repo}',
  'socialShare.projectCopyText': 'Tạo bằng EduDeck: {title}\n{url}\nRepo EduDeck: {repo}',
  'socialShare.deployFirst': 'Deploy rồi chia sẻ...',
  'socialShare.copied': 'Đã copy',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',

  'workingDirPicker.title': 'Thư mục',
  'workingDirPicker.homeTitle': 'Lưu trong local storage - bấm để chọn thư mục',
  'workingDirPicker.processing': 'Đang xử lý...',
  'workingDirPicker.select': 'Local storage',
  'workingDirPicker.clearAria': 'Xóa working directory',
  'workingDirPicker.replaceFailed': 'Không thay được working directory',
  'workingDirPicker.unavailable': 'Folder picker không khả dụng trong bản build này. Chạy desktop app để chọn thư mục.',
  'workingDirPicker.openUnavailable': 'Mở project này trong desktop app để hiện thư mục.',
  'workingDirPicker.openFailed': 'Không hiện được thư mục này',
  'workingDirPicker.showInFileManager': 'Hiện trong file manager',
  'workingDirPicker.replace': 'Chọn thư mục...',
  'workingDirPicker.recent': 'Thư mục gần đây',
  'workingDirPicker.defaultLabel': 'Local storage',

  'questions.tabLabel': 'Câu hỏi',
  'questions.banner': 'Tôi hỏi nhanh vài câu được không?',
  'questions.bannerAnswered': 'Câu hỏi đã trả lời',
  'questions.continue': 'Tiếp tục',
  'questions.generating': 'Đang tạo câu hỏi...',
  'questions.skipAll': 'Bỏ qua tất cả',
  'questions.autoSkipHint': 'Tự tiếp tục khi timer kết thúc',
  'questions.submitting': 'Đang gửi...',
  'questions.uploadingFiles': 'Đang upload file...',
  'questions.uploadNeedsProject': 'Upload file cần project đang active.',
  'questions.uploadPartialFailed': 'Đã upload {uploaded} file, nhưng {failed} thất bại.',
  'questions.uploadFailed': 'Upload file thất bại với {failed} file.',

  'nextStep.title': 'Bước tiếp theo',
  'nextStep.more': 'Thêm',
  'nextStep.share': 'Chia sẻ',
  'nextStep.download': 'Tải xuống',
  'nextStep.createDesignSystemTitle': 'Tạo design system',
  'nextStep.createDesignSystemBody': 'Nhân bản project này thành workspace design-system và bắt đầu lượt agent từ toàn bộ file/reference hiện tại.',
  'nextStep.createDesignSystemBusy': 'Đang tạo design system...',
  'nextStep.contribute': 'Contribute',
  'nextStep.planGenerateTitle': 'Generate artifact',
  'nextStep.planGenerateBody': 'Dùng plan Markdown đã duyệt làm source of truth cho lượt thiết kế tiếp theo.',
  'nextStep.planImproveTitle': 'Cải thiện tài liệu',
  'nextStep.planImproveBody': 'Siết tài liệu plan hiện tại trước khi tạo artifact cuối.',
  'nextStep.planGeneratePrompt': 'Dùng `{file}` làm source of truth. Đọc tài liệu trước, giữ nguyên các quyết định trong đó, rồi generate artifact thiết kế cuối khớp với nó. Nếu là outline slide, generate deck; nếu là PRD/plan prototype, generate prototype hoặc wireframe; nếu là storyboard/creative brief, generate artifact visual/media tương ứng. Trước khi generate, nêu mọi TODO hoặc mâu thuẫn blocker bạn không thể tự xử lý.',
  'nextStep.planImprovePrompt': 'Đọc `{file}` và cải thiện trực tiếp như tài liệu plan có thể sửa. Siết scope, bổ sung section yếu, thêm acceptance check còn thiếu, và giữ TODO/câu hỏi mở nơi vẫn cần input người dùng. Chưa generate artifact thiết kế cuối.',
  'nextStep.planImproveArtifactTitle': 'Cải thiện artifact',
  'nextStep.planImproveArtifactBody': 'Tiếp tục lặp trên artifact đã generate thay vì quay lại planning.',
  'nextStep.planImproveArtifactPrompt': 'Cải thiện `{artifact}` tại chỗ. Giữ artifact đang hoạt động và thực hiện các cải thiện sản phẩm, visual, interaction và content có impact cao nhất. Giữ hành vi đã hoạt động, rồi tóm tắt file đã đổi và rủi ro còn lại.',
  'nextStep.planMergeTitle': 'Căn chỉnh tài liệu và artifact',
  'nextStep.planMergeBody': 'Đối chiếu plan và artifact đã generate để chúng tiến cùng nhau.',
  'nextStep.planMergePrompt': 'Đọc `{document}` và `{artifact}` cùng nhau. Xem tài liệu là intent và artifact là implementation hiện tại. Đối chiếu chúng: cập nhật artifact theo quyết định đã xác nhận, chỉ cập nhật tài liệu ở nơi đã cũ, và giữ TODO/câu hỏi mở rõ ràng cho phần chưa giải quyết. Giữ hành vi đang hoạt động và tóm tắt thay đổi trong cả hai file.',
  'nextStep.projectContinueTitle': 'Tiếp tục làm',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit token & kit',
  'nextStep.brandAiOptimizeTitle': 'Refine design system đã trích xuất',
  'nextStep.brandAiOptimizeBody': 'Bắt đầu lượt agent dùng model token, trích xuất lại source và cập nhật design system này tại chỗ.',
  'nextStep.brandCreateDesignTitle': 'Tạo với design system này',
  'nextStep.brandCreateDesignBody': 'Bắt đầu thiết kế mới bằng màu, type, asset và system guidance đã trích xuất.',
  'nextStep.brandCreateDesignPrompt': 'Tạo thiết kế mới với design system {designSystem}.',
  'nextStep.brandContinueExtractionTitle': 'Tiếp tục trích xuất',
  'nextStep.brandContinueExtractionBody': 'Sau khi tab Browser đã qua verification, đọc nó và tiếp tục điền kit đã lưu.',
  'nextStep.brandContinueExtractionBusy': 'Đang tiếp tục trích xuất...',
  'nextStep.brandContinueAiExtractionTitle': 'Tiếp tục với agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Dùng agent đã chọn để trích xuất từ draft đã lưu nếu lượt programmatic vẫn không hoàn tất.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume agent đã chọn từ scaffold brand hiện tại và hoàn tất cùng design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Đang tiếp tục với agent...',
  'nextStep.createDesignBusy': 'Đang tạo thiết kế...',

  'handoff.toTarget': 'Bàn giao sang {target}',
  'handoff.openInTarget': 'Mở trong {target}',
  'handoff.openAction': 'Mở',
  'handoff.menuTitle': 'Mở bằng editor nào?',
  'handoff.action': 'Bàn giao',
  'handoff.fallbackTitle': 'Không tìm thấy editor trên $PATH - mở trong {target}',
  'handoff.chooseTargetAria': 'Chọn đích bàn giao',
  'handoff.optionsAria': 'Tùy chọn bàn giao',
  'handoff.editorSection': 'Mở bằng editor',
  'handoff.cliSection': 'Copy cho CLI',
  'handoff.clickOpen': 'Bấm để mở',
  'handoff.framework': 'Framework code',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML và CSS',
  'handoff.amrWebsite': 'EduDeck',
  'handoff.copyPrompt': 'Copy prompt',
  'handoff.copyPromptForTarget': 'Copy prompt cho {target}',
  'handoff.copied': 'Đã copy',
  'handoff.projectPathUnavailable': 'Path project vẫn đang tải. Thử lại sau một lát.',
  'handoff.copyFailed': 'Clipboard bị chặn ghi. Thử lại sau một lát.',
  'handoff.promptIntro': 'Tiếp tục từ thư mục project EduDeck local này:',
  'handoff.promptTarget': 'Đích',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Bạn đang tiếp quản trong {cli}. Vui lòng:',
  'handoff.promptReadFiles': 'Vào hoặc đọc thư mục này trước. Ưu tiên DESIGN.md, README, HTML/CSS/JS hiện có, asset và package.json nếu có.',
  'handoff.promptKeepDesign': 'Giữ nguyên thiết kế visual, layout, interaction và asset hiện tại. Đừng dừng ở plan.',
  'handoff.promptProduceCode': 'Generate hoặc sửa code {framework} thật có thể chạy. Nếu project đã có stack rõ hơn, nêu conflict và giữ kết quả chạy được.',
  'handoff.promptVerify': 'Kết thúc bằng cách nói cho tôi lệnh run, preview và verify.',
  'handoff.promptCommandHint': 'Để bắt đầu từ thư mục project, dùng:',
  'handoff.promptProject': 'Project',
  'handoff.promptProjectId': 'Project ID',
  'handoff.notInstalled': 'Chưa cài',
  'handoff.notDetectedTitle': '{target} - không phát hiện trên $PATH',

  'updater.available': 'Có update',
  'updater.availableBody': 'EduDeck {version} đã có. Cần download trước khi mở installer.',
  'updater.activeRunsTitle': 'EduDeck vẫn đang làm việc',
  'updater.activeRunsBody': '{count} task đang chạy. Restart bây giờ sẽ ngắt chúng.',
  'updater.activeRunsUnknownBody': 'EduDeck không xác nhận được còn task đang chạy hay không. Restart bây giờ có thể ngắt công việc đang active.',
  'updater.checking': 'Đang kiểm tra update',
  'updater.download': 'Download update',
  'updater.downloading': 'Đang download update',
  'updater.downloadingPercent': 'Đang download update {percent}%',
  'updater.done': 'Xong',
  'updater.failed': 'Update thất bại',
  'updater.installerOpenBody': 'Installer đã mở. EduDeck đang thoát để bạn hoàn tất update.',
  'updater.installerOpened': 'Installer đã mở',
  'updater.later': 'Để sau',
  'updater.allowSilentUpdates': 'Cho phép tự động cài update trong app sau này',
  'updater.openFailedFallback': 'Không mở được installer.',
  'updater.installRestart': 'Cài và restart',
  'updater.installingRestart': 'Đang cài và restart...',
  'updater.openInstaller': 'Cài update',
  'updater.opening': 'Đang mở installer...',
  'updater.dialogAvailableGeneric': 'Có phiên bản mới.\nDownload để cài update.',
  'updater.dialogAvailableVersion': 'v{version} đã có.\nDownload để cài update.',
  'updater.dialogCheckFailed': 'Không kiểm tra được update.\nVui lòng thử lại sau.',
  'updater.dialogReadyGeneric': 'Phiên bản mới đã sẵn sàng.\nTrải nghiệm tốt hơn và thiết kế thông minh hơn đang chờ.',
  'updater.dialogReadyVersion': 'v{version} đã sẵn sàng.\nTrải nghiệm tốt hơn và thiết kế thông minh hơn đang chờ.',
  'updater.dialogUnsupported': 'Update trong app không khả dụng ở đây.\nTải bản mới nhất từ Releases.',
  'updater.payloadReadyGeneric': 'Update EduDeck mới đã sẵn sàng. EduDeck sẽ tự đóng và restart.',
  'updater.payloadReadyVersion': 'EduDeck {version} đã sẵn sàng. EduDeck sẽ tự đóng và restart.',
  'updater.quitButton': 'Thoát EduDeck',
  'updater.quitFailedBody': 'Installer đã mở, nhưng EduDeck không thoát được. Thoát EduDeck trước khi thay app.',
  'updater.quitFailedTitle': 'Không thoát được',
  'updater.quitting': 'Đang thoát...',
  'updater.ready': 'Update sẵn sàng',
  'updater.readyGeneric': 'Phiên bản mới đã sẵn sàng. EduDeck sẽ đóng và mở installer.',
  'updater.readyVersion': 'EduDeck {version} đã sẵn sàng. EduDeck sẽ đóng và mở installer.',
  'updater.reinstallLearnMore': 'Tìm hiểu thêm',
  'updater.reinstallReadyGeneric': 'Update này cần reinstall đầy đủ. EduDeck sẽ đóng và mở installer.',
  'updater.reinstallReadyVersion': 'EduDeck {version} cần reinstall đầy đủ. EduDeck sẽ đóng và mở installer.',
  'updater.restartAnyway': 'Vẫn restart',
  'updater.upToDate': 'Bạn đang ở phiên bản mới nhất.',
  'updater.viewVersionFeatures': 'Khám phá tính năng mới',
  'updater.manualDownload': 'Download thủ công',

  'useEverywhere.modalAria': 'Dùng EduDeck ở mọi nơi',
  'useEverywhere.modalTitle': 'Dùng EduDeck ở mọi nơi',
  'useEverywhere.modalSubtitle': 'Đưa EduDeck vào bất kỳ IDE, agent hoặc script nào - CLI, HTTP, MCP và Skills. Dùng "Copy guide for an agent" rồi dán vào Claude Code, Codex, Cursor, openclaw hoặc hermes để thiết lập mọi thứ.',
  'useEverywhere.closeAria': 'Đóng use everywhere',
  'useEverywhere.closeTitle': 'Đóng (Esc)',
  'useEverywhere.tabsAria': 'Bề mặt integration',
  'useEverywhere.footStrong': 'Bàn giao một click.',
  'useEverywhere.footBody': 'Copy guide markdown có cấu trúc để agent xử lý ngay - cài, verify và dùng.',
  'useEverywhere.configureMcp': 'Cấu hình MCP server',
  'useEverywhere.copyGuide': 'Copy guide cho agent',
  'useEverywhere.copy': 'Copy',
  'useEverywhere.copied': 'Đã copy',
  'useEverywhere.copyFailed': 'Copy thất bại',
  'useEverywhere.copySnippetAria': 'Copy snippet: {label}',
  'useEverywhere.section.overview.tab': 'Tổng quan',
  'useEverywhere.section.overview.heading': 'EduDeck hoạt động ở mọi nơi agent của bạn hoạt động',
  'useEverywhere.section.overview.intro': 'EduDeck không chỉ là một cửa sổ - nó là daemon local có quyền (`od`) kèm registry Skills + Design-Systems + Atoms. Khi đang chạy trên máy, bất kỳ code agent nào (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes hoặc script riêng) đều có thể điều khiển generation, kiểm tra project và tạo design artifact qua bốn bề mặt có thể thay thế nhau.',
  'useEverywhere.section.overview.bullet1': 'CLI - `od <command>` cho script headless, CI và shell automation.',
  'useEverywhere.section.overview.bullet2': 'MCP server - nối EduDeck như Model Context Protocol server để agent hỗ trợ MCP có thể liệt kê skill, chạy scenario và đọc artifact.',
  'useEverywhere.section.overview.bullet3': 'HTTP API - endpoint REST + SSE `http://127.0.0.1:7456/api/*`; cùng bề mặt web UI đang dùng.',
  'useEverywhere.section.overview.bullet4': 'Skills - pack `SKILL.md` drop-in (tương thích Claude) mà agent đang có trên PATH có thể gọi ngay cả khi không chạy EduDeck.',
  'useEverywhere.section.overview.bullet5': 'Artifact chuẩn - seed project HTML thật từ Skills, plugin mặc định bundled và ví dụ plugin cộng đồng trước khi daemon khởi động.',
  'useEverywhere.section.overview.snippet1': 'Khởi động daemon (và web UI) local',
  'useEverywhere.section.overview.snippet2': 'Xác nhận có thể truy cập',
  'useEverywhere.section.overview.snippet3': 'Ingest artifact chuẩn trước khi boot',
  'useEverywhere.section.overview.footer': 'Daemon mặc định ghi vào `./.od/` (theo project). Đặt `OD_DATA_DIR=~/.open-design` để dùng chung dữ liệu giữa các project.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Điều khiển EduDeck từ mọi shell',
  'useEverywhere.section.cli.intro': 'Binary `od` đi kèm daemon và là cùng binary Claude Code / Codex dùng khi chạy generation. Hầu hết subcommand là thin client POST tới daemon local, nên hoạt động giống nhau dù bạn chạy qua `pnpm tools-dev` hay app đóng gói.',
  'useEverywhere.section.cli.bullet1': '`od` (không args) - boot daemon và mở web UI.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` - tạo byte ảnh / video / audio qua unified media protocol.',
  'useEverywhere.section.cli.bullet3': '`od run ...` - bắt đầu project run từ prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` - cài và áp dụng plugin cộng đồng.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` - xem thứ có sẵn local.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` - verify sức khỏe daemon và phát hiện agent CLI trên PATH.',
  'useEverywhere.section.cli.snippet1': 'Generate ảnh (ủy quyền cho media provider đã cấu hình)',
  'useEverywhere.section.cli.snippet2': 'Chạy scenario plugin headless và stream event dạng JSON lines',
  'useEverywhere.section.cli.snippet3': 'Kiểm kê skill và design system có sẵn local',
  'useEverywhere.section.cli.snippet4': 'Kiểm tra artifact đã seed qua CLI',
  'useEverywhere.section.cli.snippet5': 'Verify môi trường + agent đã phát hiện (Claude, Codex, Cursor, ...)',
  'useEverywhere.section.cli.footer': 'Mọi subcommand nhận `--daemon-url http://127.0.0.1:<port>` để trỏ tới daemon đang chạy cụ thể - hữu ích khi chạy instance thứ hai sandbox để test.',
  'useEverywhere.section.mcp.tab': 'MCP server',
  'useEverywhere.section.mcp.heading': 'Expose EduDeck như MCP server cho mọi coding agent',
  'useEverywhere.section.mcp.intro': 'EduDeck đi kèm Model Context Protocol server (`od mcp`) cho phép client hỗ trợ MCP - Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes - khám phá tool EduDeck (liệt kê skill, render preview, generate media, chạy plugin) mà không cần shell thủ công. Daemon publish snippet cài đặt sẵn để dán qua `GET /api/mcp/install-info` cho từng client lớn.',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport - không cần port bổ sung, client spawn trực tiếp `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Tự phát hiện URL daemon live qua local IPC status socket khi chạy như sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Fallback sang `--daemon-url http://127.0.0.1:<port>` cho cài đặt thường để MCP process luôn tìm được daemon đang chạy.',
  'useEverywhere.section.mcp.bullet4': 'Pin `OD_DATA_DIR` để MCP process được spawn ghi cùng nơi daemon đang dùng (tránh EPERM trong app bundle macOS đóng gói).',
  'useEverywhere.section.mcp.snippet1': 'Config MCP client chung (dùng trong Cursor, Claude Code, Codex, ...)',
  'useEverywhere.section.mcp.snippet2': 'Hoặc: hỏi daemon để lấy snippet đúng với bản cài của bạn',
  'useEverywhere.section.mcp.snippet3': 'Biến thể MCP live-artifacts (đọc & refresh dashboard)',
  'useEverywhere.section.mcp.footer': 'Trong app EduDeck, mở Settings -> Integrations để copy lệnh cài riêng cho client (Cursor, Claude Code, Antigravity, VS Code) thay vì sửa JSON thủ công.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Cùng bề mặt REST + SSE mà web UI dùng',
  'useEverywhere.section.http.intro': 'Daemon local phục vụ HTTP API tại `http://127.0.0.1:7456` (có thể cấu hình port). Mọi endpoint web UI gọi cũng dùng được cho script của bạn. Endpoint streaming (chat turn, project run) phát Server-Sent Events với contract type trong `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` - kiểm tra daemon sống.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` và `GET /api/design-systems` - registry có sẵn.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` và `POST /api/projects` - liệt kê và tạo project (POST trả về project + conversation đầu tiên).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` - SSE stream event agent cho conversation.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` - bind plugin đã cài và nhận query ví dụ + input đã render.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` - code-agent CLI phát hiện trên PATH.',
  'useEverywhere.section.http.snippet1': 'Liệt kê skill đã cài (agent sẽ dùng làm template)',
  'useEverywhere.section.http.snippet2': 'Tạo project từ prompt (flow server-side đầy đủ)',
  'useEverywhere.section.http.snippet3': 'Stream một chat turn (SSE - mỗi dòng tương thích JSON-Lines)',
  'useEverywhere.section.http.footer': 'Type TypeScript thuần cho mọi request/response nằm trong `@open-design/contracts` - import vào script để có autocomplete đầy đủ mà không cần generator.',
  'useEverywhere.section.skills.tab': 'Skills & headless',
  'useEverywhere.section.skills.heading': 'Skill drop-in cho mọi agent - kể cả khi không chạy EduDeck',
  'useEverywhere.section.skills.intro': 'Skill là thư mục có `SKILL.md` tương thích Claude (YAML front-matter + body). EduDeck mở rộng format bằng namespace `od:` (`mode`, `preview`, `design_system`, `inputs`, ...) để cùng artifact dùng được cả trong EduDeck lẫn agent vanilla như Claude Code, Codex, openclaw hoặc hermes. Discovery theo chuỗi ưu tiên để project có thể override skill riêng.',
  'useEverywhere.section.skills.bullet1': 'Discovery: `./.claude/skills/` -> `./skills/` -> `~/.claude/skills/` (project thắng).',
  'useEverywhere.section.skills.bullet2': 'Symlink một skill vào nhiều project để dùng chung mà không copy.',
  'useEverywhere.section.skills.bullet3': 'Mỗi skill có thể khai báo connector, atom, yêu cầu design-system và output ví dụ `preview` cho gallery.',
  'useEverywhere.section.skills.bullet4': 'Headless: agent có `od` trên PATH có thể gọi `od skills list` rồi chạy skill bất kỳ; daemon là tùy chọn cho flow chỉ đọc.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` chạy cùng shape artifact với ví dụ plugin mặc định và ví dụ plugin cộng đồng, rồi lưu project `index.html` kết quả làm dữ liệu test tái dùng.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md tối thiểu (front matter tương thích Claude + phần mở rộng EduDeck)',
  'useEverywhere.section.skills.snippet2': 'Symlink skill dùng chung vào project (kiểu cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Headless: liệt kê skill daemon thấy hiện tại',
  'useEverywhere.section.skills.snippet4': 'Bundle fixture artifact headless',
  'useEverywhere.section.skills.footer': 'Spec: `docs/skills-protocol.md` và `docs/agent-adapters.md` mô tả toàn bộ adapter surface (Claude Code, Codex, Cursor, agent hỗ trợ MCP, BYOK API fallback) và chiến lược inject skill theo từng adapter.',

  'settings.onboardingCreateTitle': 'Bắt đầu từ brief',
  'settings.onboardingCreateBody': 'Mô tả site, app, deck, ảnh hoặc video bạn muốn. EduDeck sẽ tạo project và giữ mọi thứ có thể chỉnh sửa.',
  'settings.onboardingMemoryTitle': 'Lưu ngữ cảnh làm việc',
  'settings.onboardingMemoryBody': 'Thêm sở thích, thông tin project và quy tắc lặp lại để các chat sau dùng đúng ngữ cảnh.',
  'settings.onboardingMemoryCalloutTitle': 'Đã lưu vào Memory',
  'settings.onboardingMemoryCalloutBody': 'Các câu trả lời này khởi tạo hồ sơ Memory của bạn. EduDeck dùng lại trong mọi task và tiếp tục học khi bạn làm việc.',
  'settings.onboardingMemoryBenefitIntent': 'Hiểu ý bạn từ yêu cầu ngắn',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Bỏ qua các câu hỏi thiết lập lặp lại',
  'settings.onboardingMemoryBenefitPersonalized': 'Điều chỉnh output theo vai trò, audience và gu của bạn',
  'settings.onboardingSystemsTitle': 'Đưa design system của bạn vào',
  'settings.onboardingSystemsBody': 'Chọn hoặc tạo brand system để output đi theo màu sắc, typography và ngôn ngữ sản phẩm thật.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Khuyến nghị chính thức',
  'settings.onboardingAmrCloudBenefitReady': 'Không cần deploy',
  'settings.onboardingAmrCloudBenefitModels': 'Dùng Claude, GPT, Fable 5 và 5.6 sol với ưu đãi giới hạn và concurrency cao.',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Sắp có',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Ảnh & video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Kho skill lớn',
  'settings.onboardingAmrCloudUpcomingRouting': 'Routing thông minh',
  'settings.onboardingAmrModelSourceLabel': 'EduDeck',
  'settings.onboardingAmrCloudAuthorizeAction': 'Ủy quyền',
  'settings.onboardingAmrCloudAuthorizedAction': 'Đã ủy quyền',
  'settings.onboardingStepConnect': 'Kết nối',
  'settings.onboardingStepDesignSystem': 'Tạo design system',
  'settings.onboardingStepProfile': 'Thông tin của bạn',
  'settings.onboardingStepNewsletter': 'Nhận cập nhật',
  'settings.onboardingNewsletterTitle': 'Theo dõi cập nhật',
  'settings.onboardingNewsletterBody': 'Nhận cập nhật sản phẩm, template mới, design-system drop và ambassador work qua inbox. Không bắt buộc, bạn có thể bỏ qua.',
  'settings.onboardingConnectTitle': 'Chọn runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Chọn cách chạy EduDeck',
  'settings.onboardingCloudBody': 'Dùng CLI local hoặc API key riêng để tạo project trên máy này.',
  'settings.onboardingCloudSignIn': 'Tiếp tục',
  'settings.onboardingCloudContinue': 'Tiếp tục',
  'settings.onboardingCloudAlternative': 'Dùng CLI local hoặc API key riêng',
  'settings.onboardingCloudRights': 'Bảo lưu mọi quyền.',
  'settings.onboardingCloudOr': 'hoặc',
  'settings.onboardingAmrCloudOfficialBadge': 'Chính thức',
  'settings.onboardingLocalAction': 'Mở cài đặt CLI',
  'settings.onboardingCliScanHint': 'Thường mất 5-10 giây.',
  'settings.onboardingByokAction': 'Mở cài đặt BYOK',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Tạo một lần, dùng lại mọi nơi.',
  'settings.onboardingDesignIntroGenerateTitle': 'Tạo từ công việc hiện có',
  'settings.onboardingDesignIntroGenerateBody': 'Upload design system từ GitHub hoặc repo code local, file Figma, ảnh và các asset nội dung khác.',
  'settings.onboardingDesignIntroReuseTitle': 'Dùng lại trong công việc sau',
  'settings.onboardingDesignIntroReuseBody': 'Prototype, slide và nội dung sau này có thể tham chiếu font, spacing, logo style và tone màu hiện có.',
  'settings.onboardingDesignIntroSkipTitle': 'Tạm thời không bắt buộc',
  'settings.onboardingDesignIntroSkipBody': 'Bỏ qua bước này nếu bạn muốn bắt đầu mà chưa tạo design system.',
  'settings.onboardingGithubTitle': 'Import từ GitHub',
  'settings.onboardingGithubBody': 'Dùng một frontend repository.',
  'settings.onboardingUploadTitle': 'Upload file local',
  'settings.onboardingUploadBody': 'Thêm file project, screenshot, CSS, tài liệu hoặc asset.',
  'settings.onboardingPromptTitle': 'Tạo từ prompt',
  'settings.onboardingPromptBody': 'Mô tả sản phẩm hoặc brand.',
  'settings.onboardingProfileTitle': 'Thông tin của bạn',
  'settings.onboardingProfileBody': 'Chi tiết tùy chọn để có default tốt hơn.',
  'settings.onboardingRoleLabel': 'Vai trò của bạn',
  'settings.onboardingOrgSizeLabel': 'Quy mô tổ chức',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Bạn biết đến chúng tôi từ đâu?',
  'settings.onboardingSourceX': 'X / Twitter',
  'settings.onboardingSourceGithub': 'GitHub',
  'settings.onboardingSourceYoutube': 'YouTube',
  'settings.onboardingSourceTiktok': 'TikTok',
  'settings.onboardingSourceReddit': 'Reddit',
  'settings.onboardingSourceLinkedin': 'LinkedIn',
  'settings.onboardingSourceMetaSocial': 'Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': 'Tìm kiếm (Google / Bing)',
  'settings.onboardingSourceAiTool': 'Công cụ AI (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': 'Bạn bè hoặc đồng nghiệp',
  'settings.onboardingSourceCommunity': 'Discord / cộng đồng',
  'settings.onboardingSourceEmail': 'Email / Newsletter',
  'settings.onboardingSourceBlog': 'Blog / bài viết',
  'settings.onboardingSourceOther': 'Khác',
  'settings.onboardingSourceOtherPlaceholder': 'Cho biết nguồn (tùy chọn)',
  'settings.onboardingSelectPlaceholder': 'Chọn một mục',
  'settings.onboardingSelectMultiplePlaceholder': 'Chọn một hoặc nhiều mục',
  'settings.onboardingOrgSolo': 'Cá nhân (1)',
  'settings.onboardingOrgTeam': 'Team nhỏ (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Công ty đang tăng trưởng (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': 'Product manager',
  'settings.onboardingRoleDesigner': 'Designer',
  'settings.onboardingRoleEngineer': 'Engineer',
  'settings.onboardingRoleMarketing': 'Marketing',
  'settings.onboardingRoleAgency': 'Marketing agency',
  'settings.onboardingRoleGrowth': 'Growth',
  'settings.onboardingRoleOps': 'Operations',
  'settings.onboardingRoleFounder': 'Founder / executive',
  'settings.onboardingRoleStudent': 'Student / educator',
  'settings.onboardingRoleOther': 'Khác',
  'settings.onboardingUseProduct': 'Product design',
  'settings.onboardingUseDesignSystem': 'Design system',
  'settings.onboardingUsePrototype': 'Prototype / app UI',
  'settings.onboardingUseLanding': 'Landing page',
  'settings.onboardingUseAds': 'Ads / social content',
  'settings.onboardingUseDashboard': 'Dashboard / internal tool',
  'settings.onboardingUseDeck': 'Presentation / deck',
  'settings.onboardingUseMarketing': 'Marketing / growth',
  'settings.onboardingUseEngineering': 'Engineering handoff',
  'settings.onboardingUseAgency': 'Agency / client work',
  'settings.onboardingBack': 'Quay lại',
  'settings.onboardingFinish': 'Hoàn tất thiết lập',
  'settings.cloudCalloutTitle': 'Dùng chế độ local',
  'settings.cloudCalloutBody': 'Project và cài đặt provider được giữ trên máy này.',
  'settings.cloudCalloutButton': 'Tiếp tục',
  'settings.designSystemRenameFailed': 'Đổi tên thất bại. Kiểm tra daemon đang chạy rồi thử lại.',
  'settings.amrCloud': 'EduDeck',
  'settings.amrBenefitLowerPrice': 'Chi phí thấp hơn',
  'settings.amrPromoBonus': 'Bonus giới hạn: +100%',
  'settings.amrSignInToContinue': 'Chọn provider local để tiếp tục',
  'settings.amrSignIn': 'Mở cài đặt',
  'settings.amrWalletBalance': 'Số dư ví',
  'settings.amrWalletUpdatedAt': 'Cập nhật {time}',
  'settings.amrWalletCached': 'đã cache',
  'settings.amrWalletRefresh': 'Làm mới',
  'settings.amrWalletRefreshTitle': 'Làm mới số dư',
  'settings.amrNotSignedIn': 'Chưa cấu hình',
  'settings.amrSigningIn': 'Đang mở...',
  'settings.amrActivationHint': 'Mở cài đặt để chọn CLI local hoặc provider BYOK.',
  'settings.amrActivationBrowserFailed': 'Mở cài đặt để chọn CLI local hoặc provider BYOK.',
  'settings.amrActivationOpen': 'Mở cài đặt',
  'settings.amrCancelSignIn': 'Hủy',
  'settings.amrAccountStatus': 'Trạng thái EduDeck',
  'settings.amrConsole': 'Quản lý',
  'settings.amrLoginErrorCompact': 'Thiết lập thất bại.',
  'settings.advanced': 'Nâng cao',
  'settings.amrLogin': 'Mở cài đặt',
  'settings.amrLogout': 'Ngắt kết nối',
  'settings.amrLoggingIn': 'Đang mở...',
  'settings.amrLoggingOut': 'Đang ngắt kết nối...',
  'settings.amrLoggedInAs': 'Đã cấu hình là {email}',
  'settings.amrLoggedInWithPlan': 'Đã cấu hình là {email} · {plan}',
  'settings.amrLoggedInPill': 'Đã cấu hình',
  'settings.amrNotLoggedIn': 'Chưa cấu hình',
  'settings.modelsLoadedFromAccount': 'Đã tải {count} model từ tài khoản.',
  'settings.modelsLoadedCount': 'Đã tải {count} model.',
  'settings.azureDeploymentModelHint': 'Với Azure OpenAI, trường này được dùng làm deployment name trong /openai/deployments/<model>. Nhập deployment name bạn đã tạo trong Azure.',
  'settings.byokVideoI2vHint': 'Model image-to-video: cần ảnh tham chiếu (ảnh mới nhất của project được dùng tự động nếu bạn không chọn ảnh)',
  'settings.skipForNow': 'Bỏ qua bây giờ',
  'settings.getStarted': 'Bắt đầu',
  'settings.cliEnvClaudeConfigDir': 'Thư mục cấu hình Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL proxy Claude',
  'settings.cliEnvClaudeApiKey': 'API key Claude CLI',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Đường dẫn executable Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key Codex/OpenAI CLI',
  'settings.mediaProviderLoadError': 'Không tải được cài đặt provider. Tạm dùng cài đặt đã lưu local.',
  'settings.privacyConsentKicker': 'Giúp cải thiện EduDeck',
  'settings.privacyConsentLead': 'Chia sẻ dữ liệu sử dụng giúp chúng tôi hiểu EduDeck hoạt động thế nào trong workflow thật để cải thiện các phần quan trọng nhất với trải nghiệm của bạn.',
  'settings.privacyConsentFooter': 'Bạn có thể đổi bất kỳ lúc nào trong Settings -> Privacy.',
  'settings.privacyConsentShare': 'Chia sẻ',
  'settings.privacyConsentDecline': 'Không chia sẻ',
  'settings.privacyConsentAccept': 'Tôi hiểu',
  'settings.privacyConsentBannerFooter': 'Chia sẻ dữ liệu bật mặc định. Bạn có thể tắt bất kỳ lúc nào trong Settings -> Privacy.',
  'settings.privacyConsentPolicyLink': 'Đọc privacy policy',
  'settings.privacyMetrics': 'Metric ẩn danh',
  'settings.privacyMetricsHint': 'Số lượt chạy, token usage, tỉ lệ lỗi và thời lượng dưới dạng metric sử dụng cơ bản.',
  'settings.privacyContent': 'Nội dung hội thoại và tool',
  'settings.privacyContentHint': 'Sau khi loại bỏ secret và thông tin nhạy cảm, chúng tôi dùng prompt, phản hồi assistant, input/output tool và ngữ cảnh cần cho review chất lượng.',
  'settings.privacyInstallationId': 'ID ẩn danh',
  'settings.privacyOptedOut': 'đã opt out',
  'settings.privacyDataDeletion': 'Xóa dữ liệu của tôi',
  'settings.privacyDataDeletionHint': 'Xoay ID ẩn danh và dừng gửi. Trace hiện có sẽ hết hạn theo chính sách lưu giữ.',
  'settings.installLatest': 'Cài bản mới nhất',
  'settings.alreadyLatest': 'Bạn đang ở phiên bản mới nhất',
  'settings.updateCheck': 'Kiểm tra update',
  'settings.updateNow': 'Update ngay',
  'settings.updateRecheck': 'Kiểm tra lại',
  'settings.updateRetry': 'Thử lại',
  'settings.updateQuitFailed': 'Installer đã mở, nhưng EduDeck không tự thoát được.',
  'settings.updateStatusNotChecked': 'Chưa kiểm tra',
  'settings.updateStatusDevelopment': 'Build development không hỗ trợ update trong app.',
  'settings.updateStatusUnsupported': 'Môi trường này không hỗ trợ update trong app.',
  'settings.updateStatusChecking': 'Đang kiểm tra update...',
  'settings.updateStatusUpToDate': 'Bạn đã ở phiên bản mới nhất.',
  'settings.updateStatusAvailable': 'Tìm thấy phiên bản mới {version}. Đang chuẩn bị download.',
  'settings.updateStatusAvailableUnknown': 'Tìm thấy phiên bản mới. Đang chuẩn bị download.',
  'settings.updateStatusDownloading': 'Đang download update...',
  'settings.updateStatusDownloadingPercent': 'Đang download update {percent}%.',
  'settings.updateStatusReady': 'Phiên bản {version} đã sẵn sàng để cài.',
  'settings.updateStatusReadyUnknown': 'Update đã sẵn sàng để cài.',
  'settings.updateStatusInstalling': 'Đang cài update...',
  'settings.updateStatusFailed': 'Kiểm tra thất bại. Vui lòng thử lại.',
  'settings.mcpHint': 'Dùng MCP để agent được hỗ trợ truy cập project và ngữ cảnh thiết kế của bạn.',
  'settings.mcpCodexInstallSuccess': 'Đã cài. Restart Codex để tải server mới.',
  'settings.mcpCodexUninstallSuccess': 'Đã gỡ khỏi Codex.',
  'settings.mcpRestartNote': 'Restart coding agent sau khi thêm server.',
  'settings.mcpRestartDetail': 'Hầu hết editor chỉ tải MCP server lúc khởi động. Trong Cursor / VS Code / Antigravity / Windsurf, bạn có thể chạy `Developer: Reload Window` từ command palette thay vì restart đầy đủ. Zed và Claude Code cần thoát rồi mở lại.',
  'settings.notifyCompletionSoundHint': 'Phát âm thanh khi một lượt hoàn tất. Mặc định tắt.',
  'settings.notifyDesktopHint': 'Gửi khi cửa sổ không focus.',
  'settings.notifyTestSent': 'Đã gửi thông báo test. Nếu không thấy banner, kiểm tra cài đặt notification của browser và hệ thống.',
  'settings.notifyTestFailed': 'Gọi notification thất bại. Kiểm tra cài đặt notification của browser và hệ thống.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Chime',
  'settings.notifySoundTwoToneUp': 'Hai âm đi lên',
  'settings.notifySoundPluck': 'Pluck',
  'settings.notifySoundBuzz': 'Buzz',
  'settings.notifySoundTwoToneDown': 'Hai âm đi xuống',
  'settings.notifySoundThud': 'Thud',
  'settings.skills': 'Skills',
  'settings.skillsHint': 'Skill chức năng agent có thể gọi giữa task',
  'settings.skillsNew': 'Skill mới',
  'settings.skillsEmpty': 'Chọn một skill bên trái hoặc tạo skill mới.',
  'settings.skillsEdit': 'Sửa',
  'settings.skillsDelete': 'Xóa',
  'settings.skillsDeleteConfirm': 'Xác nhận xóa',
  'settings.skillsName': 'Tên',
  'settings.skillsTriggers': 'Trigger (cách nhau bằng dấu phẩy hoặc dòng mới)',
  'settings.skillsDescription': 'Mô tả',
  'settings.skillsBody': 'Nội dung SKILL.md',
  'settings.skillsCreate': 'Tạo',
  'settings.skillsSave': 'Lưu',
  'settings.skillsSaving': 'Đang lưu...',
  'settings.skillsOverrideCreate': 'Tạo user override',
  'settings.skillsOverrideSave': 'Lưu thành user override',
  'settings.skillsBuiltInOverrideWarning': 'Sửa skill built-in này sẽ tạo user override. Entry built-in sẽ bị ẩn khỏi danh sách cho đến khi bạn xóa override. Tiếp tục?',
  'settings.skillsFiles': 'Files',
  'settings.skillsNoFiles': 'Không có file trong thư mục skill này.',
  'settings.skillsNameRequired': 'Bắt buộc nhập tên skill.',
  'settings.skillsBodyRequired': 'Bắt buộc nhập nội dung skill.',
  'settings.librarySkills': 'Skills',
  'settings.libraryDesignSystems': 'Design Systems',
  'settings.librarySearch': 'Tìm kiếm...',
  'settings.libraryAll': 'Tất cả',
  'settings.libraryPreview': 'Xem trước',
  'settings.libraryPreviewClose': 'Đóng',
  'settings.libraryLoading': 'Đang tải...',
  'settings.libraryNoResults': 'Không có mục nào khớp tìm kiếm.',
  'settings.libraryEnabled': 'Đã bật',
  'settings.libraryDisabled': 'Đã tắt',
  'settings.connectorsNavHint': 'Kết nối hệ thống bên ngoài',
  'settings.connectorsHint': 'Quản lý cài đặt connector và tool provider cho thiết bị này.',
  'settings.libraryToggleLabel': 'Bật/tắt',
  'settings.customInstructionsHint': 'Chỉ dẫn cố định EduDeck cần tuân theo trong mọi chat. Lưu fact, sở thích và ngữ cảnh project dưới dạng memory.',
  'settings.memoryDescription': 'Kiểm soát việc dùng lại fact, sở thích và ngữ cảnh project đã lưu trong các chat sau.',
  'settings.memoryEnabled': 'Đã bật',
  'settings.memoryDisabled': 'Đã tắt',
  'settings.memoryEnableLabel': 'Bật chèn memory',
  'settings.memoryDisabledBanner': 'Memory đang TẮT. Fact hiện có vẫn được giữ trên disk nhưng sẽ không được đưa vào chat mới và lượt mới sẽ không trích xuất thêm gì.',
  'settings.memoryNew': 'Memory mới',
  'settings.memoryEdit': 'Sửa',
  'settings.memoryDelete': 'Xóa',
  'settings.memoryPreview': 'Xem trước',
  'settings.memoryEmpty': 'Chưa có memory.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Tôi thích dark mode',
  'settings.memoryName': 'VD: Sở thích UI',
  'settings.memoryDesc': 'Một câu - memory này nói về gì?',
  'settings.memoryBody': '- Quy tắc một\n- Quy tắc hai\n\nLý do: tùy chọn\nKhi áp dụng: phạm vi tùy chọn',
  'settings.memoryBodyHint': 'Đưa các rule dạng bullet trước, sau đó thêm dòng Lý do và Khi áp dụng nếu cần. Hỗ trợ Markdown. Hoặc bấm starter bên trên để nạp ví dụ.',
  'settings.memoryStartersLabel': 'Cần điểm bắt đầu? Bấm để điền form:',
  'settings.memoryStarterUserName': 'Vai trò của tôi',
  'settings.memoryStarterUserDesc': 'Tôi là frontend engineer làm việc trên công cụ thiết kế SaaS',
  'settings.memoryStarterUserBody': '- Vai trò: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+7 (Asia/Ho_Chi_Minh)\n\nKhi áp dụng: mọi chat - đặt ví dụ quanh web frontend.',
  'settings.memoryStarterFeedbackName': 'Sở thích UI',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, chữ body lớn, mật độ thông tin thấp',
  'settings.memoryStarterFeedbackBody': '- Theme: dark mặc định\n- Body text: >= 18px\n- Mật độ thông tin: ưu tiên whitespace, ít item hơn trên mỗi màn hình\n\nLý do: đỡ mỏi mắt khi dùng lâu.\nKhi áp dụng: khi generate UI, web page hoặc slide.',
  'settings.memoryStarterProjectName': 'Project hiện tại',
  'settings.memoryStarterProjectDesc': 'EduDeck v0.5 - editor thiết kế bằng chat',
  'settings.memoryStarterProjectBody': '- Mục tiêu: ship chat-driven editor trong quý này\n- Ưu tiên: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nKhi áp dụng: mọi cuộc trao đổi về project này.',
  'settings.memorySaveHint': 'Không tự lưu - bấm Create / Save để áp dụng.',
  'settings.memoryIndexSaveHint': 'Sửa index không tự lưu - bấm Save index để áp dụng.',
  'settings.memoryIndexUnsaved': 'Có thay đổi chưa lưu',
  'settings.memoryFlashCreated': 'Memory đã tạo',
  'settings.memoryFlashSaved': 'Memory đã lưu',
  'settings.memoryFlashDeleted': 'Memory đã xóa',
  'settings.memoryFlashIndexSaved': 'Index đã lưu',
  'settings.memoryFlashPathCopied': 'Path đã copy',
  'settings.memoryNameLabel': 'Tiêu đề',
  'settings.memoryTypeLabel': 'Loại',
  'settings.memoryDescLabel': 'Mô tả',
  'settings.memoryBodyLabel': 'Nội dung',
  'settings.memoryTypeUser': 'Người dùng',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Tham chiếu',
  'settings.memoryTypeProfile': 'Hồ sơ',
  'settings.memoryTypeRule': 'Quy tắc',
  'settings.memoryTabMemories': 'Memories',
  'settings.memoryTabMemoriesCaption': 'Xem và quản lý memory đã lưu',
  'settings.memoryTabHow': 'Cách hoạt động',
  'settings.memoryTabHowCaption': 'Hai vòng lặp và phần điều khiển',
  'settings.memoryAddDisclosure': 'Thêm hoặc import memories',
  'settings.memoryAddDisclosureHint': 'Hồ sơ, nhập thủ công hoặc app đã kết nối',
  'settings.memoryProfileTab': 'Hồ sơ công việc',
  'settings.memoryProfileTabCaption': 'Bạn là ai và default của bạn',
  'settings.memoryProfileTitle': 'Hồ sơ công việc của bạn',
  'settings.memoryProfileHint': 'Một vài fact về bạn và default của bạn. Memory chèn phần này trước mỗi task để agent suy ra ý bạn từ yêu cầu ngắn.',
  'settings.memoryProfileName': 'Hồ sơ công việc',
  'settings.memoryProfileDescription': 'Vai trò, công ty, domain, audience, gu và default assistant nên dùng lại.',
  'settings.memoryProfileSave': 'Lưu hồ sơ',
  'settings.memoryProfileSaving': 'Đang lưu...',
  'settings.memoryProfileSaved': 'Đã lưu hồ sơ',
  'settings.memoryProfileRole': 'Vai trò',
  'settings.memoryProfileRolePlaceholder': 'VD: Founder, designer, PM',
  'settings.memoryProfileCompany': 'Công ty / Team',
  'settings.memoryProfileCompanyPlaceholder': 'VD: Acme, growth team',
  'settings.memoryProfileDomain': 'Domain',
  'settings.memoryProfileDomainPlaceholder': 'VD: B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Audience chính',
  'settings.memoryProfileAudiencePlaceholder': 'VD: executive, engineer, end user',
  'settings.memoryProfileAesthetic': 'Aesthetic / gu',
  'settings.memoryProfileAestheticPlaceholder': 'VD: sạch và editorial, nền sáng, nhiều whitespace',
  'settings.memoryProfileDeliverables': 'Deliverable mặc định',
  'settings.memoryProfileDeliverablesPlaceholder': 'VD: landing page, deck, one-pager',
  'settings.memoryProfileLocale': 'Locale / Ngôn ngữ',
  'settings.memoryProfileLocalePlaceholder': 'VD: English (US), Tiếng Việt',
  'settings.memoryProfileGoals': 'Mục tiêu hiện tại',
  'settings.memoryProfileGoalsPlaceholder': 'VD: ship pricing page mới, tăng conversion trial flow',
  'settings.memoryHooksTitle': 'Memory hooks',
  'settings.memoryHooksHint': 'Chọn phần nào của memory chạy tự động. Công tắc chính bên trên tắt toàn bộ.',
  'settings.memoryHooksProfileLabel': 'Dùng hồ sơ của tôi',
  'settings.memoryHooksProfileDesc': 'Chèn hồ sơ công việc của bạn vào mọi task.',
  'settings.memoryHooksRewriteLabel': 'Viết lại yêu cầu ngắn',
  'settings.memoryHooksRewriteDesc': 'PRE: mở rộng yêu cầu ngắn thành task brief đầy đủ.',
  'settings.memoryHooksVerifyLabel': 'Tự kiểm output',
  'settings.memoryHooksVerifyDesc': 'POST: kiểm kết quả theo rule của bạn, rồi hiển thị scorecard.',
  'settings.memoryHooksExtractionLabel': 'Học từ chat',
  'settings.memoryHooksExtractionDesc': 'Ghi nhận fact và sở thích hữu ích từ các lượt chat.',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Lưu index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory đã cập nhật',
  'settings.memoryToastClickHint': 'Xem',
  'settings.memoryAll': 'Tất cả',
  'settings.memoryExtractions': 'Lịch sử trích xuất',
  'settings.memoryExtractionsHint': 'Regex chạy trước, LLM chạy nền.',
  'settings.memoryExtractionsEmpty': 'Chưa có trích xuất. Lượt chat tiếp theo sẽ điền danh sách này.',
  'settings.memoryExtractionsRefresh': 'Làm mới',
  'settings.memoryExtractionsRefreshing': 'Đang làm mới...',
  'settings.memoryExtractionPhaseRunning': 'Đang chạy...',
  'settings.memoryExtractionPhaseSuccess': 'Thành công',
  'settings.memoryExtractionPhaseSkipped': 'Đã bỏ qua',
  'settings.memoryExtractionPhaseFailed': 'Thất bại',
  'settings.memoryExtractionSkipNoProvider': 'Chưa cấu hình API key cho LLM memory extraction.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'Media provider đã lưu không được hỗ trợ cho LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory đã tắt.',
  'settings.memoryExtractionSkipEmpty': 'Tin nhắn người dùng rỗng - không có gì để trích xuất.',
  'settings.memoryExtractionSkipNoMatch': 'Không regex pattern nào khớp lượt này.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'cài đặt media',
  'settings.memoryExtractionProviderOverride': 'cài đặt memory',
  'settings.memoryExtractionProposed': 'đề xuất',
  'settings.memoryExtractionWritten': 'đã ghi',
  'settings.memoryExtractionDuration': 'trong',
  'settings.memoryExtractionDelete': 'Xóa',
  'settings.memoryExtractionsClear': 'Xóa hết',
  'settings.memoryExtractionsClearTitle': 'Xóa toàn bộ lịch sử trích xuất',
  'settings.memoryExtractionsClearConfirm': 'Xóa toàn bộ lịch sử trích xuất? Không thể hoàn tác.',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction chưa chạy',
  'settings.memoryNoProviderBannerBody': 'Không tìm thấy API key cho memory extractor. Thêm OpenAI key trong Media providers, hoặc đặt ANTHROPIC_API_KEY / OPENAI_API_KEY trong environment để bật extraction bằng LLM. Regex heuristic vẫn đang hoạt động.',
  'settings.memoryUnsupportedProviderBannerBody': 'Media provider key đã lưu, nhưng Memory chỉ dùng lại provider hỗ trợ text: OpenAI, MiniMax, AIHubMix và SenseAudio. Cấu hình một provider trong Media providers, đặt ANTHROPIC_API_KEY / OPENAI_API_KEY, hoặc chọn model Memory trong Advanced.',
  'settings.libraryInstall': 'Cài đặt',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Path local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Cài đặt',
  'settings.libraryUninstall': 'Gỡ cài đặt',
  'settings.libraryBuiltIn': 'Built-in',
  'settings.libraryInstalled': 'Đã cài',
  'settings.orbit.navHint': 'Tóm tắt connector hằng ngày',
  'settings.orbit.gateBody': 'Orbit tóm tắt hoạt động trên các connector của bạn. Bạn chưa kết nối gì - thêm ít nhất một integration để Orbit có dữ liệu báo cáo.',
  'settings.orbit.gateBodyNoKey': 'Orbit tóm tắt hoạt động trên các connector, và connector chạy qua Composio. Thêm Composio API key trong Connectors để tải catalog và chọn integration đầu tiên.',
  'settings.orbit.gateAction': 'Mở Connectors',
  'settings.orbit.gateActionNoKey': 'Cấu hình Composio',
  'settings.orbit.gateLoading': 'Đang kiểm tra connector...',
  'settings.memoryModelInlineSameAsChat': 'Giống chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Giống chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Giống chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Tùy chọn. Dùng Local CLI đã chọn khi hỗ trợ; chỉ chọn model nếu muốn override default.',
  'settings.memoryModelInlineHintCliConstrained': 'Tùy chọn. Dùng Local CLI đã chọn khi hỗ trợ; {provider} chỉ là fallback provider family.',
  'settings.memoryModelInlineHintByok': 'Tùy chọn. Dùng lại API key chat của bạn - chọn model rẻ hơn để tiết kiệm chi phí.',
  'settings.memoryModelInlineHintByokNeutral': 'Memory dùng model riêng với chat. Mặc định theo model chat của bạn.',
  'settings.memoryModelInlineFlashSaved': 'Đã lưu',
  'settings.memoryModelInlineFlashCleared': 'Đã xóa',

  'common.exportImageFailed': 'Chụp ảnh thất bại. Vui lòng thử lại hoặc dùng công cụ screenshot của trình duyệt.',
  'common.minutesShort': '{n}p',
  'common.hoursShort': '{n}g',
  'common.daysShort': '{n}n',
  'common.dismiss': 'Đóng',
  'app.brand': 'EduDeck',
  'app.brandPill': 'Bản thử nghiệm',
  'app.brandSubtitle': 'bởi Nexu Labs',
  'app.welcomeLoading': 'Đang tải workspace...',
  'notify.successTitle': 'Task đã hoàn tất',
  'notify.failureTitle': 'Task thất bại',
  'notify.successBody': 'Một lượt đã chạy xong.',
  'notify.failureBody': 'Task kết thúc với lỗi.',
  'diagnostics.exportTitle': 'Export diagnostics',
  'diagnostics.exportButton': 'Export diagnostics',
  'diagnostics.exportHint': 'Đóng gói log app gần đây và thông tin máy vào file zip để chia sẻ với team.',
  'diagnostics.exporting': 'Đang export...',
  'diagnostics.exportSuccess': 'Đã lưu diagnostics vào {path}',
  'diagnostics.exportFailed': 'Không export được diagnostics: {message}',
  'quickSwitcher.placeholder': 'Mở tab hoặc file...',
  'quickSwitcher.empty': 'Project này không có file',
  'quickSwitcher.noMatches': 'Không có kết quả',
  'quickSwitcher.navigate': 'đi tới',
  'quickSwitcher.open': 'mở',
  'quickSwitcher.close': 'đóng',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Mời đồng nghiệp',
  'workspaceSwitcher.createTeam': 'Team mới',
  'workspaceSwitcher.draftsTooltip': 'Project cá nhân',
  'workspaceSwitcher.allProjectsTooltip': 'Project của team',
  'workspaceTabs.project': 'Project',
  'workspaceTabs.pluginDetails': 'Chi tiết plugin',
  'workspaceTabs.marketplace': 'Marketplace',
  'modelCapability.standard': 'Tiêu chuẩn',
  'modelCapability.advanced': 'Nâng cao',
  'modelCapability.bestQuality': 'Chất lượng tốt nhất',
  'modelCapability.standardDescription': 'Chất lượng ổn cho task thông thường.',
  'modelCapability.advancedDescription': 'Chất lượng mạnh hơn cho task khó hơn.',
  'modelCapability.bestQualityDescription': 'Chất lượng output tốt nhất cho công việc yêu cầu cao nhất.',
  'modelCost.upToHalf': 'Chi phí thấp',
  'modelCost.halfToOne': 'Chi phí vừa',
  'modelCost.oneToFour': 'Chi phí cao',
  'modelCost.overFour': 'Chi phí cao nhất',
  'libraryPicker.title': 'Import từ library',
  'libraryPicker.searchPlaceholder': 'Tìm library...',
  'libraryPicker.empty': 'Library của bạn chưa có asset',
  'libraryPicker.allKinds': 'Tất cả',
  'libraryPicker.add': 'Import',
  'libraryPicker.loading': 'Đang tải...',
  'skillDetail.providedBy': 'cung cấp bởi {author}',
  'skillDetail.markdownNotice': 'Nội dung dưới đây được lấy nguyên văn từ SKILL.md của skill này',
  'skillDetail.loadFailed': 'Không tải được SKILL.md của skill này.',
  'skillDetail.previewAria': 'Xem trước SKILL.md của {title}',
  'skillPluginCandidate.createForMe': 'Tạo plugin/template',
  'skillPluginCandidate.contributeToMain': 'Contribute vào open-design',
  'skillPluginCandidate.repoDescription': 'Repo này có vẻ dùng được làm plugin.',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Đáng tin cậy',
  'marketplace.filterRestricted': 'Bị giới hạn',
  'marketplace.emptyBefore': 'Chưa cài plugin nào. Thử',
  'marketplace.emptyAfter': ', hoặc đăng ký marketplace bên dưới.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Catalog đã cấu hình',
  'marketplace.catalogsEmpty': 'Chưa đăng ký gì. Thêm bằng',
  'marketplace.pluginCount': '{count} plugin',
  'pasteDialog.title': 'Dán text',
  'pasteDialog.hint': 'Lưu vào thư mục project. Chọn tên bất kỳ.',
  'pasteDialog.fileNameLabel': 'Tên file',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'Nội dung',
  'pasteDialog.contentPlaceholder': 'Dán bất kỳ nội dung nào...',
  'pasteDialog.save': 'Lưu',
  'pasteDialog.cancel': 'Hủy',
  'genui.continue': 'Tiếp tục',
  'genui.authorize': 'Ủy quyền',
  'genui.skip': 'Bỏ qua',
  'genui.acceptAll': 'Chấp nhận tất cả',
  'genui.rejectAll': 'Từ chối tất cả',
  'genui.submit': 'Gửi',
  'genui.submitPartial': 'Gửi quyết định một phần',
  'genui.patchNotesPlaceholder': 'Ghi chú cho người viết patch (tùy chọn)',
  'questionForm.submit': 'Gửi',
  'questionForm.skip': 'Bỏ qua',
  'questionForm.locked': 'Đã trả lời',
  'whatsNew.updatedTitle': 'EduDeck {version} đã có',
  'whatsNew.cta': 'Xem release notes',
  'newsletter.label': 'Newsletter (tùy chọn)',
  'newsletter.placeholder': 'you@studio.com',
  'misc.savedTemplate': 'Template đã lưu',
  'misc.primary': 'Chính',
  'misc.designSystem': 'Design system',
  'signOut.confirmTitle': 'Đăng xuất',
  'signOut.confirmMessage': 'Bạn có chắc muốn đăng xuất?',
  'signOut.confirmAction': 'Đăng xuất',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Tài chính',
  'brandPicker.categoryFashion': 'Thời trang',
  'brandPicker.categoryActivewear': 'Đồ thể thao',
  'brandPicker.categoryBeauty': 'Làm đẹp',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Ẩm thực',
  'brandPicker.categoryBeverage': 'Đồ uống',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Giáo dục',
  'brandPicker.categoryElectronics': 'Điện tử',
  'brandPicker.categoryAutomotive': 'Ô tô',
  'brandPicker.categoryHealthcare': 'Y tế',
  'brandPicker.categoryTravel': 'Du lịch',
  'brandPicker.heading': 'Bắt đầu từ brand bạn thích',
  'brandPicker.subtext': 'Bấm bất kỳ brand nào để trích xuất design system trực tiếp từ website của họ.',
  'brandPicker.quickPicksLabel': 'Brand phổ biến - bấm để trích xuất',
  'brandPicker.searchPlaceholder': 'Tìm brand...',
  'brandPicker.allCategories': 'Tất cả',
  'brandPicker.extractAction': 'Trích xuất',
  'brandPicker.showMore': 'Hiện thêm',
  'brandPicker.opening': 'Đang bắt đầu trích xuất - mở {brand}...',
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md đã dán',
  'brandExtractionTranscript.user': 'Trích xuất design system từ {source}.',
  'brandExtractionTranscript.doneTitle': 'Trích xuất programmatic đã hoàn tất cho {name}.',
  'brandExtractionTranscript.doneBody': 'Tôi đã tạo và đăng ký design system {designSystemId} từ {source}. Nó đã sẵn sàng để xem trước và dùng trong thiết kế mới.',
  'brandExtractionTranscript.next': 'Tiếp theo, chọn bước sau: refine design system đã trích xuất bằng agent pass dùng model token, hoặc tạo thiết kế mới bằng system này.',
  'brandEnrichment.title': 'AI Optimize',
  'brandEnrichment.body': 'EduDeck sẽ chạy trích xuất sâu hơn ở nền, tự áp dụng đúng design-system skills và cập nhật system này tại chỗ. Có thể mất 10-20 phút; bạn vẫn có thể tiếp tục làm việc.',
  'brandEnrichment.cta': 'AI Optimize',
  'brandEnrichment.busy': 'Đang bắt đầu AI Optimize...',
  'homeWorkingDir.trigger': 'Thư mục làm việc',
  'homeWorkingDir.triggerShort': 'Thư mục làm việc',
  'homeWorkingDir.pick': 'Chọn thư mục',
  'homeWorkingDir.replace': 'Đổi thư mục làm việc',
  'homeWorkingDir.recent': 'Thư mục gần đây',
  'homeWorkingDir.recentEmpty': 'Không có thư mục gần đây',
  'homeWorkingDir.clear': 'Gỡ thư mục làm việc',
  'homeWorkingDir.hint': 'Cho agent đọc thư mục local này (không import vào Design Files)',
  'homeWorkingDir.missing': 'Thư mục làm việc này không còn tồn tại - chọn thư mục khác',
  'homeWorkingDir.applyFailed': 'Không đặt được thư mục làm việc - thư mục có thể không còn tồn tại',
  'inspect.close': 'Đóng inspect',
  'inspect.colors': 'Màu',
  'inspect.text': 'Text',
  'inspect.background': 'Nền',
  'inspect.typography': 'Typography',
  'inspect.size': 'Kích thước',
  'inspect.weight': 'Độ đậm',
  'inspect.align': 'Căn chỉnh',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'onboarding.brandTitle': 'Trích xuất design system của bạn',
  'onboarding.brandSubtitle': 'Dán website và chúng tôi sẽ biến tín hiệu brand thành design system tái dùng cho công việc sau.',
  'onboarding.brandSkip': 'Bỏ qua',
  'onboarding.brandDone': 'Design system đã trích xuất',
  'onboarding.buildTitle': 'Tạo một lần, build mọi nơi',
  'onboarding.buildBody': 'EduDeck biến brand của bạn thành design system tái dùng, rồi giữ mọi thứ bạn build đúng brand và nhất quán.',
  'onboarding.buildBenefitMemoryTitle': 'Một brand memory',
  'onboarding.buildBenefitMemoryBody': 'Màu, type, spacing, component và voice trở thành DESIGN.md để agent của bạn dùng lại.',
  'onboarding.buildBenefitAlignedTitle': 'Mọi output luôn căn chỉnh',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard và marketing work đều lấy từ cùng một bộ rule.',
  'onboarding.buildBenefitSourcesTitle': 'Bắt đầu từ thứ bạn có',
  'onboarding.buildBenefitSourcesBody': 'Dùng GitHub repo, website, DESIGN.md hiện có, screenshot, font hoặc file Figma.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Tạo design system',
  'onboarding.buildHome': 'Về home',
  'qf.answered': 'đã trả lời',
  'qf.choose': 'Chọn...',
  'qf.customLabel': 'Câu trả lời tùy chỉnh',
  'qf.customPlaceholder': 'Nhập câu trả lời của bạn...',
  'qf.otherOption': 'Khác',
  'qf.required': 'bắt buộc',
  'qf.lockedSubmitted': 'Câu trả lời đã gửi - agent sẽ dùng chúng cho phần còn lại của session.',
  'qf.lockedPrev': 'Form này thuộc lượt trước.',
  'qf.hint': 'Chọn phần phù hợp. Bỏ qua field tùy chọn nếu không quan tâm - agent sẽ dùng default hợp lý.',
  'qf.submitDefault': 'Gửi câu trả lời',
  'qf.submitDisabledTitle': 'Điền các field bắt buộc trước',
  'qf.submitTitle': 'Gửi câu trả lời',
  'qf.cardSelected': 'đã chọn',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'The quick brown fox · 0123',
  'messageCenter.openAria': 'Mở message center',
  'messageCenter.unreadCount': '{count} chưa đọc',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'Cập nhật EduDeck, thông báo nền tảng và thông báo tài khoản.',
  'messageCenter.filterAll': 'Tất cả',
  'messageCenter.filterUnread': 'Chưa đọc',
  'messageCenter.filterRead': 'Đã đọc',
  'messageCenter.markAllRead': 'Đánh dấu tất cả đã đọc',
  'messageCenter.emptyAllTitle': 'Chưa có tin nhắn',
  'messageCenter.emptyUnreadTitle': 'Đã đọc hết',
  'messageCenter.emptyReadTitle': 'Không có tin nhắn đã đọc',
  'messageCenter.emptyBody': 'Tin nhắn nền tảng mới sẽ xuất hiện ở đây.',
  'messageCenter.close': 'Đóng message center',
  'messageCenter.desktopSettings': 'Cài đặt notification desktop',
  'messageCenter.desktopSettingsHint': 'Âm thanh hoàn tất task và notification hệ thống nằm trong Settings.',
  'collabPresence.ariaOne': '1 cộng tác viên online',
  'collabPresence.aria': '{count} cộng tác viên online',
  'collabPresence.ariaWithSelfOne': '1 cộng tác viên online, gồm bạn',
  'collabPresence.ariaWithSelf': '{count} cộng tác viên online, gồm bạn',
  'collabPresence.moreOnline': 'thêm {count} online',
  'collabPresence.dialogTitle': 'Cộng tác viên online',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'Bạn',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'Bạn đang xem {file}',
  'collabPresence.viewingFileOther': 'Đang xem {file}',
  'collabPresence.viewingProjectSelf': 'Bạn đang xem project này',
  'collabPresence.viewingProjectOther': 'Đang xem project này',
  'inlineSwitcher.chipTitle': 'Đổi CLI / model',
  'inlineSwitcher.chipCli': 'Local CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'default',
  'inlineSwitcher.noAgent': 'không có agent',
  'inlineSwitcher.modeLabel': 'Mode',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Provider',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Dùng Local CLI',
  'inlineSwitcher.useByok': 'Dùng BYOK API key',
  'inlineSwitcher.daemonOffline': 'Daemon offline - mở settings',
  'inlineSwitcher.noAgentsDetected': 'Không phát hiện CLI trên PATH',
  'inlineSwitcher.openSettingsForModel': 'Cấu hình provider trong Settings',
  'inlineSwitcher.missingApiKey': 'Chưa đặt API key - mở Settings để thêm.',
  'inlineSwitcher.openFullSettings': 'Mở execution settings',
  'inlineSwitcher.customSuffix': '(tùy chỉnh)',
  'promptTemplates.searchPlaceholder': 'Tìm template...',
  'promptTemplates.countLabel': '{n} kết quả',
  'promptTemplates.emptyImage': 'Chưa cài template prompt ảnh.',
  'promptTemplates.emptyVideo': 'Chưa cài template prompt video.',
  'promptTemplates.emptyNoMatch': 'Không template nào khớp tìm kiếm.',
  'promptTemplates.attributionFooter': 'Chuyển thể từ các thư viện prompt công khai. Mỗi card có link về tác giả gốc.',
  'promptTemplates.openPreviewTitle': 'Mở prompt và preview',
  'promptTemplates.sourcePrefix': 'Nguồn:',
  'promptTemplates.fetchError': 'Không tải được nội dung template này.',
  'promptTemplates.promptLabel': 'Nội dung prompt',
  'promptTemplates.copyPrompt': 'Copy prompt',
  'promptTemplates.copyDone': 'Đã copy!',
  'promptTemplates.modelHint': 'Model gợi ý: {model}',
  'promptTemplates.openSource': 'Xem bản gốc',
  'promptTemplates.openFullscreen': 'Mở preview toàn màn hình',
  'promptTemplates.closeFullscreen': 'Đóng preview toàn màn hình',
  'promptTemplates.allSources': 'Tất cả nguồn',
  'promptTemplates.sourceFilterAria': 'Lọc theo nguồn',
  'promptTemplates.retry': 'Thử lại',
  'avatar.title': 'Tài khoản & cài đặt',
  'avatar.localCli': 'Local CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Dùng Local CLI',
  'avatar.useApi': 'Dùng API · BYOK',
  'avatar.codeAgent': 'Code agent',
  'avatar.rescan': 'Quét lại PATH',
  'avatar.amrConsole': 'EduDeck',
  'avatar.amrConsoleMeta': 'Số dư & nạp tiền',
  'avatar.settings': 'Settings',
  'avatar.backToProjects': 'Quay lại project',
  'avatar.metaActive': 'active',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'đã chọn',
  'avatar.noAgentSelected': 'chưa chọn agent',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Reasoning',
  'avatar.serviceTierLabel': 'Service tier',
  'avatar.customSuffix': '(tùy chỉnh)',

  'pet.title': 'Pets',
  'pet.subtitle': 'Dùng Show pet để điều khiển companion có xuất hiện trong workspace hay không. Chọn một pet bên dưới.',
  'pet.navTitle': 'Pets',
  'pet.navHint': 'Adopt hoặc tùy chỉnh',
  'pet.tabBuiltIn': 'Built-in',
  'pet.tabBuiltInHint': 'Companion chọn lọc đi kèm EduDeck - chọn một con và adopt.',
  'pet.builtInEmpty': 'Built-in pets hiện không khả dụng. Thử refresh tab Cộng đồng khi daemon online.',
  'pet.tabCustom': 'Tùy chỉnh',
  'pet.tabCustomHint': 'Tự tạo bằng tên, glyph, màu hoặc sprite.',
  'pet.tabCommunity': 'Cộng đồng',
  'pet.tabCommunityHint': 'Pet đã nở từ Codex - nhận một con hoặc tạo con mới.',
  'pet.tabsAria': 'Chọn pet',
  'pet.adopt': 'Adopt',
  'pet.adoptedBadge': 'Đã adopt',
  'pet.adoptCallout': 'Adopt một pet',
  'pet.changePet': 'Đổi pet',
  'pet.wake': 'Hiện pet',
  'pet.tuck': 'Ẩn pet',
  'pet.wakeTitle': 'Hiện pet trong workspace. Nếu chưa chọn, pet built-in đầu tiên sẽ được dùng.',
  'pet.tuckTitle': 'Ẩn pet khỏi workspace.',
  'pet.settingsTitle': 'Mở cài đặt pet',
  'pet.useCustom': 'Dùng pet của tôi',
  'pet.customTitle': 'Tự tạo pet',
  'pet.customHint': 'Chọn tên, glyph và màu nhấn - overlay cập nhật live.',
  'pet.customGreetingPlaceholder': 'Cho pet chào một câu...',
  'pet.fieldName': 'Tên',
  'pet.fieldGlyph': 'Glyph',
  'pet.fieldGlyphHint': 'Một emoji đơn lẻ là tốt nhất (VD: 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Lời chào',
  'pet.fieldAccent': 'Màu nhấn',
  'pet.fieldAccentCustom': 'Màu tùy chỉnh',
  'pet.fieldAccentDefault': 'Màu nhấn mặc định',
  'pet.overlayAria': 'Pet companion',
  'pet.spriteAria': '{name} - kéo để di chuyển, bấm để chat',
  'pet.spriteTitle': 'Chào từ {name}! Bấm để chat.',
  'pet.taskSummarySingle': '{count} task agent đang chạy.',
  'pet.taskSummaryMultiple': '{count} task agent đang chạy trên {projects} project.',
  'pet.taskSummaryRecentSingle': '{count} task agent vừa hoàn tất.',
  'pet.taskSummaryRecentMultiple': '{count} task agent vừa hoàn tất.',
  'pet.taskListAria': 'Task agent đang active',
  'pet.taskOpenProject': 'Mở {project}',
  'pet.taskGroup.running': 'Đang chạy',
  'pet.taskGroup.queued': 'Đang chờ',
  'pet.taskGroup.recent': 'Vừa hoàn tất',
  'pet.idleQuote.leonardo.text': 'Học tập không bao giờ làm trí óc kiệt sức.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Tôi thấy thiên thần trong khối đá cẩm thạch và đục đến khi giải phóng được người.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Có hai công cụ giúp nhà điêu khắc: ánh sáng và bóng tối.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Khi vẽ, người ta không suy nghĩ.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'Mọi tác phẩm, bất kể vẽ gì hay bởi ai, chỉ là chuyện vụn vặt nếu không được tạo ra và vẽ từ đời sống.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Điều chính yếu là được lay động, yêu, hy vọng, run rẩy và sống.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Pets - hiện, ẩn hoặc chọn một pet',
  'pet.composerMenuTitle': 'Pets',
  'pet.composerMenuHint': 'tip: gõ /pet để bật/tắt',
  'pet.composerOpenSettings': 'Quản lý Pets',
  'pet.welcomeTeaserTitle': 'Adopt một pet',
  'pet.welcomeTeaserBody': 'Một companion nhỏ nổi trên màn hình và ở cạnh bạn.',
  'pet.welcomeTeaserCta': 'Chọn một pet',
  'pet.imageUpload': 'Upload sprite',
  'pet.imageReplace': 'Thay sprite',
  'pet.imageRemove': 'Dùng emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF hoặc SVG. Upload sheet? Thả một strip ngang và đặt số frame.',
  'pet.imageHintActive': 'Đang hiển thị sprite của bạn. Đặt frames > 1 để chạy spritesheet ngang.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = tĩnh. > 1 = spritesheet ngang.',
  'pet.fieldFps': 'Tốc độ (fps)',
  'pet.fieldFpsHint': 'Frame chuyển nhanh thế nào.',
  'pet.atlasImport': 'Import Codex sprite',
  'pet.atlasImportTitle': 'Import atlas hatch-pet 8x9 / 192x208 (PNG hoặc WebP).',
  'pet.atlasPickerTitle': 'Chọn hàng animation',
  'pet.atlasPickerHint': 'Codex pets có 9 hàng animation. Mặc định giữ toàn bộ atlas để pet đổi hàng khi hover, kéo và idle. Bạn cũng có thể đóng băng thành một loop.',
  'pet.atlasCancel': 'Bỏ atlas',
  'pet.atlasAdopt': 'Đóng băng hàng này',
  'pet.atlasAdoptFull': 'Dùng toàn bộ atlas (animated)',
  'pet.atlasAdoptFullTitle': 'Giữ mọi hàng để pet phản ứng với hover, hướng kéo và idle lâu.',
  'pet.atlasAdoptRowTitle': 'Cắt riêng hàng đang highlight thành một strip loop.',
  'pet.atlasActiveHint': 'Atlas animated đang active - pet chọn hàng theo interaction của bạn (hover, kéo, idle).',
  'pet.atlasRow.idle': 'Idle',
  'pet.atlasRow.running-right': 'Chạy sang phải',
  'pet.atlasRow.running-left': 'Chạy sang trái',
  'pet.atlasRow.waving': 'Vẫy tay',
  'pet.atlasRow.jumping': 'Nhảy',
  'pet.atlasRow.failed': 'Thất bại',
  'pet.atlasRow.waiting': 'Đang chờ',
  'pet.atlasRow.running': 'Đang chạy',
  'pet.atlasRow.review': 'Review',
  'pet.hatchTitle': 'Hatch pet mới bằng AI',
  'pet.hatchHint': 'Dùng skill hatch-pet đi kèm trong chat để generate spritesheet kiểu Codex, rồi import ở đây.',
  'pet.hatchConcept': 'Ý tưởng pet (tùy chọn)',
  'pet.hatchConceptPlaceholder': 'VD: một shiba pixel-art nhỏ mặc áo len ấm',
  'pet.hatchCopy': 'Copy prompt',
  'pet.hatchCopied': 'Đã copy!',
  'pet.hatchFoot': 'Sau khi skill lưu pet của bạn, quay lại và chọn "Import Codex sprite".',
  'pet.slashPopoverAria': 'Slash commands',
  'pet.slashPopoverTitle': 'Commands',
  'pet.slashPopoverHint': '↑↓ di chuyển · enter để chọn · esc để đóng',
  'pet.slashPet': 'Bật/tắt, adopt hoặc nhảy tới cài đặt pet.',
  'pet.slashPetWake': 'Hiện overlay pet nổi.',
  'pet.slashPetTuck': 'Tạm ẩn pet.',
  'pet.slashHatch': 'Generate Codex pet qua skill hatch-pet.',
  'pet.slashHatchArg': '<ý tưởng>',
  'pet.slashSearch': 'Tìm web qua OD research command.',
  'pet.slashSearchArg': '<truy vấn>',
  'pet.codexTitle': 'Vừa hatch gần đây',
  'pet.codexSubtitle': 'Pet đóng gói bởi skill hatch-pet sẽ xuất hiện ở đây để adopt một click.',
  'pet.codexSubtitleWithDir': 'Đang quét {dir} để tìm pet đóng gói bởi skill hatch-pet.',
  'pet.codexEmpty': 'Chưa có pet đã hatch. Gõ /hatch trong chat để generate.',
  'pet.codexLoading': 'Đang tìm pet đã hatch...',
  'pet.codexRefresh': 'Làm mới',
  'pet.codexAdopt': 'Adopt',
  'pet.codexAdopting': 'Đang adopt...',
  'pet.communitySync': 'Tải pet cộng đồng',
  'pet.communitySyncing': 'Đang tải...',
  'pet.communitySyncTitle': 'Đồng bộ pet mới nhất từ Codex Pet Share + j20 Hatchery vào ~/.codex/pets/.',
  'pet.communitySyncDone': 'Đã đồng bộ {wrote} pet mới ({total} tổng cộng).',
  'pet.communitySyncFailed': 'Đồng bộ thất bại: {error}',
  'pet.codexBundled': 'Bundled',
  'pet.codexBundledTitle': 'Đi kèm EduDeck - không cần download.',
  'critiqueTheater.userFacingName': 'Design Jury',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Critic',
  'critiqueTheater.roleBrand': 'Brand',
  'critiqueTheater.roleA11y': 'Accessibility',
  'critiqueTheater.roleCopy': 'Copy',
  'critiqueTheater.roundLabel': 'Vòng {n} / {m}',
  'critiqueTheater.mustFix': '{n} lỗi phải sửa',
  'critiqueTheater.composite': 'Composite',
  'critiqueTheater.threshold': 'Ngưỡng',
  'critiqueTheater.consensus': 'Đồng thuận',
  'critiqueTheater.interrupt': 'Ngắt',
  'critiqueTheater.interrupting': 'Đang ngắt...',
  'critiqueTheater.interrupted': 'Đã ngắt',
  'critiqueTheater.degradedHeading': 'Panel offline trong lượt này',
  'critiqueTheater.degradedReasonMalformed': 'Output panel sai định dạng (parser từ chối block).',
  'critiqueTheater.degradedReasonOversize': 'Output panel vượt giới hạn byte an toàn.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} không hỗ trợ Critique protocol.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} gửi protocol version không được hỗ trợ.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Run kết thúc mà không có artifact cuối.',
  'critiqueTheater.replay': 'Replay',
  'critiqueTheater.replaySpeed': 'Tốc độ replay',
  'critiqueTheater.readOnly': 'Chỉ đọc',
  'critiqueTheater.shippedSummary': 'Shipped ở vòng {round} · composite {composite}',
  'critiqueTheater.interruptedSummary': 'Bị ngắt ở vòng {round} · composite tốt nhất {composite}',
  'critiqueTheater.shippedBadge': 'Shipped',
  'critiqueTheater.belowThresholdBadge': 'Dưới ngưỡng',
  'critiqueTheater.timedOutBadge': 'Hết thời gian',
  'critiqueTheater.failedHeading': 'Run thất bại',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI thoát non-zero trước khi panel hoàn tất.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Một vòng vượt quá time budget.',
  'critiqueTheater.failedReasonTotalTimeout': 'Toàn bộ run vượt quá time budget.',
  'critiqueTheater.failedReasonOrchestrator': 'Lỗi orchestrator nội bộ.',
  'critiqueTheater.transcriptEmpty': 'Chưa có transcript để replay. Chạy critique để ghi một transcript.',
  'critiqueTheater.transcriptLoading': 'Đang tải transcript...',
  'critiqueTheater.transcriptError': 'Không tải được transcript: {error}',
  'critiqueTheater.replaySpeedPaused': 'Tạm dừng',
  'critiqueTheater.replaySpeedInstant': 'Tức thì',
  'critiqueTheater.replaySpeedLive': 'Live',
  'critiqueTheater.replaySpeedFast': 'Nhanh',
  'critiqueTheater.settingsNav': 'Design Jury',
  'critiqueTheater.settingsNavHint': 'Review thiết kế 5 panel cho các run của bạn',
  'critiqueTheater.settingsEnabledLabel': 'Hiện Design Jury trong agent run',
  'critiqueTheater.settingsEnabledDescription': 'Khi bật, review 5 panel xuất hiện cạnh generation của agent và chấm điểm output trước khi ship. Bạn có thể ngắt bất kỳ lúc nào.',
  'critiqueTheater.settingsEnabledProjectHint': 'Đã lưu cho project này. Run mới trong project này sẽ route qua Design Jury phía server.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Mở một project để lưu phía server. Tạm thời, thay đổi này chỉ là preference trong browser.',
  'sketch.save': 'Lưu sketch',
  'sketch.cancel': 'Hủy',
  'sketch.saving': 'Đang lưu...',
  'sketch.saved': 'Đã lưu',
  'sketch.tooltipMainMenu': 'Menu chính: lưu, export, trợ giúp và cài đặt canvas',
  'sketch.tooltipLock': 'Giữ tool vẽ hiện tại active để dùng lặp lại',
  'sketch.tooltipHand': 'Pan canvas mà không chọn object',
  'sketch.tooltipSelection': 'Chọn, di chuyển, resize hoặc sửa object trên canvas',
  'sketch.tooltipRectangle': 'Vẽ hình chữ nhật hoặc vùng card',
  'sketch.tooltipDiamond': 'Vẽ hình thoi cho quyết định hoặc nhánh',
  'sketch.tooltipEllipse': 'Vẽ hình tròn hoặc ellipse',
  'sketch.tooltipArrow': 'Vẽ connector định hướng hoặc flow arrow',
  'sketch.tooltipLine': 'Vẽ divider thẳng hoặc connector line',
  'sketch.tooltipFreedraw': 'Vẽ nét tự do trên canvas',
  'sketch.tooltipText': 'Thêm text có thể sửa vào canvas',
  'sketch.tooltipImage': 'Chèn ảnh vào canvas',
  'sketch.tooltipEraser': 'Xóa object khỏi canvas',
  'sketch.tooltipFrame': 'Tạo frame để nhóm một vùng canvas',
  'sketch.tooltipEmbeddable': 'Web Embed chỉ hỗ trợ link https:// hoặc http:// hợp lệ',
  'sketch.tooltipLaser': 'Tạm trỏ vào nội dung canvas mà không thay đổi nó',
  'sketch.tooltipMoreTools': 'Mở tool bổ sung như frame, web embed và laser pointer',
  'sketch.tooltipDirty': 'Có thay đổi chưa lưu',
  'sketch.tooltipClean': 'Đã lưu',
  'sketch.toolSelect': 'Chọn (no-op)',
  'sketch.toolPen': 'Bút',
  'sketch.toolText': 'Text',
  'sketch.toolRect': 'Hình chữ nhật',
  'sketch.toolArrow': 'Mũi tên',
  'sketch.toolEraser': 'Tẩy',
  'sketch.color': 'Màu',
  'sketch.strokeSize': 'Độ dày nét',
  'sketch.undo': 'Hoàn tác',
  'sketch.clear': 'Xóa',
  'sketch.close': 'Đóng',
  'sketch.closeConfirm': 'Đóng sketch và bỏ thay đổi chưa lưu?',
  'sketch.textPrompt': 'Text:',
  'sketch.textModalTitle': 'Thêm text',
  'studio.firstArtifactHint.title': 'Thiết kế đầu tiên đã sẵn sàng',
  'studio.firstArtifactHint.body': 'Thử sửa và annotate trực tiếp - export hoặc chia sẻ khi bạn hài lòng.',
  'studio.firstArtifactHint.dismiss': 'Đã hiểu',

  'community.title': 'Mẫu slide',
  'community.searchPlaceholder': 'Tìm mẫu slide, tag, dữ liệu mô tả',
  'community.searchAria': 'Tìm trong mẫu slide',
  'community.filtersAria': 'Bộ lọc mẫu slide',
  'community.closePreview': 'Đóng xem trước',
  'community.typePrototype': 'Bản mẫu',
  'community.typeLiveArtifact': 'Tài liệu tương tác',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Ảnh',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Âm thanh',
  'community.usePrompt': 'Sử dụng',
  'community.metadata': 'Dữ liệu mô tả',
  'community.designTokenCount': 'Mẫu slide · {total}',
  'community.previewFrameTitle': 'Xem trước {title}',
};
